export default {
    brandSeo: {
        pageTitle: '{title} com o Miral AI',
        toolDescription: 'No Miral AI, {description}',
        sectionTitle: '{title} com o Miral AI',
        faqTitle: '{title} no Miral AI',
        toolFreeTrialCta: 'Teste esta ferramenta grátis no Miral AI',
        toolProcessCta: '{action} grátis',
        imageFaqs: [
            { q: 'Posso testar grátis a geração de imagens no Miral?', a: 'Sim. Cadastre-se no Miral AI para receber créditos grátis e testar a geração. Cada resultado ainda usa os créditos exigidos pelo modelo escolhido.' },
            { q: 'Por que criar imagens com o Miral AI?', a: 'O Miral AI reúne modelos de imagem líderes em um só lugar para comparar recursos e continuar criando sem alternar entre plataformas.' }
        ],
        toolFaqs: [
            { q: 'Posso testar grátis esta ferramenta do Miral AI?', a: 'Sim. Entre no Miral AI para iniciar um teste grátis. O acesso depende dos limites da conta e não significa uso gratuito ilimitado.' },
            { q: 'Por que usar ferramentas criativas no Miral AI?', a: 'O Miral AI combina geração de imagens e ferramentas práticas de edição para criar, processar e baixar resultados em um único fluxo.' }
        ]
    },
    common: {
        loading: 'Carregando...',
        error: 'Ocorreu um erro',
        success: 'Sucesso',
        confirm: 'OK',
        prev: 'Anterior',
        next: 'Próximo',
        optional: 'Opcional',
        remove: 'Remover',
        generate: 'Gerar',
        generating: 'Gerando...',
        required: 'Obrigatório',
        generateFailedContactSupport: 'Falha na geração. Por favor, tente novamente ou entre em contato com o suporte!',
        localMediaTransferFailed:
            'Instabilidade na rede interrompeu a transferência ou interação do serviço. Geração interrompida. Por favor, tente novamente ou entre em contato com o suporte.',
        errorDetails: 'Detalhes do erro',
        tryAgainOrContactSupportTail: ' Por favor, tente novamente ou entre em contato com o suporte!',
        errorCategoryImageSizeInvalid: 'O tamanho da imagem não atende aos requisitos. Por favor, envie uma imagem válida',
        errorCategoryOutputEmptyOrSensitive: 'A geração foi bloqueada por regras de segurança ou não produziu resultados. Por favor, ajuste seu prompt/imagem de referência',
        errorCategoryUpstreamBusy: 'O serviço está ocupado no momento',
        errorCategoryAiNetworkError: 'Erro de conexão de rede. Por favor, verifique sua rede e tente novamente',
        errorCategoryAiTimeout: 'Tempo esgotado na requisição de IA. A rede pode estar instável, por favor tente novamente em breve',
        close: 'Fechar',
        leaveConfirmTitle: 'Lembrete Amigável',
        leaveConfirmMessage: 'Sua obra de IA ainda está sendo gerada. Trocar de página não afetará o progresso. Você pode verificar obras em processamento ou concluídas em [Meu - Minhas Obras].\nTem certeza de que deseja sair?',
        leaveConfirmConfirm: 'Sair da Página',
        leaveConfirmCancel: 'Ficar Aqui',
        genDotIdle: 'Nenhuma tarefa de geração',
        genDotActive: 'Geração em andamento, por favor não feche o navegador',
        genRecoveryTimeout: 'Geração expirada ou a página foi fechada',
        genRecoveryInterrupted: 'Geração interrompida por atualização da página'
    },
    api: {
        errors: {
            requestFailed: 'Falha na requisição',
            badRequest: 'Requisição inválida',
            unauthorized: 'Não autorizado, por favor faça login novamente',
            forbidden: 'Acesso negado',
            notFound: 'Recurso não encontrado',
            serverError: 'Erro interno do servidor',
            timeout: 'Tempo esgotado na requisição, por favor tente novamente',
            networkError: 'Erro de rede, por favor verifique sua conexão',
            sessionExpired: 'Sessão expirada, por favor faça login novamente',
            operationFailed: 'Falha na operação!'
        }
    },
    nav: {
        home: 'Início',
        models: 'Modelos de IA',
        pricing: 'Preços',
        faq: 'FAQ',
        login: 'Entrar',
        signup: 'Upgrade',
        register: 'Registrar',
        email: 'E-mail',
        logout: 'Sair',
        help: 'Ajuda',
        profile: 'Perfil',
        myWorks: 'Minhas Obras',
        username: 'Nome de usuário',
        password: 'Senha',
        confirmPassword: 'Confirmar Senha',
        processing: 'Processando...',
        haveAccount: 'Já tem uma conta?',
        noAccount: "Não tem uma conta?",
        orContinueWith: 'Ou continue com',
        loginFailed: 'Falha no login, por favor tente novamente',
        registerFailed: 'Falha no registro, por favor tente novamente',
        fillRequired: 'Por favor, preencha todos os campos obrigatórios',
        passwordMismatch: 'As senhas não coincidem',
        passwordTooShort: 'A senha deve ter pelo menos 6 caracteres',
        googleNotLoaded: 'Serviço de login do Google não carregado, por favor atualize a página',
        googleInitFailed: 'Falha na inicialização do login do Google',
        googleUserInfoFailed: 'Não foi possível obter informações do usuário',
        googleCancelled: 'Login do Google cancelado',
        codeLoginHint: 'Digite seu e-mail, enviaremos um código de verificação',
        verificationCode: 'Código de Verificação',
        sendCode: 'Enviar Código',
        resendCode: 'Reenviar',
        verifyAndLogin: 'Verificar e Entrar',
        enterEmail: 'Por favor, insira seu endereço de e-mail',
        invalidEmail: 'Por favor, insira um endereço de e-mail válido',
        sendCodeFailed: 'Falha ao enviar o código de verificação, por favor tente novamente',
        checkSpamFolder: "Não encontrou o e-mail? Verifique sua pasta de spam/lixo eletrônico",
        enterValidCode: 'Por favor, insira o código de verificação de 6 dígitos',
        verifyCodeFailed: 'Código de verificação inválido ou expirado',
        googleLoginFailed: 'Falha no login do Google, por favor tente novamente',
        registerHint: 'Ao se registrar, você concorda com nossos',
        and: 'e',
        freeCreditsLabel: 'Créditos Gratuitos:',
        freeCreditsDesc: 'Ganhe créditos gratuitos apenas fazendo login — sem necessidade de pagamento!',
        sidebar: {
            navigation: 'Navegação',
            home: 'Início',
            inspiration: 'Inspiração',
            allModels: 'Todos os Modelos de IA',
            videoAI: 'IA de Vídeo',
            videoGenerator: 'Gerador de Vídeo',
            newModels: 'Novos Modelos',
            otherModels: 'Outros Modelos',
            videoEnhance: 'Aprimorar Vídeo',
            musicAI: 'IA Musical',
            musicGenerator: 'Música com IA',
            imageAI: 'IA de Imagem',
            imageGenerator: 'Gerador de Imagem',
            hotModels: 'Modelos Populares',
            hotTools: 'Ferramentas Populares',
            history: 'Histórico',
            upgrade: 'Upgrade'
        }
    },
    footer: {
        brand: 'Miral',
        siteTitle: 'Miral - Plataforma de Criação de Imagem, Vídeo e Música com IA',
        desc: 'Uma plataforma de IA completa para criação de imagens, vídeos e músicas.',
        fluxModels: 'Modelos FLUX',
        aiImages: 'Imagens com IA',
        aiVideos: 'Vídeos com IA',
        aiMusic: 'Música com IA',
        product: 'Produto',
        videoModels: 'Modelos de vídeo IA',
        imageModels: 'Modelos de imagem IA',
        musicModels: 'Modelos de música IA',
        apps: 'Apps',
        company: 'Empresa',
        about: 'Sobre nós',
        contact: 'Contate-nos',
        blog: 'Blog',
        tools: 'Ferramentas',
        resources: 'Recursos',
        allModels: 'Todos os Modelos de IA',
        pricing: 'Preços',
        trustSafety: 'Confiança e Segurança',
        terms: 'Termos de Serviço',
        privacy: 'Política de Privacidade',
        faq: 'FAQ',
        musicGenerator: 'Gerador de Música com IA',
        copyright: '© 2025 Miral. Todos os direitos reservados.',
        langZh: '简体中文',
        langEn: 'English'
    },
    about: {
        tag: 'About Miral',
        title: 'About Us',
        subtitle: 'Create images, videos, and music with leading AI models in one place.',
        paragraphs: ['Miral is an AI creation platform for creators, designers, and businesses. Generate images and videos, compose AI music, and use practical tools such as watermark removal and document cleanup.', 'We continuously integrate leading models and reliable channels so you can go from idea to finished content in the browser.', 'Learn more about our data practices on Trust & Safety, or contact support when you need help.']
    },
    contact: {
        tag: 'Support',
        title: 'Contact Us',
        subtitle: 'We will get back to your questions and feedback as soon as we can.',
        emailLabel: 'Support email',
        hint: 'Email us about billing, credits, or generation issues. We usually reply on business days.',
        cta: 'Send Email'
    },
    models: {
        image: {
            'nano-banana': {name: 'Nano Banana Pro', desc: 'Realismo cinematográfico com pele, textura e detalhes de iluminação naturais'},
            'nano-banana-31': {name: 'Nano Banana 3.1', desc: 'Geração de imagens multi-resolução com modos v2.5 e v3.1'},
            'seedream-4': {name: 'Seedream 4', desc: 'Estilo Artístico'},
            'seedream-5': {name: 'Seedream 5', desc: 'Estilo Artístico'},
            'midjourney': {name: 'Midjourney', desc: 'Estilo Artístico'},
            'gpt-image-1': {name: 'GPT-Image-1', desc: 'Multiuso'},
            'gpt-image-1-5': {name: 'GPT-Image-1-5', desc: 'Multiuso'},
            'flux-pro-1-1-ultra': {name: 'Flux Pro 1.1 Ultra', desc: 'Texto para imagem de alta qualidade'},
            'flux-schnell': {name: 'Flux Schnell', desc: 'Texto para imagem rápido'},
            'flux-kontext': {name: 'Flux Kontext', desc: 'Texto para imagem de alta qualidade e edição'},
            'flux-2': {name: 'FLUX.2', desc: 'Texto para imagem de nova geração'},
            'qwen-image-2-0-pro': {name: 'Qwen Image 2.0 Pro', desc: 'Texto para imagem em alta resolução com detalhes finos'},
            'z-image-turbo': {name: 'Z Image Turbo', desc: 'Geração de texto para imagem em alta resolução'},
            'sd-3-5': {name: 'Stable Diffusion 3.5', desc: 'Geração de texto para imagem com Stable Diffusion 3.5'}
        },
        video: {
            'pollodance': {name: 'Pollo Dance', desc: 'Controle de movimento, referências e estilos cinematográficos'},
            'seegen': {name: 'SeeGen', desc: 'Texto e imagem para vídeo, multi-resolução'},
            'seedance': {name: 'Seedance AI', desc: 'Sincronização Áudio-Visual Nativa'},
            'wan-2-5': {name: 'Wan 2.5', desc: 'Estilo de Animação'},
            'wan-2-6': {name: 'Wan 2.6', desc: 'Qualidade Aprimorada'},
            'veo-3-1': {name: 'Veo 3.1', desc: 'Referência Multi-imagem'},
            'veo-3-1-fast': {name: 'Veo 3.1 Fast', desc: 'Rápido, suporta quadro final'},
            'kling-2-6': {name: 'Kling 2.6', desc: 'Sincronização Labial'},
            'kling-3': {name: 'Kling 3', desc: 'Sincronização Labial'},
            'sora-2': {name: 'Sora 2', desc: '4 s / 8 s / 12 s'},
            'kling-2-5': {name: 'Kling 2.5', desc: 'Padrão'},
            'wan-2-2': {name: 'Wan 2.2', desc: 'Clássico'},
            'vidu-q3-pro': {name: 'Vidu Q3 Pro', desc: 'Texto e imagem para vídeo, multi-resolução'},
            'veo-3-0': {name: 'Veo 3.0', desc: 'Texto/Imagem para Vídeo'},
            'hailuo-2-3': {name: 'Hailuo 2.3', desc: 'Vídeo Criativo'},
            'runway': {name: 'Runway', desc: 'Workbench'},
            'wan-animate': {name: 'Wan Animate', desc: 'Animação de Personagem'}
        }
    },
    tools: {
        page: {
            tag: 'Caixa de Ferramentas IA',
            title: 'Caixa de Ferramentas IA Profissional',
            subtitle: 'Remoção de marca d\'água, restauração de fotos, aumento de resolução HD, aprimoramento de vídeo e mais ferramentas profissionais para todas as suas necessidades de pós-processamento.',
            allTools: 'Todas as Ferramentas'
        },
        detail: {
            useNow: 'Usar Agora',
            clickUpload: 'Clique ou arraste para enviar ',
            support: 'Suporta',
            reupload: 'Enviar novamente',
            scale: 'Escala',
            process: 'Processar',
            processing: 'Processando...',
            before: 'Antes',
            after: 'Depois',
            download: 'Baixar Resultado',
            processNew: 'Processar Novo Arquivo',
            howToUse: 'Como Usar',
            moreTools: 'Mais Ferramentas',
            notFound: 'Ferramenta Não Encontrada',
            backToList: 'Voltar às Ferramentas',
            loginRequired: 'Login Necessário',
            loginRequiredDesc: 'Por favor, faça login para usar esta ferramenta',
            loginNow: 'Fazer login agora',
            demo: 'Demonstração',
            uploadOriginalFailed: 'Falha ao enviar a imagem original, por favor tente novamente'
        },
        steps: {
            upload: {
                title: 'Enviar Arquivo',
                desc: 'Selecione ou arraste e solte o arquivo de imagem ou vídeo que deseja processar.'
            },
            adjust: {
                title: 'Ajustar Configurações',
                desc: 'Configure os parâmetros de processamento, como fator de escala e formato de saída.'
            },
            process: {
                title: 'Processamento com Um Clique',
                desc: 'A IA processa automaticamente, geralmente concluído em segundos ou minutos.'
            },
            download: {title: 'Baixar Resultado', desc: 'Visualize o resultado e baixe a saída em alta qualidade.'}
        },
        fileTypes: {
            image: 'Imagem',
            video: 'Vídeo'
        },
        imageEnhancer: {
            name: 'Aprimorador de Imagem',
            desc: 'Aumente imagens para resolução 4K com detalhes aprimorados.',
            fullDesc: 'Aumente imagens para resolução 4K com detalhes aprimorados. Usa algoritmos avançados de IA para melhorar os detalhes, tornando imagens borradas nítidas e claras.'
        },
        'doc-crop-enhance': {
            name: 'Recorte e Correção de Imagem',
            desc: 'Recorte bordas e corrija distorção de documentos com IA.',
            fullDesc: 'Recorte, correção e aprimoramento de imagens. Remove o fundo das bordas, corrige distorção e aprimora com vários modos, incluindo clarear, nitidez, preto e branco, escala de cinza e remoção de sombras.',
            enhanceMode: 'Modo de Aprimoramento',
            enhanceModes: {
                disabled: 'Desativado',
                brighten: 'Clarear',
                sharpen: 'Aprimorar e Dar Nitidez',
                blackWhite: 'Preto e Branco',
                grayscale: 'Escala de Cinza',
                deshadow: 'Remoção de Sombra',
                bitmap: "Mapa de bits"
            },
            cropImage: 'Recortar Bordas',
            dewarpImage: 'Corrigir Distorção',
            notImageFile: 'Por favor, envie um arquivo de imagem válido',
            fileTooLarge: 'Imagem muito grande, por favor selecione uma imagem com menos de 15MB',
            noImageInResponse: 'Falha no processamento, por favor tente novamente',
            downloadName: 'doc-crop-enhanced.png',
      "featuresKicker": "MELHORIA DE DIGITALIZAÇÃO DE DOCUMENTOS",
      "featuresTitle": "Transforme fotos de documentos em digitalizações limpas e devidamente alinhadas",
      "featuresIntro": "Lide com bordas de documentos, inclinação, perspectiva, páginas curvas, sombras e clareza de texto para necessidades comuns de captura móvel e aprimoramento de digitalização.",
      "features": [
        {
          "title": "Detectar e cortar bordas de documentos automaticamente",
          "desc": "Encontre o limite entre o papel e seu fundo e, em seguida, remova mesas, sombras nas bordas e áreas não relacionadas para obter uma página mais limpa.",
          "cta": "Cortar um documento gratuitamente"
        },
        {
          "title": "Endireite documentos distorcidos e corrija a perspectiva",
          "desc": "Corrija distorções trapezoidais, páginas inclinadas e proporções causadas por fotos telefónicas angulares de contratos, formulários e papéis de teste.",
          "cta": "Corrigir uma foto de documento"
        },
        {
          "title": "Dewarp de páginas curvas e documentos digitalizados",
          "desc": "Corrija a distorção perto de encadernações de livros, papel enrolado e páginas dobradas para facilitar a leitura de livros e fotos de livros.",
          "cta": "Dewarp um documento curvo"
        },
        {
          "title": "Remova sombras de digitalizações de documentos",
          "desc": "Reduza as sombras causadas por telefones, dedos, lombadas de livros e iluminação irregular para obter recibos, planilhas e páginas digitalizadas mais limpas.",
          "cta": "Remover sombras de documentos"
        },
        {
          "title": "Ilumine documentos e torne o texto mais nítido",
          "desc": "Melhore o brilho e as bordas do texto impresso em documentos de baixo contraste para facilitar a leitura, impressão e organização.",
          "cta": "Afiar o texto digitalizado"
        },
        {
          "title": "Crie digitalizações em preto e branco, em escala de cinza ou bitmap",
          "desc": "Converta fotos coloridas de documentos em imagens em preto e branco, em escala de cinza ou com bitmap aprimorado para impressão e arquivamento.",
          "cta": "Aprimorar a imagem de um documento"
        }
      ],
      "useCasesKicker": "CASOS DE USO COMUNS",
      "useCasesTitle": "Quais imagens de documentos podem ser cortadas e aprimoradas?",
      "useCasesIntro": "Projetado para imagens de documentos individuais capturadas por telefone ou scanner com enquadramento irregular, sombras, distorção ou texto pouco claro.",
      "useCases": [
        {
          "title": "Foto do telefone para digitalizar",
          "desc": "Remova os fundos da mesa e corrija os ângulos da câmera para fazer com que as fotos do telefone pareçam mais digitalizadas."
        },
        {
          "title": "Contratos e Formulários",
          "desc": "Corte contratos, aplicações e formulários para restaurar bordas limpas e proporções de páginas."
        },
        {
          "title": "Recibos e faturas",
          "desc": "Reduza as sombras e torne o texto impresso mais nítido para uma visualização e arquivamento mais claros."
        },
        {
          "title": "Páginas curvas do livro",
          "desc": "Curvatura correta perto das encadernações de livros didáticos, livros e apostilas."
        },
        {
          "title": "Papéis de teste e planilhas",
          "desc": "Endireite papéis de teste, remova sombras e aprimore o texto impresso para reutilização ou impressão."
        },
        {
          "title": "Arquivos em preto e branco",
          "desc": "Converta fotos de documentos em estilos de digitalização consistentes em preto e branco ou em escala de cinza."
        }
      ],
      "faqTitle": "Perguntas frequentes sobre corte e correção de documentos AI",
      "faqs": [
        {
          "q": "O que é corte e correção de documentos de IA?",
          "a": "Ele detecta a área do documento, remove o fundo circundante e pode corrigir distorções, distorções de perspectiva ou páginas curvas com base nas suas configurações."
        },
        {
          "q": "Como faço para recortar automaticamente imagens de documentos digitalizados online?",
          "a": "Ative o corte de bordas e carregue a imagem do documento digitalizado. A ferramenta tenta detectar o limite do papel e remover a área fora do documento."
        },
        {
          "q": "Posso enquadrar um documento digitalizado online?",
          "a": "Sim. Use o endireitamento para uma digitalização inclinada e a correção de perspectiva para uma foto angular do telefone. Use a correção de distorções somente quando a própria página estiver curvada."
        },
        {
          "q": "Qual é a diferença entre os modos de sombra e nitidez?",
          "a": "Deshadow melhora a iluminação irregular da página, enquanto a nitidez fortalece o texto e as bordas das linhas. Escolha o modo que corresponde ao problema de origem."
        },
        {
          "q": "Que ferramenta posso usar para aprimorar documentos de teste, contratos e recibos digitalizados?",
          "a": "Use esta ferramenta de corte e aprimoramento de documentos com sombra para iluminação irregular, nitidez para texto fraco e preto e branco ou escala de cinza ao preparar documentos para impressão."
        },
        {
          "q": "Ele pode transformar uma foto de telefone em um documento digitalizado?",
          "a": "O corte, a correção e o aprimoramento podem produzir uma imagem semelhante a uma digitalização, mas a ferramenta não gera PDFs nem extrai texto OCR."
        },
        {
          "q": "Quais formatos de imagem e tamanhos de arquivo são suportados?",
          "a": "Imagens JPG, PNG e WebP são suportadas, com tamanho máximo de arquivo de 15 MB."
        },
        {
          "q": "O processamento altera o conteúdo do documento original?",
          "a": "A ferramenta ajusta enquadramento, geometria, brilho e clareza. Ele não edita texto nem extrai conteúdo do documento."
        }
      ],
      "education": {
        "kicker": "DOCUMENTOS EDUCATIVOS",
        "title": "Transforme testes, trabalhos de casa e fotos de livros didáticos em digitalizações nítidas",
        "intro": "Detecte automaticamente bordas de documentos educacionais e corrija distorções, perspectivas, páginas curvas e sombras para impressão, arquivamento e uso em sala de aula mais limpos.",
        "items": [
          {
            "title": "Fotos de papel de teste de corte",
            "desc": "Detecte as bordas do papel de teste e remova o fundo da mesa para criar uma página limpa e com moldura adequada."
          },
          {
            "title": "Imagens corretas de lição de casa",
            "desc": "Corrija a inclinação e a perspectiva nas fotos do dever de casa para que sejam mais fáceis de revisar, enviar e imprimir."
          },
          {
            "title": "Dewarp páginas de livros didáticos",
            "desc": "Corrija páginas curvas próximas às encadernações de livros e reduza as sombras que dificultam a leitura do conteúdo impresso."
          },
          {
            "title": "Aprimore planilhas de sala de aula",
            "desc": "Ilumine e aprimore planilhas ou materiais de estudo com efeitos de digitalização em preto e branco ou tons de cinza."
          }
        ],
        "relatedTitle": "Precisa remover respostas manuscritas de um teste?",
        "relatedDesc": "Esta ferramenta lida com corte, correção geométrica e aprimoramento de imagem. Use a borracha de escrita manual para remover respostas dos alunos, cálculos ou anotações do professor.",
        "relatedCta": "Abra o apagador de caligrafia"
      }
        },
        'watermark-remover': {
            name: 'Removedor de Marca d\'Água',
            desc: 'Remova marcas d\'água de imagens com um clique usando IA.',
            fullDesc: 'Remoção de marca d\'água com IA preservando a qualidade da imagem. Suporta processamento em lote, detecção automática de marca d\'água e remoção precisa sem danificar a imagem original.',
            audienceLabels: ['Vendedores de e-commerce', 'Equipes de marketing', 'Designers e criadores', 'Lojas de moda e vestuário'],
            audienceCases: [
                { title: 'Prepare visuais de produto 3 vezes mais rápido', desc: 'Antes de criar imagens profissionais para listagens, limpe fotos de produtos, imagens de fornecedores ou rascunhos que você tem autorização para usar. Remova marcas que distraem para destacar o produto.' },
                { title: 'Reduza em 60% a limpeza manual e crie campanhas mais rápido', desc: 'Antes de transformar visuais próprios ou licenciados em anúncios, banners e peças de marca, remova marcas d\'água indesejadas. Materiais limpos avançam mais rápido para campanhas, lançamentos e pôsteres de produtos.' },
                { title: 'Transforme imagens limpas em novos conceitos com mais rapidez', desc: 'Explore novas direções de design a partir de imagens de origem limpas, sem reconstruir tudo do zero. Use rascunhos sem marca d\'água como referência para esboços com IA, arte conceitual ou visuais de pôster.' },
                { title: 'Renove imagens de catálogo sem refazer a sessão de fotos', desc: 'Antes de preparar catálogos, lançamentos sazonais ou imagens para prova virtual com IA, limpe fotos de roupas autorizadas para valorizar o caimento, o tecido e os detalhes do produto.' }
            ],
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            noImageInResponse: 'Nenhuma imagem de resultado foi retornada. Por favor, tente novamente mais tarde.',
            downloadName: 'watermark-removed.png',
      "aiRepair": "Remoção de marca d'água",
      "uploadLabel": "Carregar imagem",
      "uploadHint": "Suporta imagens JPG, PNG ou WebP de até 15 MB.",
      "featuresKicker": "Rápido e preciso",
      "featuresTitle": "Remova diferentes marcas d'água de fotos online",
      "featuresIntro": "Carregue uma imagem JPG, PNG ou WebP e deixe a IA detectar áreas de marca d'água e reconstruir o fundo sem escovar manualmente.",
      "features": [
        {
          "title": "Limpar marcas d'água de imagem inteira",
          "desc": "Remova textos translúcidos repetidos ou marcas d'água de padrão que cobrem toda a imagem para obter um resultado mais limpo.",
          "cta": "Experimente o AI Watermark Remover gratuitamente"
        },
        {
          "title": "Remover carimbos de data e hora e marcas de data",
          "desc": "Limpe datas, carimbos de data e hora e marcas de câmera dos cantos das fotos enquanto reconstrói o plano de fundo por trás delas.",
          "cta": "Apagar marcas d'água de imagens on-line"
        },
        {
          "title": "Apagar logotipos de marcas",
          "desc": "Remova logotipos de marcas, emblemas de canto e marcas promocionais de imagens que você tem permissão para editar.",
          "cta": "Remova marcas d'água de fotos agora"
        },
        {
          "title": "Texto limpo e marcas de rascunho",
          "desc": "Remova sobreposições de texto de visualizações, rascunhos de design e fotos para criar um conteúdo visual mais limpo.",
          "cta": "Experimente o removedor de marca d'água agora"
        }
      ],
      "useCasesKicker": "Casos de uso",
      "useCasesTitle": "O que o removedor de marca d'água de imagem AI pode limpar?",
      "useCases": [
        {
          "title": "Remoção de marca d'água para fotos de produtos",
          "desc": "Limpe textos, logotipos e marcas promocionais de fotos de produtos antes de transmitir seus próprios ativos."
        },
        {
          "title": "Remoção de marca d'água para fotos sociais",
          "desc": "Remova marcas de plataforma ou carimbos de data/hora de suas próprias fotos para obter uma versão de publicação mais limpa."
        },
        {
          "title": "Limpe várias marcas d'água",
          "desc": "Quando uma imagem contém várias marcas d'água, a IA pode detectar e limpar várias áreas cobertas."
        }
      ],
      "howToKicker": "Três passos simples",
      "howToTitle": "Como remover marcas d’água de imagens online gratuitamente",
      "howToIntro": "Nenhuma instalação de software é necessária. Faça upload de uma imagem, execute o removedor de marca d'água AI e baixe o resultado limpo.",
      "howToCta": "Remova marcas d'água online agora",
      "steps": {
        "upload": {
          "title": "Carregar uma imagem com marca d'água",
          "desc": "Escolha uma imagem JPG, PNG ou WebP com menos de 15 MB. Certifique-se de ter o direito de editá-lo e usá-lo."
        },
        "remove": {
          "title": "Remova a marca d'água com IA",
          "desc": "Inicie o processamento e a IA detectará logotipos, texto, carimbos de data/hora ou marcas d’água de imagem completa e reconstruirá o plano de fundo."
        },
        "download": {
          "title": "Visualizar e baixar",
          "desc": "Compare os resultados de antes e depois e baixe a imagem limpa ou carregue outra."
        }
      },
      "faqTitle": "Perguntas frequentes sobre o removedor de marca d'água AI",
      "faqs": [
        {
          "q": "O que é um removedor de marca d'água AI?",
          "a": "Um removedor de marca d'água de IA detecta áreas de marca d'água e reconstrói fundos cobertos usando cores, texturas e conteúdo de imagem próximos."
        },
        {
          "q": "Como remover marcas d'água de fotos online gratuitamente?",
          "a": "Cadastre-se, carregue uma imagem para o removedor de marca d'água Miral AI e comece o processamento para visualizar o resultado limpo."
        },
        {
          "q": "Quais formatos de imagem são suportados?",
          "a": "A ferramenta atualmente oferece suporte a imagens JPG, PNG e WebP com menos de 15 MB. Esta página não remove marcas d'água de vídeos."
        },
        {
          "q": "Ele pode remover marcas d’água, logotipos e carimbos de data/hora de imagem inteira?",
          "a": "Sim. A IA pode processar marcas d'água repetidas de imagem completa, logotipos de marcas, carimbos de data, texto e marcas de rascunho. Os resultados dependem da opacidade, da área coberta e da complexidade do fundo."
        },
        {
          "q": "Que ferramenta posso usar para remover vários logotipos ou carimbos de data/hora de uma foto?",
          "a": "O removedor de marca d'água Miral AI pode processar várias áreas de marca d'água, incluindo logotipos e carimbos de data / hora. Verifique a visualização quando marcas grandes cobrem pessoas ou texturas complexas."
        },
        {
          "q": "Remover uma marca d'água de uma imagem é legal?",
          "a": "Processe apenas imagens que você possui, está autorizado a editar ou pode usar legalmente. A remoção de marcas d'água de direitos autorais sem permissão pode violar os direitos do proprietário."
        },
        {
          "q": "Como corrigir áreas desfocadas após remover uma marca d'água?",
          "a": "Comece com a imagem de origem da mais alta qualidade disponível e verifique a visualização antes de fazer o download. A IA tenta preservar a composição, a resolução e os detalhes originais, mas o conteúdo oculto por grandes marcas d’água deve ser reconstruído, portanto, os resultados locais podem diferir do original."
        }
      ]
        },
        'full-watermark-remover': {
            name: 'Removedor Completo de Marca d\'Água',
            desc: 'Remova marcas d\'água de imagem inteira e restaure uma imagem limpa com IA.',
            fullDesc: 'Remova marcas d\'água densas ou de imagem inteira com IA preservando o conteúdo e a qualidade visual da imagem original.',
            notImageFile: 'Por favor, envie um arquivo de imagem válido.',
            fileTooLarge: 'Imagem muito grande, por favor selecione uma imagem com menos de 15MB.',
            downloadName: 'full-watermark-removed.png'
        },
        'background-remover': {
            name: 'Removedor de Fundo',
            desc: 'Remova fundos de imagens com um clique usando IA.',
            heroTitle: 'Removedor de fundo com IA grátis para PNG transparente',
            fullDesc: 'Envie uma imagem JPG, PNG ou WebP e deixe a IA detectar retratos, produtos e bordas. Preserve cabelo e detalhes finos e baixe um PNG transparente sem Photoshop.',
            uploadLabel: 'Enviar imagem para remover o fundo',
            uploadHint: 'Clique ou arraste uma imagem aqui',
            uploadSpec: 'Aceita JPG, PNG ou WebP até 15MB. O resultado é baixado como PNG transparente.',
            processButton: 'Remover fundo da imagem',
            previewAlt: 'Prévia antes da remoção de fundo com IA',
            demoBeforeAlt: 'Retrato antes da remoção do fundo',
            demoAfterAlt: 'Retrato após a remoção do fundo com IA',
            processingAlt: 'A IA está removendo o fundo da imagem',
            processingLabel: 'Recorte em andamento',
            resultLabel: 'Fundo transparente pronto',
            resultBeforeAlt: 'Imagem original antes de remover o fundo',
            resultAfterAlt: 'PNG transparente após remover o fundo com IA',
            productBeforeAlt: 'Foto de produto antes de remover o fundo',
            productAfterAlt: 'Produto recortado em fundo transparente',
            featuresKicker: 'Detecção precisa do objeto',
            featuresTitle: 'Removedor de fundo com IA para retratos e produtos',
            featuresIntro: 'De bordas complexas em retratos a imagens de ecommerce, a IA separa objeto e fundo sem pincéis, caminhos ou máscaras manuais.',
            features: [
                { title: 'Remova o fundo de retratos preservando o cabelo', desc: 'Detecte pessoas, roupas e fios finos para criar perfis, retratos profissionais, cartazes e artes sociais com recorte limpo.', cta: 'Remover fundo de retrato grátis' },
                { title: 'Recorte fotos de produtos em um clique', desc: 'Remova mesas, paredes e cenários para usar o produto transparente em fundos brancos, lojas e anúncios.', cta: 'Remover fundo de produto' },
                { title: 'Baixe um PNG transparente', desc: 'Mantenha a transparência para usar o objeto em outro fundo, banner, apresentação, miniatura ou design.', cta: 'Deixar o fundo transparente' }
            ],
            featureAlts: { portraitBefore: 'Retrato antes do recorte', portraitAfter: 'Retrato recortado preservando o cabelo', productBefore: 'Produto antes de remover o fundo', productAfter: 'Produto em fundo transparente', ecommerceBefore: 'Imagem ecommerce antes do recorte', ecommerceAfter: 'PNG transparente para ecommerce' },
            useCasesKicker: 'Usos populares',
            useCasesTitle: 'Quais imagens funcionam com recorte de IA?',
            useCasesIntro: 'Use quando precisar isolar um objeto ou criar um recurso transparente para trabalhos criativos e comerciais.',
            useCases: [
                { title: 'Fotos de produtos para ecommerce', desc: 'Prepare produtos transparentes para catálogos, lojas e campanhas.' },
                { title: 'Retratos e fotos de perfil', desc: 'Remova o ambiente preservando cabelo, roupa e contornos.' },
                { title: 'Artes para redes sociais', desc: 'Coloque pessoas ou produtos em capas, posts e miniaturas.' },
                { title: 'Fotos profissionais e documentos', desc: 'Isole a pessoa e adicione depois a cor de fundo necessária.' },
                { title: 'Logos e elementos gráficos', desc: 'Remova um fundo indesejado antes de reutilizar a arte.' },
                { title: 'Publicidade e design gráfico', desc: 'Crie PNGs transparentes sem recortes manuais repetitivos.' }
            ],
            howToKicker: 'Três passos simples',
            howToTitle: 'Como remover o fundo de uma imagem online grátis',
            howToIntro: 'Envie a imagem, execute o recorte automático com IA e baixe o PNG transparente.',
            steps: [
                { title: 'Envie um JPG, PNG ou WebP', desc: 'Escolha um retrato, produto ou design nítido com até 15MB.' },
                { title: 'Remova o fundo com IA', desc: 'A IA separa o objeto preservando as bordas importantes.' },
                { title: 'Visualize e baixe o PNG', desc: 'Compare o resultado e salve a imagem transparente.' }
            ],
            faqTitle: 'Perguntas sobre remoção de fundo com IA',
            faqs: [
                { q: 'Como remover o fundo de uma imagem online grátis?', a: 'Envie um JPG, PNG ou WebP e inicie o processo. A IA detecta o objeto e gera um PNG transparente.' },
                { q: 'A IA preserva cabelo e bordas finas?', a: 'A ferramenta tenta manter cabelo, roupa e pequenos detalhes. Um bom contraste entre objeto e fundo melhora o resultado.' },
                { q: 'Posso remover o fundo de uma foto de produto?', a: 'Sim. Produtos bem visíveis são ideais para criar recursos transparentes de ecommerce e publicidade.' },
                { q: 'Qual formato recebo após o processamento?', a: 'O resultado é baixado como PNG com transparência.' },
                { q: 'Quais formatos e tamanhos são aceitos?', a: 'JPG, PNG e WebP até 15MB são aceitos.' },
                { q: 'Preciso instalar o Photoshop?', a: 'Não. A IA remove o fundo diretamente no navegador.' }
            ],
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            noImageInResponse: 'Nenhuma imagem de resultado foi retornada. Por favor, tente novamente mais tarde.',
            downloadName: 'background-removed.png'
        },
        'image-eraser': {
            name: 'Apagador de Imagem',
            desc: 'Apague qualquer objeto, pessoa ou marca d\'água de imagens com IA.',
            fullDesc: 'Apagador de imagem com IA. Passe o pincel sobre qualquer objeto, pessoa, marca d\'água ou texto indesejado na sua foto e a IA o removerá perfeitamente, preenchendo a área com conteúdo natural. Perfeito para limpar fotos e remover distrações.',
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            noImageInResponse: 'Nenhuma imagem de resultado foi retornada. Por favor, tente novamente mais tarde.',
            downloadName: 'image-erased.png'
        },
        'object-remover': {
            name: 'Remover Objetos',
            desc: 'Remova objetos indesejados das suas fotos com IA.',
            fullDesc: 'Removedor de objetos com IA. Passe o pincel sobre qualquer objeto indesejado na sua foto e a IA o removerá perfeitamente, preenchendo a área com conteúdo natural. Perfeito para limpar fotos e remover distrações.',
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            noImageInResponse: 'Nenhuma imagem de resultado foi retornada. Por favor, tente novamente mais tarde.',
            downloadName: 'object-removed.png',
      "uploadLabel": "Carregar imagem",
      "uploadHint": "Clique ou arraste para fazer upload de uma imagem",
      "uploadSpec": "Suporta imagens JPG, PNG ou WebP.",
      "maskHint": "Pincele cada parte do objeto que você deseja que a IA remova.",
      "processButton": "Remover objeto",
      "demoBeforeAlt": "Foto antes da remoção de objetos indesejados",
      "demoAfterAlt": "Foto após remoção de objeto indesejado",
      "processingAlt": "AI processando a foto marcada",
      "resultBeforeAlt": "Foto original antes da remoção do objeto",
      "resultAfterAlt": "Limpe a foto após a remoção do objeto",
      "featureImageLabels": {
        "object": "exemplo de remoção de objetos indesejados",
        "person": "exemplo de remoção de pessoa",
        "distraction": "exemplo de remoção de distração de fundo"
      },
      "featuresKicker": "Limpeza precisa de fotos",
      "featuresTitle": "Remova objetos indesejados de fotos online",
      "featuresIntro": "Marque a área exata que deseja limpar e use a remoção de objetos por IA para distrações fotográficas diárias sem reconstruir manualmente o fundo.",
      "features": [
        {
          "title": "Remova objetos indesejados",
          "desc": "Use um pincel ajustável para marcar desordem, placas, adereços ou outros objetos. AI remove a área selecionada e a preenche com detalhes da imagem circundante.",
          "cta": "Remover objetos gratuitamente"
        },
        {
          "title": "Remover pessoas dos fundos das fotos",
          "desc": "Limpe fotógrafos, turistas ou transeuntes de fotos e retratos de viagens quando eles desviarem a atenção do assunto principal.",
          "cta": "Fundos de fotos limpos grátis"
        },
        {
          "title": "Apague pequenas distrações de fundo",
          "desc": "Remova fios, lixeiras, desordem nas ruas, marcas ou distrações visuais isoladas para criar uma composição mais limpa.",
          "cta": "Apagar distrações fotográficas gratuitamente"
        }
      ],
      "useCasesKicker": "Casos de uso populares",
      "useCasesTitle": "O que você pode remover com o removedor de objetos AI?",
      "useCasesIntro": "Projetado para edições focadas, onde você pode passar claramente sobre a área indesejada e manter o resto da foto inalterado.",
      "useCases": [
        {
          "title": "Limpeza de fotos de viagens",
          "desc": "Remova transeuntes, placas, lixeiras ou desordem nas ruas das fotos das férias."
        },
        {
          "title": "Limpeza de fotos do produto",
          "desc": "Apague acessórios, etiquetas, cabos e itens que distraem um produto."
        },
        {
          "title": "Limpeza de fundo de retrato",
          "desc": "Remova pessoas do fundo e pequenos objetos que desviem a atenção do assunto."
        },
        {
          "title": "Fotos de imóveis",
          "desc": "Limpe a desordem temporária e os objetos isolados das imagens de quartos ou propriedades."
        },
        {
          "title": "Imagens de mídia social",
          "desc": "Dê polimento às fotos antes de publicá-las, removendo distrações visíveis do porta-retratos."
        },
        {
          "title": "Edição criativa de fotos",
          "desc": "Limpe as áreas selecionadas antes de reutilizar uma imagem em um layout ou projeto visual."
        }
      ],
      "howToKicker": "Três passos simples",
      "howToTitle": "Como remover um objeto de uma foto online",
      "howToIntro": "Faça upload de uma foto, passe sobre o objeto indesejado e baixe o resultado limpo por IA.",
      "steps": [
        {
          "title": "Envie sua foto",
          "desc": "Escolha a imagem que contém a pessoa, item ou distração que você deseja apagar."
        },
        {
          "title": "Pincele sobre o objeto",
          "desc": "Ajuste o pincel e cubra toda a área indesejada. Use desfazer ou borracha para refinar a máscara."
        },
        {
          "title": "Remover e baixar",
          "desc": "Inicie o processamento de IA, compare as imagens antes e depois e baixe a foto limpa."
        }
      ],
      "faqTitle": "Perguntas frequentes sobre remoção de objetos AI",
      "faqs": [
        {
          "q": "Como remover objetos indesejados de fotos online?",
          "a": "Faça upload de uma foto, passe por todo o objeto indesejado e comece o processamento. A IA reconstrói a área selecionada usando cores, texturas e detalhes da cena próximos."
        },
        {
          "q": "Que ferramenta posso usar para remover uma pessoa do fundo de uma foto?",
          "a": "Use o pincel para cobrir a pessoa e incluir detalhes como sombras ou itens carregados. Os resultados geralmente são melhores quando o fundo circundante é visível."
        },
        {
          "q": "A IA pode remover placas, fios, lixeiras e desordem nas ruas?",
          "a": "Sim. Marque claramente a área indesejada e evite cobrir assuntos próximos que você deseja manter. Distrações pequenas e isoladas são geralmente mais fáceis de reconstruir."
        },
        {
          "q": "Como posso obter um resultado de remoção de objetos mais natural?",
          "a": "Use uma imagem de origem nítida e de alta qualidade e passe um pouco além das bordas do objeto. Processe áreas difíceis separadamente quando vários objetos se sobrepõem."
        },
        {
          "q": "O removedor de objetos altera a foto inteira?",
          "a": "A solicitação de remoção é baseada na máscara escovada. A ferramenta concentra-se na área selecionada, embora a IA deva reconstruir pixels em torno de suas bordas."
        },
        {
          "q": "Quais formatos de imagem posso enviar?",
          "a": "O controle de upload aceita formatos de imagem comuns, incluindo JPG, PNG e WebP."
        }
      ]
        },
        'ai-person-remover': {
            name: 'Remover Pessoas com IA',
            desc: 'Remova pessoas das suas fotos com IA.',
            fullDesc: 'Removedor de pessoas com IA. Passe o pincel sobre qualquer pessoa na sua foto e a IA a removerá perfeitamente, preenchendo a área com conteúdo natural. Perfeito para remover transeuntes, turistas ou estranhos das suas fotos.',
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            noImageInResponse: 'Nenhuma imagem de resultado foi retornada. Por favor, tente novamente mais tarde.',
            downloadName: 'person-removed.png'
        },
        'background-blur': {
            name: 'Desfoque de Fundo',
            desc: 'Desfoque o fundo da imagem com IA em um clique para destacar o sujeito',
            fullDesc: 'A IA detecta automaticamente o sujeito em primeiro plano (pessoa/objeto), mantém o sujeito nítido e aplica um desfoque gaussiano ao fundo para um efeito de Modo Retrato. Ideal para retratos e close-ups de produtos.',
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            noImageInResponse: 'Nenhuma imagem de resultado foi retornada. Por favor, tente novamente mais tarde.',
            downloadName: 'background-blur.png'
        },
        'white-background': {
            name: 'Fundo Branco',
            desc: 'Substitua o fundo da imagem por branco usando IA.',
            fullDesc: 'Substituição de fundo branco com IA em um clique. Detecta precisamente o contorno do sujeito, preserva detalhes finos como cabelo, gera imagem com fundo branco limpo. Ideal para fotos de produtos e documentos de identidade.',
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            noImageInResponse: 'Nenhuma imagem de resultado foi retornada. Por favor, tente novamente mais tarde.',
            downloadName: 'white-background.png'
        },
        'blue-background': {
            name: 'Fundo Azul',
            desc: 'Substitua o fundo da imagem por azul usando IA.',
            fullDesc: 'Substituição de fundo azul com IA em um clique. Detecta precisamente o contorno do sujeito, preserva detalhes finos como cabelo, gera imagem com fundo azul limpo. Ideal para fotos de passaporte e documentos de identidade.',
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            noImageInResponse: 'Nenhuma imagem de resultado foi retornada. Por favor, tente novamente mais tarde.',
            downloadName: 'blue-background.png'
        },
        'face-swap': {
            name: 'Troca de rosto em fotos',
            desc: 'Troque rostos em fotos com IA em um clique.',
            fullDesc: 'Troca de rosto com IA. Envie uma foto alvo e uma foto de rosto de origem para mesclar perfeitamente o rosto na imagem alvo. Suporta cenas com múltiplas pessoas com resultados realistas.',
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            targetImage: 'Foto Alvo',
            sourceImage: 'Rosto de Origem',
            downloadName: 'face-swap-result.png',
            step1Title: 'Enviar Fotos',
            step1Desc: 'Envie a foto alvo e a foto de rosto de origem',
            step2Title: 'Troca de Rosto com IA',
            step2Desc: 'Clique em processar, a IA troca o rosto automaticamente',
            step3Title: 'Baixar',
            step3Desc: 'Visualize e baixe o resultado',
      "effectImageLabel": "Resultado",
      "processButton": "Trocar rosto",
      "targetPreviewAlt": "Pré-visualização da foto alvo para troca de rosto AI",
      "sourcePreviewAlt": "Pré-visualização de rosto de origem para troca de rosto de IA",
      "processingAlt": "Visualização do processamento de troca facial de IA",
      "resultBeforeAlt": "Foto desejada antes da troca de rosto",
      "resultAfterAlt": "Foto após troca de rosto AI",
      "featuresKicker": "Substituição natural do rosto",
      "featuresTitle": "Troque rostos entre fotos com IA",
      "featuresIntro": "Use uma foto de destino para a pose e a composição e, em seguida, forneça um rosto de origem claro para uma troca de rosto de foto focada.",
      "features": [
        {
          "title": "Crie uma troca de rosto com aparência natural",
          "desc": "A IA combina a identidade de origem com a foto alvo enquanto segue sua pose, enquadramento, iluminação e estilo visual geral.",
          "cta": "Crie uma troca de rosto de foto gratuitamente"
        },
        {
          "title": "Mantenha a composição da foto alvo",
          "desc": "Use um retrato, selfie, imagem de personagem ou cena criativa como alvo, mantendo seu plano de fundo e composição.",
          "cta": "Experimente a troca de rosto de foto gratuitamente"
        },
        {
          "title": "Use uma face de origem clara",
          "desc": "Carregue uma imagem de origem bem iluminada e frontal com detalhes faciais visíveis para ajudar o modelo a criar uma substituição mais consistente.",
          "cta": "Carregar e trocar gratuitamente"
        }
      ],
      "useCasesKicker": "Ideias criativas para fotos",
      "useCasesTitle": "Usos populares para troca de fotos on-line",
      "useCasesIntro": "Crie edições de fotos divertidas e criativas usando uma imagem de destino e uma imagem de rosto de origem.",
      "useCases": [
        {
          "title": "Trocas de selfies e fotos de perfil",
          "desc": "Substitua um rosto em uma selfie ou retrato preservando a pose, o plano de fundo e o enquadramento alvo. Explore conceitos de fotos de perfil e ideias de retratos pessoais com uma fonte clara.",
          "cta": "Crie uma troca de rosto de retrato gratuitamente",
          "imageAlt": "Exemplo de troca de rosto de IA para selfies e fotos de perfil"
        },
        {
          "title": "Memes e imagens de reação social",
          "desc": "Transforme fotos familiares em memes personalizados, imagens de reação divertidas e conteúdo social compartilhável. Uma expressão clara do alvo ajuda a manter a imagem final fácil de reconhecer.",
          "cta": "Faça uma troca de rosto meme grátis",
          "imageAlt": "Caso de uso de meme criativo e imagem de reação social"
        },
        {
          "title": "Cosplay, personagens e histórias criativas",
          "desc": "Experimente um rosto em uma fantasia, retrato de fantasia, personagem ilustrado ou cena temática. Use a troca de rostos para explorar conceitos de personagens e criar histórias visuais a partir de imagens que você pode editar.",
          "cta": "Experimente uma troca de rosto de personagem gratuitamente",
          "imageAlt": "Caso de uso de cosplay e troca de rosto de personagem"
        }
      ],
      "howToKicker": "Três passos simples",
      "howToTitle": "Como trocar rostos em fotos online com IA",
      "howToIntro": "Escolha uma foto de destino, adicione um rosto de origem claro e deixe a IA gerar o resultado de troca de rosto.",
      "faqTitle": "Perguntas frequentes sobre troca de rosto de foto",
      "faqs": [
        {
          "q": "Como trocar um rosto entre duas fotos online?",
          "a": "Faça upload da foto cuja pose e composição você deseja manter como alvo, depois carregue a identidade que deseja usar como rosto de origem e comece o processamento."
        },
        {
          "q": "Qual é a diferença entre a foto alvo e o rosto de origem?",
          "a": "A foto alvo fornece a pose, o fundo e a composição. A face de origem fornece a identidade facial usada para a substituição."
        },
        {
          "q": "Como escolho uma boa imagem de origem para troca de rosto?",
          "a": "Use uma imagem nítida e bem iluminada com um rosto desobstruído. Um ângulo de origem e uma expressão semelhantes ao alvo podem produzir um resultado mais consistente."
        },
        {
          "q": "Posso usar a troca de rosto com IA para selfies, memes ou fotos de cosplay?",
          "a": "Sim. Esses são usos criativos comuns quando você possui ou tem permissão para editar as imagens enviadas."
        },
        {
          "q": "Por que uma troca de rosto às vezes parece menos realista?",
          "a": "Grandes diferenças no ângulo do rosto, iluminação, expressão, resolução ou oclusão intensa podem dificultar a mesclagem. Experimente fotos de origem mais nítidas e compatíveis."
        },
        {
          "q": "Quais formatos de imagem e tamanhos de arquivo são suportados?",
          "a": "Imagens JPG, PNG e WebP são suportadas, com tamanho máximo de arquivo de 15 MB por imagem."
        },
        {
          "q": "Posso trocar um rosto em um vídeo nesta página?",
          "a": "Não. Esta página processa imagens estáticas e retorna um resultado de imagem."
        }
      ]
        },
        'image-enhancer': {
            name: 'Aprimorador de Imagem',
            desc: 'Aprimore a clareza da imagem com IA em um clique.',
            fullDesc: 'Aumente imagens para resolução 4K com detalhes aprimorados. Usa algoritmos avançados de IA para melhorar os detalhes, tornando imagens borradas nítidas e claras.',
            fileTooLarge: 'A imagem é muito grande. Por favor, use um arquivo com menos de 15MB (JPG, PNG ou WebP).',
            notImageFile: 'Por favor, envie um arquivo de imagem.',
            downloadName: 'image-enhanced.png',
            targetResolution: 'Resolução desejada',
            outputFormat: 'Formato de saída',
            resolutions: {
                '2k': '2K',
                '4k': '4K',
                '8k': '8K'
            },
            formats: {
                JPEG: 'JPEG',
                PNG: 'PNG',
                WEBP: 'WEBP'
            },
            processFailed: 'Falha no processamento. Tente outra imagem ou formato de saída.'
        },
        'video-enhancer': {
            name: 'Aprimorador de Vídeo',
            desc: 'Aprimore a qualidade do vídeo com aumento de resolução por IA.',
            fullDesc: 'Aprimore a qualidade do vídeo para HD/4K com interpolação de quadros e nitidez por IA.',
            notVideoFile: 'Por favor, envie um arquivo de vídeo (ex: MP4, MOV, AVI).',
            fileTooLarge: 'O vídeo é muito grande. Por favor, use um arquivo com menos de 100MB.'
        },
        'cartoon-video-style-converter': {
            name: 'Conversor de estilo cartoon',
            desc: 'Converta vídeos para estilo cartoon',
            fullDesc: 'Envie um vídeo e a IA irá convertê-lo para estilo cartoon preservando o movimento principal, enquadramento e ritmo.',
            notVideoFile: 'Por favor, envie um arquivo de vídeo válido.',
            fileTooLarge: 'O vídeo é muito grande. Selecione um vídeo com menos de 100MB.',
            downloadName: 'cartoon-style-video.mp4'
        },
        'anime-video-style-converter': {
            name: 'Conversor de estilo anime',
            desc: 'Converta vídeos para estilo anime',
            fullDesc: 'Envie um vídeo e a IA irá convertê-lo para estilo anime preservando o movimento do sujeito e o ritmo da cena.',
            notVideoFile: 'Por favor, envie um arquivo de vídeo válido.',
            fileTooLarge: 'O vídeo é muito grande. Selecione um vídeo com menos de 100MB.',
            downloadName: 'anime-style-video.mp4'
        },
        'oil-painting-video-style-converter': {
            name: 'Conversor de estilo pintura a óleo',
            desc: 'Converta vídeos para estilo pintura a óleo',
            fullDesc: 'Envie um vídeo e a IA irá convertê-lo para estilo pintura a óleo com cores ricas e textura pictórica.',
            notVideoFile: 'Por favor, envie um arquivo de vídeo válido.',
            fileTooLarge: 'O vídeo é muito grande. Selecione um vídeo com menos de 100MB.',
            downloadName: 'oil-painting-style-video.mp4'
        },
        'cyberpunk-video-style-converter': {
            name: 'Conversor de estilo cyberpunk',
            desc: 'Converta vídeos para estilo cyberpunk',
            fullDesc: 'Envie um vídeo e a IA irá convertê-lo para um estilo cyberpunk futurista de alto contraste com luzes neon.',
            notVideoFile: 'Por favor, envie um arquivo de vídeo válido.',
            fileTooLarge: 'O vídeo é muito grande. Selecione um vídeo com menos de 100MB.',
            downloadName: 'cyberpunk-style-video.mp4'
        },
        'photo-restore': {
            name: 'Restauração de Fotos',
            desc: 'Restaure fotos antigas, borradas ou danificadas com tecnologia de IA.',
            fullDesc: 'Restaure fotos antigas, borradas ou danificadas com tecnologia de IA. Suporta remoção de ruído, nitidez e preenchimento de partes ausentes para trazer memórias preciosas de volta à vida.',
            notImageFile: 'Por favor, envie um arquivo de imagem válido.',
            fileTooLarge: 'Imagem muito grande, por favor selecione uma imagem com menos de 15MB.',
            downloadName: 'photo-restored.png'
        },
        'blurry-photo-repair': {
            name: 'Corrigir Imagens Borradas',
            desc: 'Repare imagens borradas e recupere detalhes mais nítidos com IA.',
            fullDesc: 'Repare imagens borradas com IA. Aprimore a nitidez, recupere detalhes faciais e de textura, e torne fotos suaves mais nítidas para compartilhamento ou arquivo.',
            notImageFile: 'Por favor, envie um arquivo de imagem válido.',
            fileTooLarge: 'Imagem muito grande, por favor selecione uma imagem com menos de 15MB.',
            downloadName: 'blurry-image-fixed.png'
        },
        'cartoon-digital-human': {
            name: 'Gerador de personagens cartoon com IA',
            desc: 'Transforme um retrato em um avatar digital cartoon no estilo anime.',
            fullDesc: 'Gere um humano digital cartoon no estilo anime a partir de um retrato. Preserve as características reconhecíveis da pessoa enquanto cria um avatar polido com linhas limpas e cores vibrantes.',
            notImageFile: 'Por favor, envie um arquivo de imagem válido.',
            fileTooLarge: 'Imagem muito grande, por favor selecione uma imagem com menos de 15MB.',
            downloadName: 'cartoon-digital-human.png'
        },
        'manga-digital-human': {
            name: 'Gerador de personagens manga com IA',
            desc: 'Transforme um retrato em um avatar digital no estilo manga.',
            fullDesc: 'Gere um humano digital no estilo manga a partir de um retrato. Preserve as características reconhecíveis da pessoa enquanto cria uma aparência de quadrinhos limpa com linhas expressivas e sombreamento polido.',
            notImageFile: 'Por favor, envie um arquivo de imagem válido.',
            fileTooLarge: 'Imagem muito grande, por favor selecione uma imagem com menos de 15MB.',
            downloadName: 'manga-digital-human.png'
        },
        'oil-painting-digital-human': {
            name: 'Gerador de retratos a óleo com IA'
        },
        'ai-change-clothes': {
            name: 'Trocador de roupas com IA'
        },
        'id-photo-generator': {
            name: 'Gerador de Foto de Documento',
            desc: 'Gere uma foto de documento limpa a partir de um retrato com IA.',
            fullDesc: 'Gere uma foto de documento limpa e profissional a partir de um retrato. A IA ajusta o sujeito em uma aparência organizada de foto de documento, adequada para perfil e uso estilo documento de identidade.',
            notImageFile: 'Por favor, envie um arquivo de imagem válido.',
            fileTooLarge: 'Imagem muito grande, por favor selecione uma imagem com menos de 15MB.',
            downloadName: 'id-photo.png'
        },
        'handwritten-erase': {
            name: 'Apagador de Escrita à Mão',
            desc: 'Apague texto escrito à mão de documentos com IA.',
            fullDesc: 'Detecte e apague automaticamente texto escrito à mão de documentos enquanto preserva o conteúdo impresso. Perfeito para provas, anotações, contratos e mais. Suporta recorte, correção de distorção e rotação.',
            docDirection: 'Rotação',
            docDirections: {
                none: 'Sem Rotação',
                rotate90: '90° Sentido Horário',
                rotate180: '180° Sentido Horário',
                rotate270: '270° Sentido Horário',
                auto: 'Detecção Automática'
            },
            crop: 'Recortar Bordas',
            dewarp: 'Corrigir Distorção',
            notImageFile: 'Por favor, envie um arquivo de imagem válido',
            fileTooLarge: 'Imagem muito grande, por favor selecione uma imagem com menos de 15MB',
            noImageInResponse: 'Falha no processamento, por favor tente novamente',
            downloadName: 'handwriting-erased.png',
      "featuresKicker": "Remoção de manuscrito de documento",
      "featuresTitle": "Remova a caligrafia e restaure documentos limpos",
      "featuresIntro": "Limpe respostas manuscritas, revisões de contratos, notas de revisão e marcas de documentos digitalizados, preservando o texto impresso e o layout original.",
      "features": [
        {
          "title": "Remover as respostas dos alunos dos testes",
          "desc": "Detecte automaticamente respostas manuscritas, cálculos e anotações em testes preenchidos.",
          "cta": "Limpe as respostas do papel de teste gratuitamente"
        },
        {
          "title": "Apagar caligrafia de contratos",
          "desc": "Limpe adições manuscritas, círculos, valores alterados, setas e notas de revisão, preservando cláusulas, tabelas e layout impressos.",
          "cta": "Escrita limpa do contrato on-line"
        },
        {
          "title": "Preparar e reimprimir testes para ensino",
          "desc": "Limpe as respostas dos alunos e as anotações dos professores para aulas, preparação para testes e arquivamento de documentos.",
          "cta": "Experimente o limpador de papel de teste do professor"
        },
        {
          "title": "Limpe marcas manuscritas de documentos digitalizados",
          "desc": "Remova marcas, setas, círculos, notas de margem e marcas de revisão de formulários digitalizados, relatórios de inspeção e documentos de escritório.",
          "cta": "Limpar marcas de documentos digitalizados"
        }
      ],
      "useCasesKicker": "Para alunos e professores",
      "useCasesTitle": "Casos de uso educacional para remoção de escrita manual de IA",
      "useCases": [
        {
          "title": "Remoção de resposta de teste",
          "desc": "Apague as respostas e cálculos dos alunos das provas."
        },
        {
          "title": "Revisão de erros",
          "desc": "Restaure os papéis preenchidos para outra rodada de prática."
        },
        {
          "title": "Limpeza da pasta de trabalho",
          "desc": "Remova o conteúdo manuscrito dos trabalhos de casa e das planilhas."
        },
        {
          "title": "Ensino e preparação para testes",
          "desc": "Crie papéis limpos para aulas, reimpressão e arquivamento."
        },
        {
          "title": "Correção de papel digitalizado",
          "desc": "Gire, corte e corrija imagens de documentos distorcidas ou curvas."
        },
        {
          "title": "Limpeza de Contratos e Notas",
          "desc": "Remova caligrafia e anotações de documentos gerais."
        }
      ],
      "howToKicker": "Três passos simples",
      "howToTitle": "Como remover respostas manuscritas de testes online",
      "howToIntro": "Carregue um papel ou documento de teste, defina as opções de rotação, corte e correção de distorções e, em seguida, baixe o resultado limpo.",
      "steps": {
        "upload": {
          "title": "Carregar um papel ou documento de teste",
          "desc": "Carregue um documento de teste JPG, PNG ou WebP, uma folha de lição de casa ou um documento digitalizado com menos de 15 MB."
        },
        "process": {
          "title": "Configurar e remover manuscrito",
          "desc": "Escolha a direção do documento e ative o corte ou a correção da distorção conforme necessário e, em seguida, inicie o processamento."
        },
        "download": {
          "title": "Revise e baixe",
          "desc": "Compare as imagens antes e depois, baixe o documento limpo ou processe outra imagem."
        }
      },
      "faqTitle": "Perguntas frequentes sobre o removedor de respostas de papel de teste AI",
      "faqs": [
        {
          "q": "Que ferramenta posso usar para remover respostas manuscritas das provas?",
          "a": "O removedor de escrita manual Miral AI detecta respostas, cálculos e anotações manuscritas, preservando as perguntas impressas e o layout original sempre que possível."
        },
        {
          "q": "A IA pode remover a escrita manual preservando o texto impresso?",
          "a": "Ele pode restaurar um papel limpo enquanto preserva o texto impresso quando a escrita não se sobrepõe fortemente ao conteúdo impresso."
        },
        {
          "q": "Os professores podem limpar e reimprimir as provas?",
          "a": "Sim. É adequado para preparação de aulas, explicações em sala de aula, criação de testes e arquivamento de documentos."
        },
        {
          "q": "Os alunos podem redefinir os trabalhos respondidos para revisão?",
          "a": "Sim. Os papéis de teste e planilhas limpas podem ser reutilizados para revisão de erros e prática adicional."
        },
        {
          "q": "Como apago notas manuscritas, marcas de caneta e anotações em tinta vermelha?",
          "a": "Carregue a imagem do documento e execute o removedor de manuscrito. Ele pode processar diferentes cores e ferramentas de escrita à mão, embora os resultados dependam da clareza e da sobreposição com o texto impresso."
        },
        {
          "q": "Como faço para corrigir uma digitalização distorcida ou curva antes de remover a escrita à mão?",
          "a": "Primeiro, distorça ou gire uma digitalização inclinada. Use o corte para excesso de fundo e a correção de distorções apenas para páginas genuinamente curvas antes de processar a escrita à mão."
        },
        {
          "q": "Quais formatos de imagem são suportados?",
          "a": "Imagens JPG, PNG e WebP com menos de 15 MB são suportadas. Arquivos PDF não são suportados nesta página."
        }
      ]
        },
        category: {
            image: 'Ferramentas de Imagem',
            video: 'Ferramentas de Vídeo',
            document: 'Ferramentas de Documento'
        },
        categoryModal: {
            title: 'Selecionar Categoria de Ferramenta'
        },
        convert: {
            success: 'Conversão Concluída!',
            zipHint: 'O resultado é empacotado como um arquivo ZIP contendo múltiplas imagens',
            fileTooLarge: 'Arquivo muito grande, por favor selecione um arquivo com menos de 50MB',
            multiImageHint: 'Suporta envio de múltiplas imagens e mesclagem em um único PDF',
            addMore: 'Adicionar mais'
        },
        'pdf-to-word': {
            name: 'PDF para Word',
            desc: 'Converta arquivos PDF em documentos Word editáveis',
            fullDesc: 'Converta inteligentemente arquivos PDF em documentos Word editáveis, preservando com precisão layout, tabelas, imagens e mais. Suporta texto misto em chinês e inglês.'
        },
        'image-to-word': {
            name: 'Imagem para Word',
            desc: 'Converta texto em imagens em documentos Word',
            fullDesc: 'Reconheça inteligentemente texto, tabelas e outros conteúdos em imagens e converta-os em documentos Word, preservando o formato de layout original. Suporta extração de carimbos e reconhecimento de texto manuscrito.'
        },
        'pdf-to-excel': {
            name: 'PDF para Excel',
            desc: 'Converta tabelas PDF em arquivos Excel editáveis',
            fullDesc: 'Reconheça inteligentemente o conteúdo de tabelas em arquivos PDF e converta-os em arquivos Excel editáveis, preservando com precisão a estrutura e os dados da tabela.'
        },
        'pdf-to-ppt': {
            name: 'PDF para PPT',
            desc: 'Converta arquivos PDF em apresentações PPT editáveis',
            fullDesc: 'Converta inteligentemente arquivos PDF em apresentações PPT editáveis, preservando o layout original, imagens e conteúdo de texto.'
        },
        'pdf-to-image': {
            name: 'PDF para Imagem',
            desc: 'Converta cada página PDF em imagens de alta qualidade',
            fullDesc: 'Converta cada página de um arquivo PDF em imagens de alta qualidade. Suporta conversão em lote de PDFs com múltiplas páginas, com resultados empacotados para download em ZIP.'
        },
        'word-to-pdf': {
            name: 'Word para PDF',
            desc: 'Converta documentos Word em arquivos PDF',
            fullDesc: 'Converta rapidamente documentos Word em arquivos PDF, preservando layout, fontes e imagens originais para garantir consistência de formato.'
        },
        'excel-to-pdf': {
            name: 'Excel para PDF',
            desc: 'Converta planilhas Excel em arquivos PDF',
            fullDesc: 'Converta planilhas Excel em arquivos PDF, preservando a estrutura da tabela e o layout de dados para fácil compartilhamento e impressão.'
        },
        'image-to-pdf': {
            name: 'Imagem para PDF',
            desc: 'Mescle múltiplas imagens em um único arquivo PDF',
            fullDesc: 'Mescle múltiplas imagens em um único arquivo PDF. Suporta formatos de imagem comuns como JPG, PNG e BMP para gerenciamento e compartilhamento unificados.'
        },
        'word-to-image': {
            name: 'Word para Imagem',
            desc: 'Converta cada página de documento Word em uma imagem',
            fullDesc: 'Converta cada página de um documento Word em imagens de alta qualidade. Suporta conversão em lote de documentos com múltiplas páginas, com resultados empacotados para download em ZIP.'
        }
    },
    plans: {
        basic: {
            name: 'Basic',
            features: [
                'Todos os créditos entregues de uma vez',
                'Gere até 2.600 imagens com IA',
                'Gere 520 vídeos com IA',
                'Gere até 480 faixas de música com IA',
                'Sem marca d\'água',
                'Licença comercial'
            ]
        },
        pro: {
            name: 'Pro',
            features: [
                'Todos os créditos entregues de uma vez',
                'Gere até 10.600 imagens com IA',
                'Gere até 2.120 vídeos com IA',
                'Gere até 1.920 faixas de música com IA',
                'Todos os modelos premium',
                'Fila prioritária',
                'Suporte prioritário',
                'Modo de privacidade e conformidade com DPA'
            ]
        },
        ultimate: {
            name: 'Ultimate',
            features: [
                'Todos os créditos entregues de uma vez',
                'Gere até 36.600 imagens com IA',
                'Gere até 7.320 vídeos com IA',
                'Gere até 6.720 faixas de música com IA',
                'Todos os modelos premium',
                'Suporte dedicado',
                'Modo de privacidade e conformidade com DPA'
            ]
        }
    },
    faq: {
        categories: {
            all: 'Todos',
            general: 'Geral',
            pricing: 'Preços',
            models: 'Modelos',
            features: 'Recursos'
        },
        items: [
            {
                q: 'O que é o Miral?',
                a: 'Miral é uma plataforma de criação com IA completa que integra mais de 29 modelos de IA de ponta, suportando geração de imagens, criação de vídeos, produção musical e ferramentas de edição profissional. Não é necessário alternar entre plataformas - uma conta dá acesso a todos os principais modelos, incluindo FLUX, Midjourney, Sora, Veo, Kling e mais.'
            },
            {
                q: 'Quais modelos de IA são suportados?',
                a: 'Suportamos mais de 29 modelos de IA de ponta, incluindo modelos de imagem (FLUX 2 Max, Midjourney, Seedream, GPT-Image-1, Nano Banana, etc.), modelos de vídeo (Veo 3.1, Sora 2, Kling 2.6, Seedance, Wan 2.5, etc.) e modelos de geração de música com IA. Todos os modelos são atualizados continuamente.'
            },
            {
                q: 'Como funciona o sistema de créditos?',
                a: 'Usamos um sistema de créditos unificado. A geração de imagens começa em 2 créditos, vídeos em 10 créditos e música em 10 créditos por faixa. Modelos premium podem consumir mais créditos. Assinantes desfrutam de taxas de créditos menores e também podem adquirir pacotes de créditos separadamente.'
            },
            {
                q: 'Posso gerar imagens, vídeos e músicas?',
                a: 'Sim! O Miral suporta texto-para-imagem, edição de imagens, transferência de estilo, texto-para-vídeo, imagem-para-vídeo, criação de música com IA e mais - atendendo todas as necessidades criativas, desde projetos pessoais até trabalhos comerciais.'
            },
            {
                q: 'Quão rápida é a geração?',
                a: 'A maioria das gerações de imagem é concluída em 30 segundos, e a geração de vídeos leva de 1 a 6 minutos. Otimizamos continuamente nossa infraestrutura para garantir uma geração rápida e estável.'
            },
            {
                q: 'Posso usar o Miral para fins comerciais?',
                a: 'Sim. Todos os planos pagos incluem licenças comerciais, permitindo que você use o conteúdo gerado para projetos comerciais, materiais de marketing, redes sociais e mais.'
            },
            {
                q: 'O acesso à API está disponível?',
                a: 'Sim, o plano Ultimate inclui acesso à API. Através de nossa API abrangente, você pode integrar a geração de imagens, vídeos e músicas com IA diretamente em seus aplicativos.'
            },
            {
                q: 'Posso gerar música com IA?',
                a: 'Com certeza! Nosso gerador de música com IA suporta vários estilos musicais. Basta descrever o que deseja para gerar música original, perfeita para trilhas sonoras de vídeos, música de fundo para podcasts e mais.'
            },
            {
                q: 'Como vocês lidam com a privacidade e segurança dos dados?',
                a: 'Seguimos rigorosamente os padrões de conformidade com o GDPR. Todos os dados são criptografados e não são usados para treinamento de IA. Os usuários podem excluir suas contas e todos os dados a qualquer momento.'
            },
            {
                q: 'Outras pessoas podem ver meu trabalho?',
                a: 'Por padrão, seu trabalho é visível apenas para você. Usuários Pro e Ultimate podem ativar o modo de privacidade para garantir privacidade completa.'
            },
            {
                q: 'Como posso excluir minha conta e dados?',
                a: 'Você pode solicitar a exclusão da conta nas configurações da sua conta a qualquer momento. Excluiremos todos os seus dados e conteúdo gerado em até 30 dias.'
            },
            {
                q: 'Posso obter suporte se encontrar problemas?',
                a: 'Claro! Você pode entrar em contato com nossa equipe de suporte em miral_support@miralvis.com. Usuários Pro recebem suporte prioritário e usuários Ultimate recebem suporte dedicado.'
            }
        ]
    },
    testimonials: {
        items: [
            {
                name: 'Alex Chen',
                role: 'Diretor de Marketing Digital',
                tag: 'Economize 90% do Tempo',
                content: 'Miral se tornou nosso hub de conteúdo visual. Gere imagens de produtos com Midjourney, crie vídeos promocionais com Veo e edite tudo no Miral - sem trocar de plataforma.'
            },
            {
                name: 'Sarah Rodriguez',
                role: 'Proprietária de E-commerce',
                tag: 'Conversão 40% Maior',
                content: 'Acessar mais de 29 modelos em um só lugar é incrível. Uso Seedream para fotos de produtos, Seedance para anúncios em vídeo e ferramentas de aumento de resolução para catálogos. A conversão aumentou 40%!'
            },
            {
                name: 'David Kim',
                role: 'Criador de Conteúdo',
                tag: 'Mais de 500K Seguidores',
                content: 'Crio imagens com FLUX e Nano Banana, depois as transformo em vídeos virais com Kling e Sora. O sistema de créditos é justo - pague pelo que usar. Meus seguidores adoram o conteúdo diversificado!'
            },
            {
                name: 'Emma Thompson',
                role: 'Designer Gráfica',
                tag: 'Nível Profissional',
                content: 'Como designer, eu era cética sobre plataformas de IA. Mas a rica biblioteca de modelos e as ferramentas de edição precisas do Miral são realmente impressionantes - de esboços conceituais a produtos finais, tudo é fácil.'
            },
            {
                name: 'James Wilson',
                role: 'Produtor de Vídeo',
                tag: 'Fluxo de Trabalho 10x Mais Rápido',
                content: 'Os modelos de vídeo aqui são incríveis - o Veo é cinematográfico, o Seedance é rápido e a animação de personagens do Wan é natural. Todos os modelos compartilham um sistema de créditos - economiza tempo e dinheiro.'
            },
            {
                name: 'Lisa Park',
                role: 'Proprietária de Agência Criativa',
                tag: 'Escolha da Equipe',
                content: 'Toda a nossa equipe mudou para o Miral. A integração da API é tranquila e a variedade de modelos significa que sempre encontramos a ferramenta certa. Esta é a melhor plataforma de IA disponível.'
            }
        ]
    },
    langModal: {
        title: 'Selecionar Idioma'
    },
    home: {
        searchModel: 'Buscar modelo...',
        newModels: 'Novos Modelos',
        otherModels: 'Outros Modelos',
        selectModel: 'Selecionar Modelo',
        promptPlaceholderImage: 'Descreva a imagem que deseja criar...',
        promptPlaceholderVideo: 'Descreva o vídeo que deseja criar...',
        generate: 'Gerar',
        chatDisabledGenerateHint: 'Por favor, insira um prompt',
        compactChatPlaceholder: 'Digite seu prompt para gerar imagens e vídeos incríveis com IA e músicas originais',
        hero: {
            title: 'Miral – Criador completo de imagens, vídeos e músicas com IA',
            subtitle: 'Com modelos de IA versáteis, o Miral reúne edição de imagens, geração de vídeos e criação de música com IA. Edite fotos, produza vídeos de retratos cinematográficos e crie músicas de fundo personalizadas para projetos pessoais e comerciais.',
            createVideo: 'Criar Vídeo',
            createImage: 'Criar Imagem'
        },
        stats: {
            models: 'Principais Modelos de IA',
            works: 'Obras Geradas',
            tools: 'Ferramentas Profissionais',
            platforms: 'Plataformas Parceiras'
        },
        generatorNew: {
            promptPlaceholder: 'Descreva o vídeo que deseja gerar...',
            promptPlaceholderImage: 'Descreva a imagem que deseja gerar...',
            generating: 'Gerando...',
            noHistory: 'Os resultados aparecerão aqui após a geração',
            generationFailed: 'Falha na geração',
            historyTitle: 'Histórico',
            myAssets: 'Meus Ativos'
        },
        quickTools: {
            title: 'Ferramentas rápidas de IA'
        },
        exploreMore: {
            title: 'Explorar mais recursos de IA'
        },
        musicPresets: [
            { label: 'Hino Pop Animado', value: 'Upbeat Pop Anthem' },
            { label: 'Beat Lo-fi Relaxante', value: 'Chill Lo-fi Beat' },
            { label: 'Trilha Épica Cinematográfica', value: 'Cinematic Epic Score' },
            { label: 'Canção Folk Acústica', value: 'Acoustic Folk Song' },
            { label: 'Faixa Dance Eletrônica', value: 'Electronic Dance Track' },
            { label: 'Vibe Jazz Lounge', value: 'Jazz Lounge Vibe' },
            { label: 'Rock Power Ballad', value: 'Rock Power Ballad' },
            { label: 'Meditação Ambiente', value: 'Ambient Meditation' }
        ],
        musicPresetsPlaceholder: 'Selecione uma predefinição de música',
        platform: {
            tag: 'Plataforma',
            title: 'Caixa de Ferramentas IA que Simplifica a Criação',
            subtitle: 'Geração de imagens, criação de vídeos, produção musical e ferramentas profissionais tudo em um, com modelos de IA líderes do setor.',
            tabs: {
                image: 'Imagens IA',
                video: 'Vídeos IA',
                music: 'Música IA',
                tools: 'Caixa de Ferramentas IA'
            },
            image: {
                title: 'Gere e Edite Imagens Incríveis com os Melhores Modelos de IA Globais',
                desc: 'Texto para imagem, edição precisa, transferência de estilo e aumento de resolução HD. Com FLUX, Midjourney, Seedream, GPT-Image-1 e Nano Banana.',
                explore: 'Explorar Modelos de Imagem →'
            },
            video: {
                title: 'Crie Vídeos Cinematográficos com IA',
                desc: 'De texto para vídeo a animação de imagens, com Veo, Sora, Kling, Seedance e modelos Wan. Gere vídeos com áudio sincronizado e câmera profissional.',
                explore: 'Explorar Modelos de Vídeo →'
            },
            music: {
                title: 'Criação de Música Original com IA',
                desc: 'Gere músicas originais a partir de descrições, suportando vários estilos e durações. Perfeito para trilhas sonoras de vídeos, música de fundo para podcasts e mais.',
                explore: 'Explorar Música IA →'
            },
            tools: {
                title: 'Caixa de Ferramentas IA Profissional',
                desc: 'Remoção de marca d\'água, restauração de fotos, aumento de resolução HD, aprimoramento de vídeo e mais ferramentas profissionais para todas as suas necessidades de pós-processamento.',
                explore: 'Ver Todas as Ferramentas →'
            }
        },
        models: {
            tag: 'Modelos',
            title: 'Integração Completa dos Principais Modelos de IA Globais',
            subtitle: 'Uma plataforma integrando todos os modelos de IA mainstream. Chega de alternar entre múltiplas contas e assinaturas.',
            imageModels: 'Modelos de Imagem',
            videoModels: 'Modelos de Vídeo',
            musicModels: 'Música IA',
            musicDesc: 'Gere músicas originais a partir de descrições',
            filterAll: 'Todos',
            credits: 'Créditos',
            viewAll: 'Ver Tudo →'
        },
        features: {
            tag: 'Recursos Principais',
            title: 'Crie Imagens, Vídeos e Músicas Incríveis',
            subtitle: 'De texto para imagem, texto para vídeo até criação de música com IA, além de edição precisa e aumento de resolução HD — criação completa em um só lugar.',
            items: {
                textToImage: {
                    tag: 'Texto para Imagem',
                    title: 'Texto para Imagem',
                    desc: 'Insira uma descrição e veja a magia. Seja retratos hiper-realistas ou paisagens fantásticas, use Midjourney, Seedream, Nano Banana e outros modelos para gerar obras-primas visuais com prompts simples.',
                    cta: 'Geração de Imagens',
                    imageAlt: 'Gere obras-primas visuais com prompts simples usando Midjourney, Seedream, Nano Banana e outros modelos'
                },
                imageEdit: {
                    tag: 'Edição de Imagem e Transferência de Estilo',
                    title: 'Edição de Imagem e Transferência de Estilo',
                    desc: 'Use IA para remodelar imagens com precisão. Seja mudando estilos, modificando objetos, substituindo fundos ou editando texto, tudo com alta consistência.',
                    cta: 'Edição de Imagens',
                    beforeAlt: 'Antes da edição de imagem e transferência de estilo',
                    afterAlt: 'Depois da edição de imagem e transferência de estilo'
                },
                textToVideo: {
                    tag: 'Texto para Vídeo',
                    title: 'Texto para Vídeo',
                    desc: 'Basta inserir prompts para gerar vídeos cinematográficos com áudio sincronizado, câmera profissional e movimento realista. Escolha entre modelos Veo, Sora, Kling, Seedance e Wan.',
                    cta: 'Geração de Vídeos'
                },
                imageToVideo: {
                    tag: 'Imagem para Vídeo',
                    title: 'Imagem para Vídeo',
                    desc: 'Transforme imagens estáticas em vídeos cinematográficos. Seja fotos de produtos, ilustrações ou imagens geradas por IA, dê vida a elas com movimento natural e narração.',
                    cta: 'Animação de Imagens'
                },
                upscale: {
                    tag: 'Aumento de Resolução HD',
                    title: 'Aumento de Resolução HD',
                    desc: 'Use IA para melhorar a qualidade de imagens e vídeos. Suporte a aumento de resolução HD sem perdas e aprimoramento de resolução de vídeo para nível profissional 4K.',
                    cta: 'Aumentar Resolução',
                    imageAlt: 'Use IA para melhorar a qualidade de imagens e vídeos'
                },
                templates: {
                    tag: '40+ Modelos de Imagem',
                    title: '40+ Modelos de Imagem',
                    desc: 'Modelos variados para inspirar: modelos 3D, estilo Ghibli, toys de designer, gerador de memes, capas de revista e mais — envie uma foto, resultados instantâneos.',
                    cta: 'Navegar pelos Modelos',
                    imageAlt: 'Exemplo de modelo de imagem'
                }
            }
        },
        gallery: {
            tag: 'Galeria',
            title: 'Explore Possibilidades Infinitas',
            subtitle: 'Veja o que criadores estão construindo com o Miral — de imagens hiper-realistas a vídeos cinematográficos, inspiração ao seu alcance.',
            images: {
                alt1: 'Exemplo de Imagem Gerada pelo Midjourney',
                alt2: 'Exemplo de Imagem Gerada pelo Seedream',
                alt3: 'Exemplo de Imagem Gerada pelo GPT-Image-1',
                alt4: 'Exemplo de Imagem Gerada pelo Flux',
                alt5: 'Exemplo de Imagem Gerada pelo Flux Pro',
                alt6: 'Exemplo de Imagem Gerada pelo Midjourney',
                alt7: 'Exemplo de Imagem Gerada pelo Seedream',
                alt8: 'Exemplo de Imagem Gerada pelo GPT-Image-1'
            }
        },
        whyChoose: {
            tag: 'Por Que Escolher o Miral',
            title: 'Criação Completa, Tudo o Que Você Precisa',
            subtitle: 'Plataforma completa reunindo os melhores modelos de IA do mundo para criação de imagens, vídeos e músicas.',
            items: {
                allModels: {
                    title: 'Todos os Modelos Integrados, Um Bastat',
                    desc: 'Acesso completo a mais de 29 modelos de IA premium de OpenAI, Google, Alibaba, ByteDance e mais. Sem necessidade de alternar entre ferramentas ou gerenciar múltiplas assinaturas.'
                },
                fast: {
                    title: 'Ultra Rápido',
                    desc: 'A maioria das gerações de imagem é concluída em 30 segundos, vídeos levam cerca de 1-6 minutos. Infraestrutura otimizada garante sem longas esperas.'
                },
                credits: {
                    title: 'Sistema de Créditos Simples',
                    desc: 'Pague pelo uso, preços transparentes. Comece com créditos gratuitos — sem necessidade de assinatura para começar a criar.'
                },
                api: {
                    title: 'API para Desenvolvedores',
                    desc: 'Integre geração de imagens, vídeos e músicas por IA diretamente em suas aplicações através de nossa API abrangente. Construa seu produto sobre os melhores modelos de IA.'
                }
            }
        },
        testimonials: {
            tag: 'Histórias de Usuários',
            title: 'Confiado por Criadores do Mundo Todo',
            subtitle: 'Junte-se a milhares de profissionais e criadores usando o Miral para gerar imagens, criar vídeos e impulsionar seus fluxos de trabalho criativos.'
        },
        faq: {
            tag: 'Suporte',
            title: 'Perguntas Frequentes',
            subtitle: 'Um guia completo sobre a plataforma, modelos suportados, planos de preços e recursos.'
        },
        cta: {
            title: 'Comece Sua Jornada de Criação com IA Agora',
            subtitle: 'Junte-se a milhares de criadores, designers e empresas usando o Miral para realizar sua criatividade com os melhores modelos de IA do mundo.',
            createImage: 'Criar Imagem →',
            createVideo: 'Criar Vídeo →',
            note: 'Novos usuários recebem créditos gratuitos ao se registrar. Não é necessário cartão de crédito.'
        },
        apps: {
            title: "Aplicativos",
            quickTitle: "Apps rápidas de IA",
        more: "Mais",
        keywords: {
            viralVideo: "Vídeo viral",
            tiktokAds: "Anúncios TikTok",
            productShowcase: "Showcase de produto",
            aiAvatar: "Avatar de IA",
            homeModernKitchen: "Cozinha moderna"
        },
            social: 'Redes Sociais',
            posters: 'Cartazes',
            interior: 'Casa',
            entertainment: 'Entretenimento',
            lifestyle: 'Estilo de Vida',
            comic: 'Quadrinhos',
            items: {
                viralVideo: 'Vídeo Viral',
                celebrityVideo: 'Vídeo de Celebridade',
                productShowcase: 'Vitrine de Produto',
                tiktokAds: 'Anúncios TikTok',
                aiMeme: 'Meme IA',
                aiAvatar: 'Avatar IA',
                logoAnimation: 'Animação de Logo',
                socialShorts: 'Shorts Sociais',
                brandStory: 'História de Marca',
                tutorialClip: 'Clipe Tutorial',
                musicVideo: 'Videoclipe IA',
                animeScene: 'Cena de Anime',
                movieTrailer: 'Trailer de Filme',
                gameCinematic: 'Cinematic de Jogo',
                visualPoetry: 'Poesia Visual',
                natureDoc: 'Documentário Natureza',
                cyberpunkCity: 'Cidade Cyberpunk',
                underwaterWorld: 'Mundo Submarino',
                timelapseArt: 'Arte Timelapse',
                dailyVlog: 'Vlog Diário',
                cookingShow: 'Programa de Culinária',
                fitnessCoach: 'Personal Fitness',
                travelDiary: 'Diário de Viagem',
                fashionShow: 'Desfile de Moda',
                petParadise: 'Paraíso Pet',
                weddingMoment: 'Momento de Casamento',
                yogaFlow: 'Fluxo de Yoga',
                homeDecor: 'Decoração de Casa',
                sunsetRun: 'Corrida ao Pôr do Sol',
                instagramReels: 'Instagram Reels',
                youtubeIntro: 'Intro YouTube',
                linkedinPromo: 'Promo LinkedIn',
                aiThumbnail: 'Thumbnail IA',
                podcastClip: 'Clipe de Podcast',
                horrorShort: 'Curta de Terror',
                danceVideo: 'Vídeo de Dança',
                aiComic: 'Quadrinhos IA',
                magicShow: 'Show de Magica',
                fantasyWorld: 'Mundo Fantasia',
                diyCraft: 'Artesanato DIY',
                morningRoutine: 'Rotina Matinal',
                babyGrowth: 'Crescimento do Bebê',
                streetFood: 'Comida de Rua',
                bookTrailer: 'Trailer de Livro',
                socialLuxuryBag: 'Lançamento de Bolsa de Luxo',
                socialFashionVote: 'Votação de Moda',
                socialSneakerDrop: 'Tênis Urbano Premium',
                socialTropicalCocktail: 'Coquetel de Fim de Semana',
                socialCityBillboard: 'Anúncio em Painel Urbano',
                socialStreetwearDrop: 'Lançamento Streetwear',
                socialBoxingGloves: 'Anúncio de Luvas de Boxe',
                homeEclecticLiving: 'Sala de Estar Eclética',
                homeFarmhouseKitchen: 'Cozinha Rústica',
                homeModernKitchen: 'Cozinha Moderna Minimalista',
                homeVictorianStairs: 'Escada Vitoriana',
                homeScandiLiving: 'Sala de Estar Escandinava',
                homeMediterraneanPatio: 'Pátio Mediterrâneo',
                homeBohoSunroom: 'Sunroom Boêmio',
                homeEclecticBedroom: 'Quarto Eclético',
                comicPortrait: 'Quadrinhos de Super-Herói',
                animeCharacter: 'Anime Mecha',
                mangaScene: 'Manga Noite Chuvosa',
                comicOilPainting: 'Quadrinhos do Dia a Dia',
                comicCover: 'Quadrinhos Herói de Energia',
                animePortrait: 'Quadrinhos Salto entre Telhados',
                comicCouple: 'Quadrinhos Jovem Herói',
                mangaWarrior: 'Quadrinhos Feiticeiro'
            }
        }
    },
    musicTags: {
        pop: 'Pop',
        electronic: 'Eletrônica',
        classical: 'Clássica',
        jazz: 'Jazz'
    },
    music: {
        breadcrumb: {
            home: 'Início',
            aiMusic: 'Música IA'
        },
        model: {
            label: 'Modelo',
            aiMusicName: 'Música IA',
            desc: 'Gere músicas originais a partir de descrições, suportando vários estilos e durações.',
            tagMusic: 'Geração de Música',
            tagLyrics: 'Criação de Letras'
        },
        mode: {
            describe: 'Descrever',
            lyrics: 'Escrever Letras'
        },
        form: {
            musicDesc: 'Descrição da Música',
            musicDescPlaceholder: 'Descreva o estilo, emoção e cena da música que deseja...\n\nExemplo: Uma música eletrônica animada com melodias synth futuristas, adequada para vídeos promocionais de produtos de tecnologia',
            optimize: 'Otimizar',
            songTitle: 'Título da Música',
            songTitlePlaceholder: 'Digite o título da música...',
            lyricsDescLabel: 'Descrição da Letra',
            lyricsDescPlaceholder: 'Escreva sua descrição de letra aqui...\n\nExemplo:\n[Intro]\n...\n[Verso]\n...\n[Refrão]\n...',
            styleTags: 'Tags de Estilo',
            styleTagsPlaceholder: 'Clique nas tags abaixo para adicionar (multi-seleção)'
        },
        tags: {
            sections: [
                {label: 'Verso', value: '[Verse]\n'},
                {label: 'Refrão', value: '[Chorus]\n'},
                {label: 'Ponte', value: '[Bridge]\n'},
                {label: 'Intro', value: '[Intro]\n'},
                {label: 'Outro', value: '[Outro]\n'}
            ],
            styles: [
                {label: 'Pop', value: 'Pop'},
                {label: 'Rock', value: 'Rock'},
                {label: 'Jazz', value: 'Jazz'},
                {label: 'Clássica', value: 'Classical'},
                {label: 'Eletrônica', value: 'Electronic'},
                {label: 'R&B', value: 'R&B'},
                {label: 'Hip-Hop', value: 'Hip-Hop'},
                {label: 'Country', value: 'Country'},
                {label: 'Folk', value: 'Folk'},
                {label: 'Ambiente', value: 'Ambient'},
                {label: 'Cinematográfica', value: 'Cinematic'},
                {label: 'Lo-fi', value: 'Lo-fi'},
                {label: 'Metal', value: 'Metal'},
                {label: 'Reggae', value: 'Reggae'},
                {label: 'Blues', value: 'Blues'},
                {label: 'Soul', value: 'Soul'},
                {label: 'Funk', value: 'Funk'},
                {label: 'Indie', value: 'Indie'}
            ]
        },
        options: {
            duration: 'Duração',
            instrumental: 'Instrumental',
            instrumentalDescOn: 'Gerar apenas acompanhamento, sem vocais',
            instrumentalDescOff: 'Incluir performance vocal'
        },
        errors: {
            titleRequired: 'O título da música é obrigatório',
            lyricsDescRequired: 'A descrição da letra é obrigatória'
        },
        footer: {
            creditsRequired: 'Créditos Necessários:',
            creditsLeft: 'Restantes:',
            generate: 'Gerar Música'
        },
        preview: {
            generating: 'Gerando música...',
            generatedTitle: 'Música Gerada',
            emptyTitle: 'Gerador de Música IA',
            emptySubtitle: 'Crie músicas originais com IA. Descreva o estilo ou insira letras e gere sua própria música em segundos.',
            emptyTags: ['Pop', 'Jazz', 'Cinematográfica', 'Lo-fi', 'Rock'],
            track: 'Faixa',
            play: 'Reproduzir',
            pause: 'Pausar',
            mute: 'Silenciar',
            unmute: 'Ativar Som',
            download: 'Baixar',
            showLyrics: 'Mostrar letras',
            hideLyrics: 'Ocultar letras',
            generateFailed: 'Falha na geração',
            requestFailed: 'Falha na requisição, por favor tente novamente',
            downloadMp3: 'Baixar MP3',
            downloadWav: 'Baixar WAV',
            regenerate: 'Regenerar',
            noHistory: 'Sem histórico ainda'
        },
        intro: {
            title: 'Gerador de Música IA',
            desc: 'Usando tecnologia avançada de IA, basta inserir uma descrição ou letras para gerar músicas originais de alta qualidade. Suporta múltiplos estilos musicais, ideal para trilhas sonoras de vídeos, anúncios, podcasts e mais.',
            tagMusic: 'Geração de Música',
            tagLyrics: 'Criação de Letras',
            tagStyles: 'Múltiplos Estilos',
            tagCommercial: 'Licença Comercial'
        },
        features: {
            badge: 'Recursos Principais',
            title: 'O que o Gerador de Música IA pode fazer por você?',
            items: {
                styles: {
                    icon: '🎵',
                    title: 'Múltiplos Estilos',
                    desc: 'Suporta Pop, Rock, Eletrônica, Jazz, Clássica, Hip-Hop e dezenas de estilos musicais para atender diversas necessidades criativas.'
                },
                lyrics: {
                    icon: '📝',
                    title: 'Criação de Letras',
                    desc: 'Insira letras para gerar músicas completas com marcadores de seção (Verso, Refrão, etc.), a IA automaticamente arranja e produz a música.'
                },
                vocals: {
                    icon: '🎤',
                    title: 'Síntese Vocal',
                    desc: 'Suporta vocais masculinos e femininos com vários timbres, a IA canta suas letras com resultados naturais e suaves.'
                },
                instrumental: {
                    icon: '🎹',
                    title: 'Modo Instrumental',
                    desc: 'Gere acompanhamento instrumental de alta qualidade, adequado para trilhas sonoras de vídeos, música de fundo para podcasts e mais.'
                },
                fast: {
                    icon: '⚡',
                    title: 'Geração Rápida',
                    desc: 'Modelos avançados de IA garantem produção musical rápida, a maioria das músicas pode ser gerada em 30 segundos.'
                },
                commercial: {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todas as músicas geradas podem ser usadas para fins comerciais, incluindo vídeos, anúncios, podcasts e mais.'
                }
            }
        },
        faq: {
            title: 'Perguntas Frequentes',
            items: {
                howItWorks: {
                    q: 'Como funciona o Gerador de Música IA?',
                    a: 'Nosso Gerador de Música IA usa modelos avançados de aprendizado profundo para criar músicas originais baseadas em suas descrições de texto ou letras. Basta inserir o estilo, emoção e descrição da cena, e a IA automaticamente comporá uma peça musical completa.'
                },
                commercial: {
                    q: 'As músicas geradas podem ser usadas para fins comerciais?',
                    a: 'Sim, todas as músicas geradas usando nossa plataforma podem ser usadas para fins comerciais, incluindo vídeos do YouTube, anúncios, podcasts, jogos e mais.'
                },
                styles: {
                    q: 'Quais estilos musicais são suportados?',
                    a: 'Suportamos Pop, Rock, Eletrônica, Jazz, Clássica, Hip-Hop, R&B, Country, Metal, Folk e dezenas de outros estilos. Você também pode misturar múltiplos estilos para criar músicas únicas.'
                },
                credits: {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Dependendo do modelo selecionado, cada geração custa de 8 a 10 créditos. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                download: {
                    q: 'Posso baixar as músicas geradas?',
                    a: 'Sim, as músicas geradas suportam download nos formatos MP3 e WAV. Você pode escolher o formato adequado conforme suas necessidades.'
                }
            }
        },
        demoTracks: {
            summerBreeze: {title: 'Brisa de Verão', style: 'Pop / Animada', duration: '2:00'},
            spaceJourney: {title: 'Jornada Espacial', style: 'Eletrônica / Futurista', duration: '1:30'},
            rainWalk: {title: 'Caminhando na Chuva', style: 'Jazz / Descontraído', duration: '2:30'},
            mountainDawn: {title: 'Amanhecer na Montanha', style: 'Clássica / Serena', duration: '3:00'}
        }
    },
    pricing: {
        title: 'Inspiração Ilimitada, Escolha o Plano Ideal para Você',
        subtitle: 'Desbloqueie todos os modelos de IA, gere imagens, vídeos e músicas em lote.',
        promo: 'Oferta por Tempo Limitado — Economize 30% nos Planos Anuais',
        monthly: 'Mensal',
        yearly: 'Anual',
        yearlyNote: 'Plano anual — créditos entregues de uma vez, pagamento único mais econômico',
        popular: 'Mais Popular',
        currentPlan: 'Plano Atual',
        currentPlanBtn: 'Plano Atual',
        upgrade: 'Atualizar',
        unavailable: 'Indisponível',
        upgradeSuccess: 'Atualização realizada com sucesso!',
        upgradeFailed: 'Falha na atualização',
        upgradeModal: {
            title: 'Confirmar atualização',
            item1: 'Cobraremos a diferença de preço no seu cartão.',
            item2: 'Após o pagamento ser confirmado, o saldo extra será adicionado automaticamente.',
            item3: 'O novo plano entra em vigor após a confirmação do pagamento.',
            tip: 'Dica: Certifique-se de que sua forma de pagamento é válida. O saldo é atualizado em segundos após o pagamento.',
            cancel: 'Cancelar',
            confirm: 'Confirmar atualização'
        },
        subscribe: 'Assine Agora',
        processing: 'Processando...',
        creditsPer: 'créditos /',
        extraCredits: 'créditos extras',
        creditsRate: '100 créditos = $',
        perMonth: 'mês',
        perYear: 'ano',
        yearlyBilling: 'Cobrança anual',
        saveVsMonthly: 'Economia vs mensal:',
        planDesc: {
            basic: 'Perfeito para começar',
            pro: 'Ideal para criadores e profissionais',
            ultimate: 'Para equipes e usuários avançados'
        },
        creditsPack: {
            title: 'Comprar Pacote de Créditos',
            subtitle: 'Compra única, sem assinatura',
            buy: 'Comprar Créditos',
            oneTime: 'Compra única',
            permanent: 'Os créditos nunca expiram',
            tip: 'Dica: As assinaturas oferecem melhor custo-benefício',
            tipItems: ['Taxas de créditos menores (economize 40-60%)', '15% de desconto em todos os pacotes de créditos']
        },
        security: {
            noTraining: 'Não utilizado para treinamento de IA',
            encrypted: 'Armazenamento criptografado',
            gdpr: 'Conformidade com LGPD/GDPR',
            delete: 'Exclusão de conta por conta própria'
        },
        dataSafety: 'Saiba mais sobre nosso compromisso com a segurança de dados →',
        allPlansInclude: 'Todos os Planos Incluem',
        includes: {
            models: 'Modelos de IA Premium',
            fast: 'Geração Rápida',
            privacy: '100% Privacidade',
            commercial: 'Uso Comercial'
        },
        creditsInfo: {
            title: 'Guia de Créditos',
            subtitle: 'Veja o consumo de créditos de todos os modelos',
            model: 'Modelo',
            type: 'Tipo',
            cost: 'Custo em Créditos',
            speed: 'Velocidade',
            image: 'Imagem',
            video: 'Vídeo'
        },
        questions: 'Dúvidas?',
        contact: 'Precisa de ajuda?',
        contactUs: 'Fale Conosco',
        faq: {
            items: [
                {
                    q: 'O que posso criar com os créditos?',
                    a: 'Os créditos podem ser usados para gerar imagens, vídeos e músicas com IA. A geração de imagens começa em 2 créditos, vídeos em 10 créditos e músicas em 10 créditos por faixa. Modelos premium podem consumir mais créditos.'
                },
                {
                    q: 'Posso cancelar a qualquer momento?',
                    a: 'Sim, você pode cancelar sua assinatura a qualquer momento. Você pode continuar usando o serviço até o final do período de cobrança atual.'
                },
                {
                    q: 'E se os meus créditos acabarem?',
                    a: 'Você pode comprar pacotes de créditos avulsos a qualquer momento (sem necessidade de assinatura). Assinantes recebem 15% de desconto nos pacotes de créditos. Você também pode atualizar seu plano para melhores taxas nas cotas mensais.'
                },
                {
                    q: 'Existe política de reembolso?',
                    a: 'Sim. Para primeiras compras de pacotes avulsos ou primeiras assinaturas, você pode solicitar reembolso em até 7 dias corridos se o uso de créditos for inferior a 3%.'
                }
            ]
        }
    },
    modelDetail: {
        breadcrumb: {
            home: 'Início',
            models: 'Modelos'
        },
        model: 'Modelo',
        modelVersion: 'Versão do Modelo',
        standard: 'Padrão',
        pro: 'Pro',
        standardDesc: 'Qualidade padrão, geração rápida',
        proDesc: 'Alta qualidade, suporta alta resolução',
        credits: 'créditos',
        imagePrompt: 'Prompt de Imagem',
        imagePromptPlaceholder: 'Descreva a imagem que deseja gerar...',
        videoPrompt: 'Prompt de Vídeo',
        videoPromptPlaceholder: 'Descreva o vídeo que deseja gerar...',
        referenceImage: 'Imagem de Referência',
        aspectRatio: 'Proporção de Tela',
        thinkingLevel: 'Nível de Raciocínio',
        thinkingMinimal: 'Baixa latência',
        thinkingHigh: 'Alta fidelidade',
        referenceImageFormats: 'PNG, JPG, JPEG, WEBP',
        uploadImageHint: 'PNG, JPG, JPEG, WEBP',
        nanoBanana2EmptyPreview: 'Pré-visualização da saída de imagem oficial do Nano Banana 2',
        characters: 'caracteres',
        imageSize: 'Tamanho da Imagem',
        auto: 'Automático',
        resolution: 'Resolução',
        duration: 'Duração',
        seconds: 'segundos',
        creditsRequired: 'Créditos Necessários:',
        creditsRemaining: 'Restantes:',
        remaining: 'Restantes:',
        generate: 'Gerar',
        getMoreCredits: 'Obter mais créditos',
        generating: 'Gerando...',
        demoPrompt: 'Prompt de Demonstração',
        modelLabel: 'Modelo:',
        version: 'Versão:',
        size: 'Tamanho:',
        download: 'Baixar',
        regenerate: 'Regenerar',
        noHistory: 'Sem histórico de geração',
        features: {
            badge: 'Recursos Principais',
            title: 'O que este modelo pode fazer?',
            items: {
                realistic: {
                    icon: '📷',
                    title: 'Realismo Cinematográfico',
                    desc: 'Crie imagens realistas de alta fidelidade com tons de pele naturais, texturas de materiais ricas e iluminação cinematográfica convincente.'
                },
                artistic: {
                    icon: '🎨',
                    title: 'Estilo Artístico',
                    desc: 'Crie imagens artísticas com diversos estilos de pintura.'
                },
                portrait: {
                    icon: '👤',
                    title: 'Retrato',
                    desc: 'Fotografia de retrato profissional com tons de pele naturais.'
                },
                landscape: {icon: '🏔️', title: 'Paisagem', desc: 'Fotografia deslumbrante de paisagens e natureza.'},
                product: {icon: '📦', title: 'Produto', desc: 'Fotografia de produtos de alta qualidade para e-commerce.'},
                fast: {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens é gerada em 10 a 30 segundos.'},
                highRes: {icon: '🖼️', title: 'Alta Resolução', desc: 'Suporta saída com resolução de até 4K.'},
                cinematic: {
                    icon: '🎬',
                    title: 'Cinematográfico',
                    desc: 'Crie vídeos cinematográficos com trabalho de câmera profissional.'
                },
                audioSync: {icon: '🔊', title: 'Sincronização de Áudio', desc: 'Sincronização nativa de áudio e vídeo.'},
                lipSync: {icon: '👄', title: 'Lip Sync', desc: 'Sincronização labial precisa para vídeos de personagens.'},
                animation: {icon: '🎭', title: 'Animação', desc: 'Animação e movimento suave de personagens.'},
                longVideo: {icon: '⏱️', title: 'Vídeo Longo', desc: 'Suporte para durações de vídeo mais longas.'},
                privacy: {
                    icon: '🔒',
                    title: 'Privacidade e segurança',
                    desc: 'Todos os dados são criptografados em trânsito e não são usados para treinamento de IA. Suas criações pertencem a você.'
                }
            }
        },
        whyChoose: {
            items: [
                'Criação inteligente com {name}',
                'Complete tarefas criativas complexas de forma rápida e eficiente',
                'O conteúdo gerado pode ser usado comercialmente',
                'Atualizações contínuas e capacidades em constante melhoria',
                'Sistema unificado de créditos, pague pelo uso'
            ]
        },
        faq: {
            title: 'Perguntas Frequentes',
            imageType: 'imagens',
            videoType: 'vídeos',
            imageFormats: 'Os formatos de saída PNG, JPEG e WebP são suportados; escolha o que melhor se adapta ao seu fluxo de trabalho.',
            videoFormats: 'Os vídeos são entregues em MP4 com opções de 480p e 720p e múltiplas proporções de tela.',
            items: [
                {
                    q: 'Como o {name} funciona?',
                    a: 'Envie uma referência ou insira um prompt de texto — o {name} gera {type} de alta qualidade com base na sua entrada. O processo é simples e não requer habilidades especializadas.'
                },
                {
                    q: 'Posso usar os {type} gerados comercialmente?',
                    a: 'Sim. O conteúdo do {name} pode ser usado comercialmente, incluindo marketing, redes sociais e uso de produtos.'
                },
                {
                    q: 'Quantos créditos por geração?',
                    a: 'Cada geração com {name} utiliza {credits} créditos. Assinantes obtêm melhores taxas de créditos.'
                },
                {
                    q: 'Quão rápida é a geração?',
                    a: 'A velocidade típica do {name} é {speed}. Continuamos otimizando para resultados rápidos e confiáveis.'
                },
                {q: 'Quais formatos de saída são suportados?', a: ''}
            ]
        },
        qwenImage20Pro: {
            negativePromptLabel: 'Prompt negativo (opcional)',
            negativePromptPlaceholder: 'Descreva o que você não quer que apareça (ex: baixa clareza, mãos deformadas, etc.)',
            customWidth: 'Largura',
            customHeight: 'Altura',
            sizeHint: 'Intervalo: 512×512 a 2048×2048',
            sizeErrorRequired: 'Por favor, insira largura e altura',
            sizeErrorInteger: 'Largura e altura devem ser números inteiros',
            sizeErrorRange: 'A resolução deve estar entre 512×512 e 2048×2048',
            promptEnhanceTitle: 'Aprimoramento de Prompt',
            promptEnhanceDesc: 'Aprimore os detalhes do prompt para resultados mais ricos',
            watermarkTitle: 'Marca d\'água',
            watermarkDesc: 'Adicionar marca d\'água às imagens geradas',
            demoPromptText: 'Entre montanhas nevadas, um menino com equipamento de esqui e óculos de proteção desliza alegremente em seus esquis; cristais de neve flutuam ao longo de seu trajeto, com intermináveis cordilheiras cobertas de neve ao fundo.',
            faqSizeSupportQ: 'Quais tamanhos são suportados?',
            faqSizeSupportA: 'Insira largura e altura dentro de 512~2048 (ex: 2048*2048).',
            faqMaxCountQ: 'Quantas imagens podem ser geradas no máximo?',
            faqMaxCountA: 'Até 4 imagens (n=1..4).',
            faqLinkUsageQ: 'Como uso os links das imagens após a geração?',
            faqLinkUsageA: 'Primeiro é feito o download da URL temporária retornada pelo DashScope, depois o upload para nosso servidor, retornando uma URL de acesso duradoura.'
        },
        zImageTurbo: {
            promptExtendTitle: 'Aprimoramento de Prompt',
            promptExtendDesc: 'Aprimore os detalhes do prompt para resultados mais ricos',
            customWidth: 'Largura',
            customHeight: 'Altura',
            sizeHint: 'Intervalo: 512×512 a 2048×2048',
            sizeErrorRequired: 'Por favor, insira largura e altura',
            sizeErrorInteger: 'Largura e altura devem ser números inteiros',
            sizeErrorRange: 'A resolução deve estar entre 512×512 e 2048×2048',
            seedLabel: 'Seed',
            seedErrorRequired: 'Por favor, insira uma seed',
            seedErrorInteger: 'A seed deve ser um número inteiro',
            seedErrorRange: 'A seed deve estar entre 0 e 2147483647',
            tagQuality: 'Alta qualidade',
            tagOfficial: 'Direto oficial',
            tagHighRes: 'Alta resolução',
            tagSeed: 'Controle de seed',
            tagPromptExtend: 'Aprimoramento de Prompt',
            feature1Title: 'Saída de alta qualidade',
            feature1Desc: 'Gere imagens em alta resolução e faça upload para URLs de acesso duradouro.',
            feature2Title: 'Resolução personalizada',
            feature2Desc: 'Insira largura e altura dentro de 512–2048.',
            feature3Title: 'Geração controlável',
            feature3Desc: 'Suporta seed e aprimoramento de prompt para reprodutibilidade e ajustes.',
            demoPromptText: 'Em areia dourada fina, uma trilha clara de pegadas conduz mais fundo no enquadramento; as bordas mostram areia úmida e granulada, a superfície cintila ao sol, atraindo o olhar para um farol distante.',
            faqSizeSupportQ: 'Quais tamanhos são suportados?',
            faqSizeSupportA: 'Insira largura e altura dentro de 512–2048 (ex: 1024*1536).',
            faqSeedQ: 'Para que serve a seed?',
            faqSeedA: 'Com o mesmo prompt e parâmetros, uma seed ajuda a reproduzir resultados semelhantes.',
            faqPromptExtendQ: 'O que é Aprimoramento de Prompt?',
            faqPromptExtendA: 'Quando ativado, aprimora os detalhes do prompt para resultados mais ricos.'
        }
    },
    modelIntro: {
        common: {
            videoMode: 'Modo de Vídeo',
            textToVideo: 'Texto para Vídeo',
            imageToVideo: 'Imagem para Vídeo',
            referenceImage: 'Imagem de Referência',
            referenceAudio: 'Áudio de Referência',
            negativePrompt: 'Prompt Negativo',
            duration: 'Duração',
            resolution: 'Resolução',
            aspectRatio: 'Proporção de Tela',
            seed: 'Seed',
            generateAudio: 'Gerar Áudio',
            watermark: 'Adicionar Marca d\'água',
            endFrame: 'Quadro Final',
            promptEnhance: 'Aprimorar Prompt',
            promptExtend: 'Estender Prompt',
            imageSize: 'Tamanho da Imagem',
            imageCount: 'Quantidade de Imagens',
            style: 'Estilo',
            sizeMode: 'Modo de Tamanho',
            width: 'Largura',
            height: 'Altura',
            optional: 'Opcional',
            uploading: 'Enviando...',
            clickToUpload: 'Clique para Enviar',
            quality: 'Qualidade',
            qualityAuto: 'Automático',
            qualityLow: 'Baixa',
            qualityMedium: 'Média',
            qualityHigh: 'Alta',
            multipleOf64Hint: 'Largura e altura devem ser múltiplos de 64.'
        },
        seegen: {
            aspectAdaptive: 'Automático',
            genMode: 'Modo de geração',
            modeStand: 'Padrão',
            modeSpeed: 'Rápido'
        },
        pollodance: {
            variantLabel: 'Variante do modelo',
            card20: '2.0',
            card20Fast: '2.0 FAST',
            card20Ref: '2.0 REF',
            card20FastRef: '2.0 FAST REF',
            opt20Desc: 'Controle avançado de movimento, transferência de estilo cinematográfica e geração de nível industrial.',
            opt20FastDesc: 'Geração em alta velocidade com baixa latência.',
            opt20RefDesc: 'Controle forte de referência: transferência de estilo e rastreamento de objeto.',
            opt20FastRefDesc: 'Geração rápida com controle preciso de referência.',
            refImages: 'Imagens de referência',
            refVideo: 'Vídeo de referência',
            refAudio: 'Áudio de referência',
            webSearch: 'Busca na web'
        },
        nanoBanana: {
            version: 'Versão do Modelo',
            title: 'Gerador de Imagens IA Nano Banana Pro',
            desc: 'Nano Banana é um modelo de geração de imagens por IA de alto desempenho que suporta geração de imagens em estilo realista, destacando-se em retratos e cenas naturais. Disponível nas versões Padrão e Pro para atender diferentes necessidades.',
            v25Type: 'Baixa Latência',
            v25TypeBadge: 'Rápido',
            v25TypeDesc: 'Resolução fixa de 1024px, velocidade de geração rápida',
            v31Type: 'Alta Fidelidade',
            v31TypeBadge: 'Qualidade',
            v31TypeDesc: 'Suporta múltiplas resoluções 1K / 2K / 4K',
            demoPrompt: 'Um retrato cinematográfico de uma mulher na luz dourada do pôr do sol, com textura natural de pele e fundo suave com efeito bokeh',
            multiSize: 'Múltiplos Tamanhos',
            multiSizeDesc: 'Suporta automático, 1:1, 4:3, 3:4, 16:9, 9:16, 3:2, 2:3 e outros tamanhos de imagem.',
            featuresDesc: 'Nano Banana oferece recursos de geração de imagens de alta qualidade com múltiplas opções de tamanho e resolução.',
            flexiblePricing: 'Preços Flexíveis',
            flexiblePricingDesc: 'Padrão 5 créditos, Pro 20 créditos, escolha conforme necessário.',
            commercial: 'Licença Comercial',
            commercialDesc: 'Todas as imagens geradas podem ser usadas para fins comerciais.',
            enterPrompt: 'Por favor, insira um prompt',
            generateFailed: 'Falha na geração',
            requestFailed: 'Falha na requisição, por favor tente novamente',
            faq: [
                {
                    q: 'Qual a diferença entre as versões Padrão e Pro?',
                    a: 'A versão Padrão é adequada para geração rápida de imagens de qualidade padrão, consumindo 5 créditos. A versão Pro suporta resoluções mais altas (1K/2K/4K) com melhor qualidade de imagem, consumindo 20 créditos.'
                },
                {
                    q: 'Como o Nano Banana funciona?',
                    a: 'Basta inserir uma descrição de texto e o modelo Nano Banana gerará imagens realistas de alta qualidade com base no seu prompt.'
                },
                {
                    q: 'Quais tamanhos de imagem são suportados?',
                    a: 'Suporta automático, 1:1 (quadrado), 4:3, 3:4, 16:9 (paisagem), 9:16 (retrato), 3:2, 2:3 e outros tamanhos.'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Nano Banana pode ser usado para fins comerciais.'
                }
            ]
        },
        nanoBanana2: {
            genType: 'Versão de Geração'
        },
        seedream: {
            title: 'Gerador de Imagens IA Seedream 4',
            desc: 'Seedream 4 é um modelo avançado de geração de imagens por IA especializado em imagens artísticas e criativas. Perfeito para ilustrações, concept art e visuais estilizados.',
            webSearch: 'Busca na Web',
            webSearchDesc: 'Ativar busca na web para informações de referência mais precisas',
            watermark: 'Adicionar marca d\'água',
            watermarkDesc: 'Adicionar marca d\'água às imagens geradas',
            sizeModeResolution: 'Por resolução',
            sizeModeCustom: 'Tamanho personalizado',
            customWidth: 'Largura',
            customHeight: 'Altura',
            sizeHint: 'Área 1024×1024–4096×4096, proporção de tela 1/16–16',
            sizeErrorArea: 'A área deve estar entre 1024×1024 e 4096×4096',
            sizeErrorRatio: 'A proporção de tela deve estar entre 1/16 e 16',
            demoPromptExample: 'Luz lateral da tarde ilumina a barraca de acampamento, com a textura áspera da lona da barraca claramente visível. Um Pastor Alemão descansa dentro; seu dono se agacha para apertar sua pata.',
            features: [
                {
                    icon: '🎨',
                    title: 'Estilo Artístico',
                    desc: 'Gere imagens artísticas impressionantes com vários estilos de pintura e ilustração.'
                },
                {icon: '🖼️', title: 'Alta Resolução', desc: 'Suporte até resolução 4K para obras detalhadas.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens geradas em 15 segundos.'},
                {icon: '🎭', title: 'Transferência de Estilo', desc: 'Aplique vários estilos artísticos às suas criações.'},
                {icon: '📐', title: 'Múltiplos Tamanhos', desc: 'Suporte a várias proporções para diferentes necessidades.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todas as imagens geradas podem ser usadas para fins comerciais.'
                }
            ],
            faq: [
                {
                    a: 'Seedream 4 é excelente na geração de imagens artísticas e criativas, incluindo ilustrações, concept art e visuais estilizados.'
                },
                {
                    a: 'Usar Seedream 4 custa 8 créditos por geração. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                {
                    q: 'Quais estilos são suportados?',
                    a: 'Seedream 4 suporta vários estilos artísticos incluindo pintura a óleo, aquarela, arte digital, anime e mais.'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Seedream 4 pode ser usado para fins comerciais.'
                }
            ]
        },
        seedream5: {
            title: 'Gerador de Imagens IA Seedream 5',
            desc: 'Seedream 5 é um modelo avançado de geração de imagens por IA especializado em imagens artísticas e criativas. Perfeito para ilustrações, concept art e visuais estilizados.',
            webSearch: 'Busca na Web',
            webSearchDesc: 'Ativar busca na web para informações de referência mais precisas',
            watermark: 'Adicionar marca d\'água',
            watermarkDesc: 'Adicionar marca d\'água às imagens geradas',
            sizeModeResolution: 'Por resolução',
            sizeModeCustom: 'Tamanho personalizado',
            customWidth: 'Largura',
            customHeight: 'Altura',
            sizeHint: 'Área 2560×1440–3072×3072, proporção de tela 1/16–16',
            sizeErrorArea: 'A área deve estar entre 2560×1440 e 3072×3072',
            sizeErrorRatio: 'A proporção de tela deve estar entre 1/16 e 16',
            demoPromptExample: 'Luz lateral da tarde ilumina a barraca de acampamento, com a textura áspera da lona da barraca claramente visível. Um Pastor Alemão descansa dentro; seu dono se agacha para apertar sua pata.',
            features: [
                {
                    icon: '🎨',
                    title: 'Estilo Artístico',
                    desc: 'Gere imagens artísticas impressionantes com vários estilos de pintura e ilustração.'
                },
                {icon: '🖼️', title: 'Alta Resolução', desc: 'Suporte a saída 2K e 3K com detalhes ricos.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens geradas em 15 segundos.'},
                {icon: '🎭', title: 'Transferência de Estilo', desc: 'Aplique vários estilos artísticos às suas criações.'},
                {icon: '📐', title: 'Tamanhos Flexíveis', desc: 'Suporta resoluções predefinidas e tamanhos personalizados.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todas as imagens geradas podem ser usadas para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Para que o Seedream 5 é melhor?',
                    a: 'Seedream 5 é excelente na geração de imagens artísticas e criativas, incluindo ilustrações, concept art e visuais estilizados.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Usar Seedream 5 custa 10 créditos por geração. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                {
                    q: 'Quais resoluções são suportadas?',
                    a: 'Suporta predefinições 2K e 3K, além de tamanhos personalizados dentro dos intervalos permitidos de área e proporção de tela.'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Seedream 5 pode ser usado para fins comerciais.'
                }
            ]
        },
        midjourney: {
            title: 'Gerador de Imagens IA Midjourney',
            desc: 'Midjourney é um modelo líder de geração de imagens por IA conhecido por sua qualidade artística excepcional e capacidades criativas. Perfeito para trabalhos artísticos profissionais e projetos criativos.',
            referenceBoxTitle: 'Adicionar imagens de referência para imagem-para-imagem',
            referenceBoxSubtitle: 'Suporta PNG, JPEG, WEBP (máx. 100KB). Até 5 imagens. Menos imagens, resultados mais precisos.',
            demoPrompt: 'Uma ilha flutuante mística no céu, ruínas antigas cobertas de cristais brilhantes, cachoeiras em cascata para as nuvens abaixo, iluminação etérea, estilo arte fantasia',
            referenceImages: 'Imagens de referência',
            referenceImagesCount: 'Até 5',
            refImageMaxSize: 'Cada imagem não deve exceder 100KB',
            style: 'Estilo',
            styleRealistic: 'Realista',
            styleAnime: 'Anime',
            generationSpeed: 'Velocidade de Geração',
            fastDesc: 'Geração em velocidade padrão',
            turboDesc: 'Geração rápida, processamento prioritário',
            creative: 'Criativo',
            highQuality: 'Alta Qualidade',
            fastTurbo: 'Rápido/Turbo',
            creativeGeneration: 'Geração Criativa',
            speed: 'Velocidade',
            features: [
                {
                    icon: '🎨',
                    title: 'Excelência Artística',
                    desc: 'Qualidade artística e produção criativa líderes do setor.'
                },
                {
                    icon: '🖼️',
                    title: 'Alta Resolução',
                    desc: 'Gere imagens de alta qualidade adequadas para uso profissional.'
                },
                {icon: '🎭', title: 'Estilos Únicos', desc: 'Estilos artísticos distintivos que diferenciam seu trabalho.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens geradas em 20 segundos.'},
                {icon: '📐', title: 'Múltiplos Tamanhos', desc: 'Suporta várias proporções de tela e resoluções.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todas as imagens geradas podem ser usadas para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Qual a diferença entre Rápido e Turbo?',
                    a: 'O modo Rápido custa 10 créditos com velocidade padrão. O modo Turbo custa 20 créditos com geração mais rápida e processamento prioritário.'
                },
                {
                    q: 'Como o Midjourney funciona?',
                    a: 'Basta inserir uma descrição de texto, e o Midjourney gerará imagens artísticas com base no seu prompt.'
                },
                {
                    q: 'Quais tamanhos de imagem são suportados?',
                    a: 'Suporta 1:1 (quadrado), 4:3, 3:4, 16:9 (paisagem), 9:16 (retrato), 3:2, 2:3 e outros tamanhos.'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Midjourney pode ser usado para fins comerciais.'
                }
            ]
        },
        gptImage: {
            title: 'Gerador de Imagens IA GPT-Image-1',
            desc: 'GPT-Image-1 é o modelo versátil de geração de imagens da OpenAI, capaz de criar uma ampla variedade de imagens a partir de descrições de texto. Ideal para geração de imagens de uso geral.',
            demoPromptExample: 'Campos da Toscana ao anoitecer, colinas suaves cobertas de trigo dourado, ciprestes e uma antiga casa de pedra ao fundo, o pôr do sol projetando um brilho vermelho quente pelo céu, caloroso, reconfortante, fotografia de paisagem, hora dourada.',
            imageCount: 'Quantidade de Imagens',
            promptEnhance: 'Aprimoramento de Prompt',
            promptEnhanceDesc: 'Otimizar automaticamente os prompts para melhores resultados de geração',
            count: 'Quantidade',
            multiPurpose: 'Multiuso',
            batchGeneration: 'Geração em Lote',
            size1024Square: '1024×1024 (quadrado)',
            size1536Landscape: '1536×1024 (paisagem)',
            size1024Portrait: '1024×1536 (retrato)',
            threeSizes: 'Três tamanhos fixos',
            tagQuality: 'Alta qualidade',
            tagCommercialShort: 'Uso comercial',
            features: [
                {icon: '🎨', title: 'Geração Versátil', desc: 'Crie uma ampla variedade de imagens para qualquer finalidade.'},
                {icon: '🖼️', title: 'Alta Qualidade', desc: 'Gere imagens de alta qualidade com detalhes precisos.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens geradas em 15 segundos.'},
                {
                    icon: '📝',
                    title: 'Compreensão de Texto',
                    desc: 'Excelente compreensão de descrições de texto complexas.'
                },
                {
                    icon: '📐',
                    title: 'Três tamanhos fixos',
                    desc: '1024×1024 (quadrado), 1536×1024 (paisagem), 1024×1536 (retrato).'
                },
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todas as imagens geradas podem ser usadas para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Como o GPT-Image-1 funciona?',
                    a: 'Basta inserir uma descrição de texto, e o GPT-Image-1 gerará imagens de alta qualidade com base no seu prompt.'
                },
                {
                    q: 'Quais tamanhos de imagem são suportados?',
                    a: 'Suporta três tamanhos fixos: 1024×1024 (quadrado), 1536×1024 (paisagem) e 1024×1536 (retrato).'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando GPT-Image-1 pode ser usado para fins comerciais.'
                }
            ]
        },
        gptImage15: {
            title: 'Gerador de Imagens IA GPT-Image-1.5',
            desc: 'GPT-Image-1.5 é o modelo versátil de geração de imagens da OpenAI, capaz de criar uma ampla variedade de imagens a partir de descrições de texto. Ideal para geração de imagens de uso geral.',
            demoPromptExample: 'Campos da Toscana ao anoitecer, colinas suaves cobertas de trigo dourado, ciprestes e uma antiga casa de pedra ao fundo, o pôr do sol projetando um brilho vermelho quente pelo céu, caloroso, reconfortante, fotografia de paisagem, hora dourada.',
            imageCount: 'Quantidade de Imagens',
            promptEnhance: 'Aprimoramento de Prompt',
            promptEnhanceDesc: 'Otimizar automaticamente os prompts para melhores resultados de geração',
            count: 'Quantidade',
            multiPurpose: 'Multiuso',
            batchGeneration: 'Geração em Lote',
            size1024Square: '1024×1024 (quadrado)',
            size1536Landscape: '1536×1024 (paisagem)',
            size1024Portrait: '1024×1536 (retrato)',
            threeSizes: 'Três tamanhos fixos',
            tagQuality: 'Alta qualidade',
            tagCommercialShort: 'Uso comercial',
            features: [
                {icon: '🎨', title: 'Geração Versátil', desc: 'Crie uma ampla variedade de imagens para qualquer finalidade.'},
                {icon: '🖼️', title: 'Alta Qualidade', desc: 'Gere imagens de alta qualidade com detalhes precisos.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens geradas em 15 segundos.'},
                {
                    icon: '📝',
                    title: 'Compreensão de Texto',
                    desc: 'Excelente compreensão de descrições de texto complexas.'
                },
                {
                    icon: '📐',
                    title: 'Três tamanhos fixos',
                    desc: '1024×1024 (quadrado), 1536×1024 (paisagem), 1024×1536 (retrato).'
                },
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todas as imagens geradas podem ser usadas para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Como o GPT-Image-1.5 funciona?',
                    a: 'Basta inserir uma descrição de texto, e o GPT-Image-1.5 gerará imagens de alta qualidade com base no seu prompt.'
                },
                {
                    q: 'Quais tamanhos de imagem são suportados?',
                    a: 'Suporta três tamanhos fixos: 1024×1024 (quadrado), 1536×1024 (paisagem) e 1024×1536 (retrato).'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando GPT-Image-1.5 pode ser usado para fins comerciais.'
                }
            ]
        },
        fluxKontext: {
            title: 'Gerador de Imagens IA Flux Kontext',
            desc: 'Flux Kontext para geração e edição de texto-para-imagem de alta qualidade, com múltiplas proporções de tela e geração em lote.',
            imageCount: 'Quantidade de Imagens',
            count: 'Quantidade',
            demoPrompt1: 'Uma jovem sentada em um terraço na hora dourada, usando uma jaqueta jeans oversized, fones de ouvido brancos ao pescoço, tomando café gelado de um copo plástico transparente. Seu cabelo cacheado curto esvoaça levemente ao vento enquanto as luzes da cidade começam a brilhar ao fundo.',
            demoPrompt2: 'Um homem nos seus 20 anos sentado no chão de um estúdio de arte bagunçado, cercado por telas inacabadas e tubos de tinta. Ele veste uma regata branca manchada de cores e jeans rasgado.',
            demoPrompt3: 'Uma jovem mãe ajustando o gorro do bebê enquanto senta em um cobertor de piquenique. Ela usa um suéris creme e saia longa de cotim, descalça na grama.',
            highQuality: 'Alta Qualidade',
            fastGen: 'Geração Rápida',
            multiSize: 'Múltiplos Tamanhos',
            outputStyle: 'Estilo de Saída',
            outputStyleDesc: {
                auto: 'Padrão — o modelo determina automaticamente o estilo, sem aparência forçada',
                photographic: 'Fotográfico — fotos realistas, luz e sombras naturais',
                digital_art: 'Arte Digital — aparência CG/ilustração, cores vibrantes e ricas',
                anime: 'Anime — estilo anime/cartoon japonês, linhas limpas'
            },
            outputStyleLabel: {
                auto: 'Padrão',
                photographic: 'Fotográfico',
                digital_art: 'Arte Digital',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'Saída de Alta Qualidade', desc: 'Gere imagens detalhadas e de alta fidelidade.'},
                {icon: '🎨', title: 'Texto para Imagem', desc: 'Gere imagens com precisão a partir de descrições de texto.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens é concluída em cerca de 15 segundos.'},
                {icon: '📐', title: 'Múltiplos Tamanhos', desc: 'Suporte para proporções 1:1, 3:2, 2:3.'},
                {icon: '💼', title: 'Licença Comercial', desc: 'Imagens geradas podem ser usadas para fins comerciais.'}
            ],
            faq: [
                {
                    q: 'Como o Flux Kontext funciona?',
                    a: 'Insira uma descrição de texto; o Flux Kontext gera imagens de alta qualidade e suporta uma ou múltiplas imagens por requisição.'
                },
                {q: 'Quais tamanhos de imagem são suportados?', a: 'Suporta 1:1 (quadrado), 3:2 (paisagem), 2:3 (retrato).'},
                {
                    q: 'Posso gerar múltiplas imagens de uma vez?',
                    a: 'Sim, você pode gerar de 1 a 3 imagens, cada uma cobrada separadamente.'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, o conteúdo gerado com Flux Kontext pode ser usado para fins comerciais.'
                }
            ]
        },
        fluxPro11Ultra: {
            title: 'Gerador de Imagens IA Flux Pro 1.1 Ultra',
            desc: 'Flux Pro 1.1 Ultra para texto-para-imagem de alta qualidade com múltiplas proporções de tela e geração em lote.',
            imageCount: 'Quantidade de Imagens',
            count: 'Quantidade',
            demoPrompt1: 'Uma jovem sentada em um terraço na hora dourada, usando uma jaqueta jeans oversized, fones de ouvido brancos ao pescoço, tomando café gelado de um copo plástico transparente. Seu cabelo cacheado curto esvoaça levemente ao vento enquanto as luzes da cidade começam a brilhar ao fundo.',
            demoPrompt2: 'Um homem nos seus 20 anos sentado no chão de um estúdio de arte bagunçado, cercado por telas inacabadas e tubos de tinta. Ele veste uma regata branca manchada de cores e jeans rasgado.',
            demoPrompt3: 'Uma jovem mãe ajustando o gorro do bebê enquanto senta em um cobertor de piquenique. Ela usa um suéris creme e saia longa de cotim, descalça na grama.',
            highQuality: 'Alta Qualidade',
            fastGen: 'Geração Rápida',
            multiSize: 'Múltiplos Tamanhos',
            outputStyle: 'Estilo de Saída',
            outputStyleDesc: {
                auto: 'Padrão — o modelo determina automaticamente o estilo, sem aparência forçada',
                photographic: 'Fotográfico — fotos realistas, luz e sombras naturais',
                digital_art: 'Arte Digital — aparência CG/ilustração, cores vibrantes e ricas',
                anime: 'Anime — estilo anime/cartoon japonês, linhas limpas'
            },
            outputStyleLabel: {
                auto: 'Padrão',
                photographic: 'Fotográfico',
                digital_art: 'Arte Digital',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'Saída de Alta Qualidade', desc: 'Gere imagens detalhadas e de alta fidelidade.'},
                {icon: '🎨', title: 'Texto para Imagem', desc: 'Gere imagens com precisão a partir de descrições de texto.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens é concluída em cerca de 15 segundos.'},
                {
                    icon: '📐',
                    title: 'Múltiplos Tamanhos',
                    desc: 'Suporte para 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'
                },
                {icon: '💼', title: 'Licença Comercial', desc: 'Imagens geradas podem ser usadas para fins comerciais.'}
            ],
            faq: [
                {
                    q: 'Como o Flux Pro 1.1 Ultra funciona?',
                    a: 'Insira uma descrição de texto para gerar imagens de alta qualidade; suporta de 1 a 4 imagens por requisição.'
                },
                {q: 'Quais tamanhos de imagem são suportados?', a: 'Suporta 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'},
                {
                    q: 'Posso gerar múltiplas imagens de uma vez?',
                    a: 'Sim, você pode gerar de 1 a 4 imagens, cada uma cobrada separadamente.'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, o conteúdo pode ser usado para fins comerciais.'
                }
            ]
        },
        fluxSchnell: {
            title: 'Gerador de Imagens IA Flux Schnell',
            desc: 'Flux Schnell para texto-para-imagem rápido com múltiplas proporções de tela e geração em lote.',
            imageCount: 'Quantidade de Imagens',
            count: 'Quantidade',
            demoPrompt1: 'Uma jovem sentada em um terraço na hora dourada, usando uma jaqueta jeans oversized, fones de ouvido brancos ao pescoço, tomando café gelado de um copo plástico transparente. Seu cabelo cacheado curto esvoaça levemente ao vento enquanto as luzes da cidade começam a brilhar ao fundo.',
            demoPrompt2: 'Um homem nos seus 20 anos sentado no chão de um estúdio de arte bagunçado, cercado por telas inacabadas e tubos de tinta. Ele veste uma regata branca manchada de cores e jeans rasgado.',
            demoPrompt3: 'Uma jovem mãe ajustando o gorro do bebê enquanto senta em um cobertor de piquenique. Ela usa um suéris creme e saia longa de cotim, descalça na grama.',
            highQuality: 'Alta Qualidade',
            fastGen: 'Geração Rápida',
            multiSize: 'Múltiplos Tamanhos',
            outputStyle: 'Estilo de Saída',
            outputStyleDesc: {
                auto: 'Padrão — o modelo determina automaticamente o estilo, sem aparência forçada',
                photographic: 'Fotográfico — fotos realistas, luz e sombras naturais',
                digital_art: 'Arte Digital — aparência CG/ilustração, cores vibrantes e ricas',
                anime: 'Anime — estilo anime/cartoon japonês, linhas limpas'
            },
            outputStyleLabel: {
                auto: 'Padrão',
                photographic: 'Fotográfico',
                digital_art: 'Arte Digital',
                anime: 'Anime'
            },
            features: [
                {icon: '✨', title: 'Saída de Alta Qualidade', desc: 'Gere imagens detalhadas e de alta fidelidade.'},
                {icon: '🎨', title: 'Texto para Imagem', desc: 'Gere imagens com precisão a partir de descrições de texto.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria das imagens é concluída em cerca de 15 segundos.'},
                {
                    icon: '📐',
                    title: 'Múltiplos Tamanhos',
                    desc: 'Suporte para 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'
                },
                {icon: '💼', title: 'Licença Comercial', desc: 'Imagens geradas podem ser usadas para fins comerciais.'}
            ],
            faq: [
                {
                    q: 'Como o Flux Schnell funciona?',
                    a: 'Insira uma descrição de texto para gerar rapidamente imagens de alta qualidade; suporta de 1 a 4 imagens por requisição.'
                },
                {q: 'Quais tamanhos de imagem são suportados?', a: 'Suporta 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21.'},
                {
                    q: 'Posso gerar múltiplas imagens de uma vez?',
                    a: 'Sim, você pode gerar de 1 a 4 imagens, cada uma cobrada separadamente.'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, o conteúdo pode ser usado para fins comerciais.'
                }
            ]
        },
        flux2: {
            title: 'Gerador de Imagens AI FLUX.2',
            desc: 'O FLUX.2 traz eficiência de nível empresarial e precisão profissional para a geração de texto para imagem com detalhes fotorrealistas, mãos, rostos e texturas precisos.',
            variant: 'Variante do Modelo',
            variantLabel: 'Variante do Modelo',
            variantDesc: {
                'klein-04': 'Tempo real',
                'klein-09': 'Equilibrado',
                'max': 'Maior qualidade',
                'pro': 'Produção',
                'flex': 'Personalizável'
            },
            promptUpsampling: 'Ampliação de Prompt',
            promptUpsamplingHint: 'Aprimore os detalhes do prompt para resultados mais ricos (não disponível para modelos Klein).',
            steps: 'Passos',
            stepsHint: 'Mais passos produzem mais detalhes, mas levam mais tempo. Apenas variante Flex.',
            guidance: 'Orientação',
            guidanceHint: 'Controla o quão fielmente a saída segue o prompt. Apenas variante Flex.',
            tagPhotorealism: 'Fotorrealismo',
            tagMultilingual: 'Multilíngue',
            tagVariants: '5 Variantes',
            demoPrompt1: 'Uma jovem sentada em um terraço na hora dourada, usando uma jaqueta jeans oversized, fones de ouvido brancos ao pescoço, tomando café gelado de um copo plástico transparente. Seu cabelo cacheado curto esvoaça levemente ao vento enquanto as luzes da cidade começam a brilhar ao fundo.',
            features: [
                {icon: '✨', title: 'Detalhe Fotorrealista', desc: 'Mãos, rostos, tecidos, logos e objetos pequenos precisos com resolução de até 4MP.'},
                {icon: '🎨', title: 'Tipografia e Design', desc: 'Renderiza tipografia clara e legível e segue instruções complexas de layout.'},
                {icon: '🌍', title: 'Multilíngue', desc: 'Suporte nativo a prompts em vários idiomas com seguimento de instruções de ponta.'},
                {icon: '🎯', title: '5 Variantes de Modelo', desc: 'Klein 4B/9B para velocidade, Max para qualidade, Pro para escala, Flex para controle personalizado.'},
                {icon: '⚙️', title: 'Controle Flexível', desc: 'Passos, orientação, tamanho e tolerância de segurança ajustáveis para fluxos de trabalho de produção.'}
            ],
            faq: [
                {
                    q: 'Quais são as variantes do modelo FLUX.2?',
                    a: 'FLUX.2 oferece 5 variantes: Klein 4B e 9B (rápido, alto volume), Max (maior qualidade com busca de fundamentação), Pro (produção em escala) e Flex (passos e orientação ajustáveis).'
                },
                {
                    q: 'Quais tamanhos de imagem são suportados?',
                    a: 'FLUX.2 usa dimensões em pixels (largura x altura) que devem ser múltiplos de 16. Predefinições incluem 1:1 (1024x1024), 4:3, 3:4, 16:9, 9:16, 21:9 e 9:21.'
                },
                {
                    q: 'O que é Ampliação de Prompt?',
                    a: 'Quando ativado, o modelo aprimora seu prompt internamente para detalhes mais ricos. Disponível para variantes Max, Pro e Flex (não Klein).'
                },
                {
                    q: 'O que são Passos e Orientação no modo Flex?',
                    a: 'Passos (1-50) controlam a qualidade de inferência — maior significa mais detalhes, porém mais lento. Orientação (1.5-10) controla a aderência ao prompt — maior significa mais próximo da sua descrição.'
                },
                {
                    q: 'As imagens geradas podem ser usadas comercialmente?',
                    a: 'Sim, o conteúdo pode ser usado para fins comerciais.'
                }
            ]
        },
        seedance: {
            title: 'Gerador de Vídeos IA Seedance',
            desc: 'Seedance é um modelo de vídeo IA de próxima geração que suporta sincronização áudio-visual nativa, movimento cinematográfico e expressão emocional. Abrange modos de texto-para-vídeo, imagem-para-vídeo e extensão de vídeo.',
            textToVideo: 'Texto para Vídeo',
            imageToVideo: 'Imagem para Vídeo',
            videoExtend: 'Extensão de Vídeo',
            uploadImage: 'Clique para enviar imagem de referência',
            uploadHint: 'PNG, JPG, JPEG (máx. 20MB)',
            endFrame: 'Quadro Final',
            endFrameHint: '(Opcional) Envie o quadro final para controlar o final do vídeo',
            uploadEndFrame: 'Clique para enviar imagem do quadro final',
            uploadVideo: 'Clique para enviar vídeo de referência',
            uploadVideoHint: 'MP4, MOV, WebM (máx. 100MB)',
            videoPrompt: 'Prompt de Vídeo',
            promptPlaceholder: 'Descreva o vídeo que deseja gerar...',
            videoPromptPlaceholder: 'Descreva o vídeo que deseja gerar...',
            negativePrompt: 'Prompt Negativo',
            negativePromptPlaceholder: 'Descreva o que você não quer no vídeo (opcional)',
            duration: 'Duração',
            videoDuration: 'Duração do vídeo',
            resolution: 'Resolução',
            aspectRatio: 'Proporção de Tela',
            promptEnhance: 'Aprimoramento de prompt',
            promptEnhanceDesc: 'Otimizar automaticamente os prompts para melhores resultados de geração',
            generateAudio: 'Gerar Áudio',
            audioOn: 'Áudio nativo (voz + efeitos sonoros)',
            audioOff: 'Apenas vídeo, sem áudio',
            seedValue: 'Valor da Seed',
            seedHint: 'O valor da seed é o identificador único do estilo geral. Usar a mesma seed mantém o estilo consistente, enquanto ajustar outros parâmetros ajuda a refinar os detalhes visuais.',
            seedPlaceholder: '-1 (aleatório)',
            characters: 'caracteres',
            creditsRequired: 'Créditos Necessários:',
            creditsRemaining: 'Restantes:',
            generate: 'Gerar',
            generating: 'Gerando...',
            demoPrompt: 'Prompt de Demonstração',
            demoPromptExample: 'Um gatinho branco fofinho e macio dança alegremente nas pontas das patas, seu corpo fofo balançando suavemente com as pequenas patinhas rosadas levantadas. Sobre um carpete macio sob iluminação amarela quente, estilo cartoon reconfortante, detalhes requintados, cores suaves e gentis.',
            modelLabel: 'Modelo:',
            durationLabel: 'Duração:',
            techSpecsTitle: 'Especificações Técnicas',
            techSpecsDesc: 'Seedance suporta sincronização áudio-visual nativa, movimento cinematográfico e expressão emocional. Abrange modos de texto-para-vídeo, imagem-para-vídeo e extensão de vídeo.',
            t2vTitle: 'Texto para Vídeo (T2V)',
            t2vDesc: 'Transforme prompts em cenas de vídeo cinematográficas',
            i2vTitle: 'Imagem para Vídeo (I2V)',
            i2vDesc: 'Anime uma única imagem usando IA',
            input: 'Entrada:',
            textPrompt: 'Prompt de texto',
            imagePrompt: 'Imagem + prompt',
            audio: 'Áudio:',
            nativeAudio: 'Geração de áudio nativo',
            bestFor: 'Ideal para:',
            t2vBestFor: 'Perfeito para criação de conteúdo cinematográfico, publicidade e vídeos para redes sociais.',
            i2vBestFor: 'Ideal para animação de retratos, vitrines de produtos e conteúdo criativo.',
            featuresDesc: 'Seja você designer, profissional de marketing, criador de conteúdo ou usuário casual, Seedance ajuda você a criar rapidamente conteúdo IA de alta qualidade.',
            features: [
                {
                    icon: '🎬',
                    title: 'Geração Áudio-Visual Nativa',
                    desc: 'Gere vídeo e áudio simultaneamente em uma única operação, entregando qualidade cinematográfica. Lip sync natural e dublagem de diálogos.'
                },
                {
                    icon: '😊',
                    title: 'Expressão Orientada por Emoções',
                    desc: 'Performance com consciência emocional para expressões faciais mais realistas. Expressões sutis incluem hesitação, tristeza, tensão ou contenção emocional.'
                },
                {
                    icon: '🎥',
                    title: 'Controle de Câmera de Nível de Diretor',
                    desc: 'Suporta movimentos de câmera de aproximação, afastamento, panorâmica, órbita e rastreamento. Orientação de primeiro e último quadro para transições suaves.'
                },
                {
                    icon: '📱',
                    title: 'Entrada Multimodal',
                    desc: 'Suporta texto-para-vídeo, imagem-para-vídeo e outros fluxos de trabalho criativos flexíveis.'
                },
                {
                    icon: '⚡',
                    title: 'Geração Rápida',
                    desc: 'Motor de inferência otimizado garante produção rápida, a maioria dos vídeos é concluída em minutos.'
                },
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais, adequados para publicidade, redes sociais e mais.'
                }
            ],
            enterPrompt: 'Por favor, insira um prompt',
            imageRequired: 'O modo imagem-para-vídeo requer uma imagem de referência',
            videoRequired: 'O modo de extensão de vídeo requer um vídeo de referência',
            generateFailed: 'Falha na geração',
            requestFailed: 'Falha na requisição, por favor tente novamente',
            faq: [
                {
                    q: 'Como o Seedance funciona?',
                    a: 'Você pode enviar uma imagem de referência ou inserir uma descrição de texto diretamente, e o modelo Seedance gerará conteúdo de vídeo de alta qualidade com base em suas instruções, com áudio sincronizado. O processo é simples e intuitivo, não exigindo habilidades profissionais.'
                },
                {
                    q: 'Os vídeos gerados podem ser usados comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Seedance pode ser usado para fins comerciais, incluindo materiais de marketing, redes sociais, vitrines de produtos e mais.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Usar Seedance custa 18 créditos por geração. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                {
                    q: 'Quão rápida é a geração?',
                    a: 'A velocidade média de geração do Seedance é de cerca de 1,5 minutos. Otimizamos continuamente nossa infraestrutura para garantir geração rápida e estável.'
                },
                {
                    q: 'Quais formatos de saída são suportados?',
                    a: 'Os vídeos são gerados em formato MP4, suportando resoluções de 480p, 720p e 1080p, com durações de 5 ou 10 segundos e múltiplas proporções de tela.'
                }
            ]
        },
        veo: {
            title: 'Gerador de Vídeos IA Veo 3.1',
            desc: 'Google Veo 3.1 é um modelo de vídeo IA de ponta que suporta geração de áudio nativo, resolução ultra-alta e criação de vídeos longos. Perfeito para produção de vídeo profissional.',
            fastType: 'Tipo Rápido',
            fastTypeBadge: 'Velocidade rápida, menor custo',
            fastTypeDesc: '(Suporta imagens de referência 16:9)',
            qualityType: 'Tipo Qualidade',
            qualityTypeBadge: 'Detalhes mais ricos',
            qualityTypeDesc: 'Movimento mais suave. O quadro final é opcional no modo de imagem para controlar o último quadro.',
            imageMode: 'Modo de Geração',
            startEndFrames: 'Quadros Inicial/Final',
            referenceImage: 'Imagem de Referência',
            startFrame: 'Quadro Inicial',
            startFrameHint: 'Defina o primeiro quadro. O vídeo é animado a partir deste quadro.',
            uploadStartFrame: 'Clique para enviar quadro inicial',
            endFrame: 'Quadro Final',
            endFrameHint: 'Defina o último quadro. O vídeo termina neste quadro.',
            uploadEndFrame: 'Clique para enviar quadro final',
            negativePrompt: 'Prompt Negativo',
            negativePromptPlaceholder: 'Descreva o que você não quer no vídeo...',
            features: [
                {
                    icon: '🎬',
                    title: 'Geração de Áudio Nativo',
                    desc: 'Gere vídeo e áudio simultaneamente, incluindo diálogos e efeitos sonoros.'
                },
                {
                    icon: '📺',
                    title: 'Resolução Ultra HD',
                    desc: 'Suporte a saída com resolução de até 4K para produção de vídeo profissional.'
                },
                {
                    icon: '⏱️',
                    title: 'Suporte a Vídeo Longo',
                    desc: 'Gere vídeos de até 2 minutos, adequados para diversas necessidades criativas.'
                },
                {icon: '🎥', title: 'Movimento Cinematográfico', desc: 'Movimentos de câmera profissionais e transições suaves.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'Motor de inferência otimizado para produção rápida.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Qual a diferença entre os tipos Rápido e Qualidade?',
                    a: 'O tipo Rápido é mais veloz e econômico, adequado para iteração rápida. O tipo Qualidade produz detalhes mais ricos e movimento mais suave, ideal para saída final.'
                },
                {
                    q: 'Como o Veo 3.1 funciona?',
                    a: 'Insira uma descrição de texto ou envie uma imagem de referência, e o Veo 3.1 gerará conteúdo de vídeo de alta qualidade com base em suas instruções, opcionalmente com áudio sincronizado.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Usar Veo 3.1 custa 30 créditos por geração. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                {
                    q: 'Quais resoluções e durações são suportadas?',
                    a: 'Suporta resoluções 720p e 1080p, com durações de 5s, 10s e até 2 minutos para vídeos mais longos.'
                }
            ]
        },
        veo31: {
            genType: 'Tipo de Geração',
            genTypeFast: 'Rápido',
            genTypeQuality: 'Qualidade',
            endFrame: 'Quadro Final'
        },
        veo30: {
            title: 'Gerador de Vídeos IA Veo 3.0',
            desc: 'Google Veo 3.0 é um modelo de vídeo IA avançado que suporta texto-para-vídeo e imagem-para-vídeo, com duração de 4s/6s/8s e saída em 720p/1080p.',
            fastType: 'Tipo Rápido',
            fastTypeBadge: 'Mais rápido, menor custo',
            fastTypeDesc: '(Suporta imagem de referência 16:9)',
            qualityType: 'Tipo Qualidade',
            qualityTypeBadge: 'Detalhes mais ricos',
            qualityTypeDesc: 'Movimento mais suave. O quadro final no modo de imagem é opcional para controlar o último quadro.',
            imageMode: 'Modo de Imagem',
            startEndFrames: 'Quadro Inicial/Final',
            referenceImage: 'Imagem de Referência',
            referenceImageHint: 'Envie uma imagem de referência; o vídeo será gerado com base nela.',
            uploadReferenceImage: 'Clique para enviar imagem de referência',
            startFrame: 'Quadro Inicial',
            startFrameHint: 'Defina o primeiro quadro. O vídeo é animado a partir deste quadro.',
            uploadStartFrame: 'Clique para enviar quadro inicial',
            endFrame: 'Quadro Final',
            endFrameHint: 'Defina o último quadro. O vídeo termina neste quadro.',
            uploadEndFrame: 'Clique para enviar quadro final',
            negativePrompt: 'Prompt Negativo',
            negativePromptPlaceholder: 'Descreva o que você não quer no vídeo...',
            seedRangeError: 'A seed deve ser um número inteiro entre 0 e 2147483647.',
            duration: 'Duração',
            resolution: 'Resolução',
            demoPrompt: 'Uma adolescente desenhando em um caderno na janela de um café, chuva batendo no vidro...',
            features: [
                {
                    icon: '🎬',
                    title: 'Geração de Áudio Nativo',
                    desc: 'Gere vídeo e áudio simultaneamente, incluindo diálogos e efeitos sonoros.'
                },
                {
                    icon: '📺',
                    title: 'Resolução HD',
                    desc: 'Suporte a saída 720p e 1080p para produção de vídeo profissional.'
                },
                {icon: '⏱️', title: 'Múltiplas Durações', desc: 'Suporte a geração de vídeos de 4s, 6s e 8s.'},
                {icon: '🎥', title: 'Movimento Cinematográfico', desc: 'Movimentos de câmera profissionais e transições suaves.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'Motor de inferência otimizado para produção rápida.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Qual a diferença entre os tipos Rápido e Qualidade?',
                    a: 'O tipo Rápido é mais veloz e econômico, adequado para iteração rápida. O tipo Qualidade produz detalhes mais ricos e movimento mais suave, ideal para saída final.'
                },
                {
                    q: 'Como o Veo 3.0 funciona?',
                    a: 'Insira uma descrição de texto ou envie uma imagem de referência, e o Veo 3.0 gerará conteúdo de vídeo de alta qualidade com base em suas instruções, opcionalmente com áudio sincronizado.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Usar Veo 3.0 custa 25 créditos por geração. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                {
                    q: 'Quais resoluções e durações são suportadas?',
                    a: 'Suporta resoluções 720p e 1080p, com durações de 4s, 6s ou 8s.'
                }
            ]
        },
        veo31fast: {
            title: 'Gerador de Vídeos IA Veo 3.1 Fast',
            desc: 'Google Veo 3.1 Fast para geração mais rápida, suportando texto-para-vídeo e imagem-para-vídeo com quadro final opcional, duração de 4s/6s/8s e saída em 720p/1080p/4K.',
            referenceImage: 'Imagem de Referência',
            referenceImageHint: 'Envie uma imagem de referência; o vídeo será gerado com base nela.',
            uploadReferenceImage: 'Clique para enviar imagem de referência',
            endFrame: 'Quadro Final',
            endFrameHint: 'Opcional. Defina a imagem para o último quadro do vídeo para controlar o final.',
            uploadEndFrame: 'Clique para enviar quadro final',
            duration: 'Duração',
            resolution: 'Resolução',
            seedRangeError: 'A seed deve ser um número inteiro entre 0 e 2147483647.',
            demoPrompt: 'Uma adolescente desenhando em um caderno na janela de um café, chuva batendo no vidro...',
            features: [
                {icon: '⚡', title: 'Geração Rápida', desc: 'Otimizado para saída mais rápida.'},
                {icon: '📺', title: 'Resolução 4K', desc: 'Suporte a saída 720p, 1080p e 4K.'},
                {icon: '⏱️', title: 'Múltiplas Durações', desc: 'Suporte a vídeos de 4s, 6s e 8s.'},
                {
                    icon: '🖼️',
                    title: 'Quadro Final Opcional',
                    desc: 'Imagem-para-vídeo pode enviar um quadro final para controlar o encerramento.'
                },
                {icon: '🎥', title: 'Movimento Cinematográfico', desc: 'Movimentos de câmera profissionais e transições suaves.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Qual a diferença entre Veo 3.1 Fast e Veo 3.1?',
                    a: 'Veo 3.1 Fast é otimizado para velocidade e menor custo de créditos, com suporte a 4K e quadro final opcional.'
                },
                {
                    q: 'O que é o quadro final?',
                    a: 'Para imagem-para-vídeo, você pode enviar uma imagem de quadro final para que o vídeo termine naquele quadro, dando controle sobre o encerramento.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Usar Veo 3.1 Fast custa 20 créditos por geração.'
                },
                {
                    q: 'Quais resoluções e durações são suportadas?',
                    a: 'Suporta resoluções 720p, 1080p e 4K, com durações de 4s, 6s ou 8s.'
                }
            ]
        },
        kling: {
            title: 'Gerador de Vídeos IA Kling 2.6',
            desc: 'Kling 2.6 é um modelo de vídeo IA de alto desempenho que suporta texto-para-vídeo e imagem-para-vídeo, com excelente qualidade de movimento e velocidade de geração rápida.',
            features: [
                {
                    icon: '🎬',
                    title: 'Movimento de Alta Qualidade',
                    desc: 'Movimento suave e natural com saída de qualidade profissional.'
                },
                {icon: '📱', title: 'Múltiplas Proporções de Tela', desc: 'Suporta 1:1, 16:9, 9:16 e outras proporções de tela.'},
                {
                    icon: '🔊',
                    title: 'Geração de Áudio',
                    desc: 'Geração opcional de áudio nativo para experiência de vídeo completa.'
                },
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria dos vídeos gerada em 2 minutos.'},
                {icon: '🖼️', title: 'Imagem para Vídeo', desc: 'Anime imagens estáticas com movimento alimentado por IA.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Como o Kling 2.6 funciona?',
                    a: 'Insira uma descrição de texto ou envie uma imagem de referência, e o Kling 2.6 gerará conteúdo de vídeo de alta qualidade com base em suas instruções.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Usar Kling 2.6 custa 28 créditos por geração. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                {
                    q: 'Quais resoluções e durações são suportadas?',
                    a: 'Suporta resoluções 720p e 1080p, com durações de 5s e 10s.'
                },
                {
                    q: 'Posso usar os vídeos gerados comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Kling 2.6 pode ser usado para fins comerciais.'
                }
            ]
        },
        kling3: {
            title: 'Gerador de Vídeos IA Kling 3.0',
            desc: 'Kling 3.0 é um modelo de vídeo IA de alto desempenho que suporta texto-para-vídeo e imagem-para-vídeo, com excelente qualidade de movimento e velocidade de geração rápida.',
            features: [
                {
                    icon: '🎬',
                    title: 'Movimento de Alta Qualidade',
                    desc: 'Movimento suave e natural com saída de qualidade profissional.'
                },
                {icon: '📱', title: 'Múltiplas Proporções de Tela', desc: 'Suporta 1:1, 16:9, 9:16 e outras proporções de tela.'},
                {
                    icon: '🔊',
                    title: 'Geração de Áudio',
                    desc: 'Geração opcional de áudio nativo para experiência de vídeo completa.'
                },
                {icon: '⚡', title: 'Geração Rápida', desc: 'A maioria dos vídeos gerada em 2 minutos.'},
                {icon: '🖼️', title: 'Imagem para Vídeo', desc: 'Anime imagens estáticas com movimento alimentado por IA.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Como o Kling 3.0 funciona?',
                    a: 'Insira uma descrição de texto ou envie uma imagem de referência, e o Kling 3.0 gerará conteúdo de vídeo de alta qualidade com base em suas instruções.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Usar Kling 3.0 custa 28 créditos por geração. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                {
                    q: 'Quais resoluções e durações são suportadas?',
                    a: 'Suporta resoluções 720p e 1080p, com durações de 5s e 10s.'
                },
                {
                    q: 'Posso usar os vídeos gerados comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Kling 3.0 pode ser usado para fins comerciais.'
                }
            ]
        },
        sora: {
            title: 'Gerador de Vídeos IA Sora 2',
            desc: 'Sora 2 é o modelo avançado de vídeo IA da OpenAI, capaz de gerar vídeos de alta qualidade com movimento realista e qualidade cinematográfica.',
            demoPromptExample: '@sama O CEO da OpenAI, Sam, está apresentando este produto de gabinete, dizendo que é igual ao dele e muito útil.',
            landscape: 'Paisagem',
            portrait: 'Retrato',
            removeWatermark: 'Remover Marca d\'Água',
            enabled: 'Ativado',
            disabled: 'Desativado',
            noWatermark: 'Sem Marca d\'Água',
            cinematic: 'Qualidade Cinematográfica',
            restrictedAccess: 'Acesso Restrito',
            '60secDuration': 'Duração de 4 s / 8 s / 12 s',
            photorealistic: 'Fotorrealista',
            physicsSimulation: 'Simulação de Física',
            features: [
                {
                    icon: '🎬',
                    title: 'Qualidade Cinematográfica',
                    desc: 'Gere vídeos com aparência e sensação cinematográfica profissional.'
                },
                {
                    icon: '🎥',
                    title: 'Movimento Realista',
                    desc: 'Movimento natural e realista para personagens e cenas.'
                },
                {icon: '⏱️', title: 'Duração Flexível', desc: 'Suporta vários comprimentos de vídeo para diferentes necessidades.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'Otimizado para produção rápida de vídeo.'},
                {icon: '🖼️', title: 'Entrada Multimodal', desc: 'Suporta modos de texto-para-vídeo e imagem-para-vídeo.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Como o Sora 2 funciona?',
                    a: 'Insira uma descrição de texto ou envie uma imagem de referência, e o Sora 2 gerará conteúdo de vídeo de alta qualidade com base em suas instruções.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Usar Sora 2 custa 15 créditos por geração. Você pode obter melhores taxas de crédito através de planos de assinatura.'
                },
                {
                    q: 'O que torna o Sora 2 especial?',
                    a: 'Sora 2 se destaca na geração de movimento realista e vídeos de qualidade cinematográfica, tornando-o ideal para criação de conteúdo profissional.'
                },
                {
                    q: 'Posso usar os vídeos gerados comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Sora 2 pode ser usado para fins comerciais.'
                }
            ]
        },
        wan: {
            title: 'Gerador de Vídeos IA Wan',
            desc: 'Wan é um modelo de vídeo IA versátil que suporta texto-para-vídeo e imagem-para-vídeo com excelente qualidade e velocidade.',
            multiFormat: 'Múltiplos Formatos',
            smoothMotion: 'Movimento Suave',
            referenceAudio: 'Áudio de Referência',
            uploadAudio: 'Clique para enviar áudio de referência',
            uploadAudioHint: 'MP3, WAV, M4A (opcional, direciona a trilha sonora do vídeo)',
            features: [
                {
                    icon: '🎬',
                    title: 'Saída de Alta Qualidade',
                    desc: 'Gere vídeos de qualidade profissional a partir de texto ou imagens.'
                },
                {icon: '⚡', title: 'Geração Rápida', desc: 'Produção rápida de vídeo para fluxo de trabalho eficiente.'},
                {icon: '📱', title: 'Múltiplos Formatos', desc: 'Suporta várias proporções de tela e resoluções.'},
                {icon: '🖼️', title: 'Animação de Imagem', desc: 'Dê vida a imagens estáticas com movimento IA.'},
                {icon: '🎥', title: 'Movimento Suave', desc: 'Movimento natural e fluido nos vídeos gerados.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Como o Wan funciona?',
                    a: 'Insira uma descrição de texto ou envie uma imagem de referência, e o Wan gerará conteúdo de vídeo de alta qualidade com base em suas instruções.'
                },
                {
                    q: 'Qual versão do Wan devo usar?',
                    a: 'Wan 2.5 e 2.6 oferecem os recursos mais recentes e melhor qualidade. Wan 2.2 é uma opção econômica para projetos mais simples.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Wan 2.6 custa 70 créditos, Wan 2.5 custa 60 créditos e Wan 2.2 custa 10 créditos por geração.'
                },
                {
                    q: 'Posso usar os vídeos gerados comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Wan pode ser usado para fins comerciais.'
                }
            ]
        },
        wan25: {
            title: 'Gerador de Vídeos IA Wan 2.5',
            desc: 'Wan 2.5 é um modelo de vídeo IA versátil que suporta texto-para-vídeo e imagem-para-vídeo com excelente qualidade e velocidade.',
            features: [
                {
                    icon: '🎬',
                    title: 'Saída de Alta Qualidade',
                    desc: 'Gere vídeos de qualidade profissional a partir de texto ou imagens.'
                },
                {icon: '⚡', title: 'Geração Rápida', desc: 'Produção rápida de vídeo para fluxo de trabalho eficiente.'},
                {icon: '📱', title: 'Múltiplos Formatos', desc: 'Suporta várias proporções de tela e resoluções.'},
                {icon: '🖼️', title: 'Animação de Imagem', desc: 'Dê vida a imagens estáticas com movimento IA.'},
                {icon: '🎥', title: 'Movimento Suave', desc: 'Movimento natural e fluido nos vídeos gerados.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Como o Wan 2.5 funciona?',
                    a: 'Insira uma descrição de texto ou envie uma imagem de referência, e o Wan 2.5 gerará conteúdo de vídeo de alta qualidade com base em suas instruções.'
                },
                {
                    q: 'Qual a diferença entre Wan 2.5 e Wan 2.6?',
                    a: 'Wan 2.6 oferece melhorias adicionais em qualidade e estabilidade; Wan 2.5 é econômico e adequado para a maioria dos casos de uso.'
                },
                {q: 'Quantos créditos cada geração custa?', a: 'Wan 2.5 custa 60 créditos por geração.'},
                {
                    q: 'Posso usar os vídeos gerados comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Wan 2.5 pode ser usado para fins comerciais.'
                }
            ]
        },
        wan26: {
            title: 'Gerador de Vídeos IA Wan 2.6',
            desc: 'Wan 2.6 é um modelo de vídeo IA aprimorado com qualidade e estabilidade melhoradas, suportando texto-para-vídeo e imagem-para-vídeo.',
            features: [
                {
                    icon: '🎬',
                    title: 'Saída de Alta Qualidade',
                    desc: 'Gere vídeos de qualidade profissional a partir de texto ou imagens com qualidade aprimorada.'
                },
                {icon: '⚡', title: 'Geração Rápida', desc: 'Produção rápida de vídeo para fluxo de trabalho eficiente.'},
                {icon: '📱', title: 'Múltiplos Formatos', desc: 'Suporta várias proporções de tela e resoluções.'},
                {icon: '🖼️', title: 'Animação de Imagem', desc: 'Dê vida a imagens estáticas com movimento IA.'},
                {icon: '🎥', title: 'Movimento Suave', desc: 'Movimento natural e fluido nos vídeos gerados.'},
                {
                    icon: '💼',
                    title: 'Licença Comercial',
                    desc: 'Todos os vídeos gerados podem ser usados para fins comerciais.'
                }
            ],
            faq: [
                {
                    q: 'Qual a diferença entre Wan 2.6 e Wan 2.5?',
                    a: 'Wan 2.6 oferece melhorias adicionais em qualidade e estabilidade para saída de maior qualidade.'
                },
                {
                    q: 'Como o Wan 2.6 funciona?',
                    a: 'Insira uma descrição de texto ou envie uma imagem de referência, e o Wan 2.6 gerará conteúdo de vídeo de alta qualidade com base em suas instruções.'
                },
                {q: 'Quantos créditos cada geração custa?', a: 'Wan 2.6 custa 70 créditos por geração.'},
                {
                    q: 'Posso usar os vídeos gerados comercialmente?',
                    a: 'Sim, todo o conteúdo gerado usando Wan 2.6 pode ser usado para fins comerciais.'
                }
            ]
        },
        wan22: {
            title: 'Gerador de Vídeos IA Wan 2.2 Clássico',
            desc: 'Wan 2.2 é um modelo de vídeo IA clássico para texto-para-vídeo e imagem-para-vídeo, focado em saída estável e forte custo-benefício.',
            demoPromptExample: 'Uma garota com poucas sardas e cabelo ruivo bagunçado sentada em um terraço durante o pôr do sol, jaqueta jeans levemente gasta, segurando uma câmera Polaroid, o horizonte da cidade brilhando em tons suaves ao fundo.',
            resolutionBadge: '720p',
            classicVersion: 'Versão Clássica',
            stableReliable: 'Estável e Confiável',
            costEffective: 'Econômico',
            features: [
                {
                    icon: '🎬',
                    title: 'Texto/Imagem para Vídeo',
                    desc: 'Suporta tanto texto-para-vídeo quanto imagem-para-vídeo para criação diária e testes em lote.'
                },
                {icon: '⚡', title: 'Resultados Estáveis', desc: 'Modelo clássico maduro com qualidade de saída previsível.'},
                {icon: '💰', title: 'Econômico', desc: 'Menor consumo de créditos para fluxos de trabalho de alta frequência.'},
                {icon: '📐', title: 'Proporções Comuns', desc: 'Suporta proporções de tela comuns como 16:9 e 9:16.'},
                {icon: '🎥', title: 'Saída Limpa', desc: 'Entrega qualidade de vídeo clara e estável.'},
                {icon: '💼', title: 'Licença Comercial', desc: 'O conteúdo gerado pode ser usado comercialmente.'}
            ],
            faq: [
                {
                    q: 'Qual a diferença entre Wan 2.2 e Wan 2.5?',
                    a: 'Wan 2.2 é melhor para cenários sensíveis a custo e alto volume; Wan 2.5/2.6 oferecem capacidades e qualidade mais fortes.'
                },
                {
                    q: 'Como o Wan 2.2 funciona?',
                    a: 'Insira um prompt ou envie uma imagem de referência, e o modelo gera o vídeo com base em sua instrução.'
                },
                {
                    q: 'Os vídeos gerados podem ser usados comercialmente?',
                    a: 'Sim, as saídas do Wan 2.2 podem ser usadas para fins comerciais.'
                }
            ]
        },
        kling25: {
            title: 'Gerador de Vídeos IA Kling 2.5',
            desc: 'Kling 2.5 é um modelo de vídeo IA padrão que suporta texto-para-vídeo e imagem-para-vídeo com qualidade estável e bom custo-benefício.',
            standard: 'Padrão',
            reliable: 'Confiável',
            costEffective: 'Econômico',
            standardQuality: 'Qualidade Padrão',
            textToVideo: 'Texto para Vídeo',
            imageToVideo: 'Imagem para Vídeo',
            referenceImage: 'Imagem de Referência',
            referenceImageHint: 'Clique para enviar ou arraste e solte',
            referenceImageFormats: 'Suporta PNG, JPG, JPEG, WEBP (<=10MB)',
            endFrame: 'Quadro Final',
            endFrameOptional: 'Opcional',
            endFrameFormats: 'PNG, JPG, JPEG',
            endFrameHint: 'Restringir o quadro final; melhor quando a proporção corresponde à imagem de referência',
            videoPrompt: 'Prompt de Vídeo',
            promptPlaceholder: 'Descreva o vídeo que deseja gerar...',
            negativePrompt: 'Prompt Negativo',
            negativePromptPlaceholder: 'Descreva o que deve ser excluído...',
            duration: 'Duração',
            aspectRatio: 'Proporção de Tela',
            uploading: 'Enviando...',
            clickToUploadReference: 'Clique para enviar imagem de referência',
            clickToUploadEndFrame: 'Clique para enviar imagem do quadro final',
            remove: 'Remover',
            creditsRequired: 'Créditos Necessários:',
            remaining: 'Restantes:',
            generate: 'Gerar',
            generating: 'Gerando...',
            demoPrompt: 'Prompt de Demonstração',
            demoPromptExample: 'Use a imagem de beco sci-fi enviada como primeiro quadro. Mantenha o mesmo beco, letreiros de neon, reflexos e a mulher de capuz caminhando para longe. Mova a câmera lentamente para frente pelo beco...',
            model: 'Modelo:',
            durationLabel: 'Duração:',
            introTitle: 'Crie Vídeos IA de Alta Qualidade com Kling 2.5 Padrão',
            featuresBadge: 'Recursos Principais',
            featuresTitle: 'O que {name} pode fazer?',
            faqTitle: 'FAQ',
            errorPromptRequired: 'Por favor, insira um prompt',
            errorImageRequired: 'Imagem de referência é obrigatória no modo imagem-para-vídeo',
            errorGenerationFailed: 'Falha na geração',
            errorRequestFailed: 'Falha na requisição, por favor tente novamente',
            errorUploadFailed: 'Falha no envio, por favor tente novamente',
            features: [
                {
                    icon: '🎬',
                    title: 'Texto/Imagem para Vídeo',
                    desc: 'Suporta tanto texto-para-vídeo quanto imagem-para-vídeo com opções de duração de 5s/10s.'
                },
                {icon: '⚡', title: 'Saída Confiável', desc: 'Modelo padrão maduro com desempenho estável.'},
                {icon: '💰', title: 'Ótimo Custo-Benefício', desc: 'Menor consumo de créditos em comparação com modelos superiores.'},
                {icon: '📐', title: 'Múltiplas Proporções', desc: 'Suporta 1:1, 16:9 e 9:16.'},
                {icon: '💼', title: 'Licença Comercial', desc: 'O conteúdo gerado pode ser usado comercialmente.'}
            ],
            faq: [
                {
                    q: 'Qual a diferença entre Kling 2.5 e Kling 2.6?',
                    a: 'Kling 2.5 é otimizado para custo e produtividade, enquanto Kling 2.6 oferece capacidades gerais mais fortes.'
                },
                {
                    q: 'Como o Kling 2.5 funciona?',
                    a: 'Insira um prompt ou envie uma imagem de referência, e o Kling 2.5 gera o vídeo correspondente.'
                },
                {q: 'Os vídeos gerados podem ser usados comercialmente?', a: 'Sim, as saídas do Kling 2.5 podem ser usadas comercialmente.'}
            ]
        },
        viduq3pro: {
            title: 'Vídeo IA Vidu Q3 Pro',
            desc: 'Vidu Q3 Pro suporta texto-para-vídeo e imagem-para-vídeo com resolução, duração de 1 a 16s, proporções de tela e áudio opcional.',
            imageUrlHint: 'Apenas URLs de imagem HTTPS são aceitas (o envio retorna uma URL pública). A proporção de tela da imagem deve estar entre 1:4 e 4:1.',
            lengthLabel: 'Duração (segundos)',
            optional: 'Opcional',
            tagHighQuality: 'Alta qualidade',
            tagLength: '1–16 segundos',
            tagResolution: 'Até 2K',
            demoPromptExample: 'Uma calçada à beira-mar ao amanhecer, corredores, gaivotas sobre a água, um veleiro ao longe.',
            features: [
                {icon: '🎬', title: 'Texto e imagem', desc: 'Gere a partir de um prompt ou de uma imagem de referência.'},
                {icon: '📐', title: 'Proporções de tela', desc: 'Modo texto: 16:9, 9:16, 1:1, 4:3, 3:4.'},
                {icon: '⏱️', title: 'Duração flexível', desc: 'Escolha de 1 a 16 segundos.'},
                {icon: '🎵', title: 'Áudio opcional', desc: 'Ative áudio de som natural para o clipe.'},
                {icon: '🎲', title: 'Controle de seed', desc: 'Seed opcional para resultados mais reprodutíveis.'}
            ],
            faq: [
                {q: 'O que imagem-para-vídeo requer?', a: 'Uma URL de imagem HTTPS pública (JPG/PNG). A proporção de tela deve estar entre 1:4 e 4:1.'},
                {q: 'Como os modos texto e imagem diferem?', a: 'O modo texto usa proporção de tela; o modo imagem usa sua URL de imagem e não envia campos de proporção apenas texto.'},
                {q: 'Como os créditos são calculados?', a: 'Conforme os créditos exibidos na página, com base na duração, resolução e configurações de áudio.'}
            ]
        },
        wanAnimate: {
            title: 'Wan Animate',
            desc: 'Anime personagens a partir de uma imagem de referência e vídeo de movimento. Qualidade padrão ou profissional.',
            animateMode: 'Modo de Animação',
            modeAnimate: 'Imagem-para-Ação',
            modeReplace: 'Troca de Personagem no Vídeo',
            referenceVideo: 'Vídeo de Referência',
            quality: 'Modo de Qualidade',
            refImageLabel: 'Imagem de referência',
            refImageHint: 'Personagem ou sujeito para animar (JPG/PNG/JPEG/BMP/WEBP, máx. 5MB, lados 200–4096px, proporção 1:3–3:1).',
            refVideoLabel: 'Vídeo de referência',
            refVideoHint: 'Referência de movimento (MP4/AVI/MOV, 2–30s, máx. 200MB, lados 200–2048px, proporção 1:3–3:1).',
            animateModeLabel: 'Modo de animação',
            btnAnimate: 'Animar',
            animateModeBadgeAnimate: 'Movimento',
            animateModeBadgeReplace: 'Substituir',
            btnAnimateDesc: 'Combine o personagem da imagem com o movimento do vídeo.',
            btnReplace: 'Substituir',
            btnReplaceDesc: 'Substitua o personagem no vídeo pelo personagem da imagem.',
            qualityLabel: 'Modo de qualidade',
            qualityStd: 'Padrão',
            qualityPro: 'Profissional',
            watermarkLabel: 'Marca d\'água',
            uploadVideoRequired: 'Por favor, envie um vídeo de referência.',
            uploadImage: 'Enviar imagem',
            uploadVideo: 'Enviar vídeo',
            uploading: 'Enviando…',
            imageUploadHint: 'JPG, PNG, JPEG, BMP, WEBP · máx. 5MB',
            videoUploadHint: 'MP4, AVI, MOV · 2–30s · máx. 200MB',
            uploadImageRequired: 'Por favor, envie uma imagem de referência.',
            errImageFileTooLarge: 'O arquivo de imagem é muito grande (máx. 5MB).',
            errImageDimensions: 'Largura e altura da imagem devem estar entre 200 e 4096 px.',
            errImageAspect: 'A proporção de tela da imagem deve estar entre 1:3 e 3:1.',
            errImageInvalid: 'Arquivo de imagem inválido ou ilegível.',
            errVideoFileTooLarge: 'O arquivo de vídeo é muito grande (máx. 200MB).',
            errVideoDuration: 'A duração do vídeo deve estar entre 2 e 30 segundos.',
            errVideoDimensions: 'Largura e altura do vídeo devem estar entre 200 e 2048 px.',
            errVideoAspect: 'A proporção de tela do vídeo deve estar entre 1:3 e 3:1.',
            errVideoInvalid: 'Arquivo de vídeo inválido ou ilegível.',
            defaultModelName: 'Wan Animate',
            demoEmptyHint: 'Envie uma imagem de personagem e um vídeo de movimento, e use Wan Animate para criar animações de personagens impressionantes.',
            demoEmptyTitle: 'Animação de Personagem',
            demoStepCharacter: 'Personagem',
            demoStepMotion: 'Movimento',
            demoStepAnimate: 'Animar',
            faqCredits: 'O modo padrão usa menos créditos por geração do que o modo profissional. Veja a linha de créditos acima.',
            characterAnimation: 'Animação de personagem',
            faceSwap: 'Troca de rosto',
            motionTransfer: 'Transferência de movimento',
            identityReplacement: 'Substituição de identidade',
            motionAccuracy: 'Alta fidelidade de movimento',
            features: [
                {icon: '🎭', title: 'Dois modos', desc: 'Animação por transferência de movimento ou substituição completa de personagem.'},
                {icon: '📐', title: 'DashScope oficial', desc: 'Alimentado por Wan 2.2 Animate na Alibaba Cloud.'},
                {icon: '⚡', title: 'Padrão / Pro', desc: 'Escolha qualidade padrão ou profissional por tarefa.'},
                {icon: '💧', title: 'Marca d\'água opcional', desc: 'Ative ou desative marca d\'água na saída.'}
            ],
            faq: [
                {q: 'Quais entradas são necessárias?', a: 'Uma URL de imagem HTTPS pública e URL de vídeo após envio. Imagens e vídeos devem atender aos limites de tamanho e proporção de tela.'},
                {q: 'Qual a diferença entre Animar e Substituir?', a: 'Animar aplica o movimento do vídeo ao personagem da sua imagem. Substituir troca o personagem no vídeo pelo personagem da sua imagem.'},
                {q: 'Como os créditos são calculados?', a: 'O modo profissional custa mais que o modo padrão por geração, conforme exibido na página.'}
            ]
        },
        hailuo: {
            title: 'Gerador de Vídeos IA Hailuo 2.3',
            desc: 'Hailuo 2.3 é um modelo de vídeo IA de próxima geração projetado para geração de vídeos criativos e de alta qualidade.',
            demoPromptExample: 'Um plano cinematográfico de ondas quebrando em uma costa rochosa ao pôr do sol, luz dourada refletindo na água...',
            highQuality: 'Alta Qualidade',
            highQualityOutput: 'Saída de Alta Qualidade',
            features: [
                {icon: '🎬', title: 'Texto para Vídeo', desc: 'Gere vídeos de alta qualidade diretamente a partir de prompts de texto.'},
                {
                    icon: '✨',
                    title: 'Aprimoramento de Prompt',
                    desc: 'O aprimoramento de prompt ajuda a melhorar a consistência e qualidade.'
                },
                {icon: '🌊', title: 'Estilo Criativo', desc: 'Ideal para conteúdo de vídeo criativo e artístico.'},
                {icon: '⚡', title: 'Geração Rápida', desc: 'Pipeline otimizado para resultados mais rápidos.'},
                {icon: '🎨', title: 'Qualidade Visual', desc: 'Produz saída visual detalhada e estável.'},
                {icon: '💼', title: 'Licença Comercial', desc: 'O conteúdo gerado pode ser usado comercialmente.'}
            ],
            faq: [
                {
                    q: 'Como o Hailuo 2.3 funciona?',
                    a: 'Insira um prompt ou envie uma imagem de referência e o modelo gera o vídeo correspondente.'
                },
                {
                    q: 'O que é aprimoramento de prompt?',
                    a: 'O aprimoramento de prompt reescreve e enriquece os prompts para melhor qualidade de geração.'
                },
                {
                    q: 'Os vídeos gerados podem ser usados comercialmente?',
                    a: 'Sim, as saídas do Hailuo 2.3 podem ser usadas comercialmente.'
                },
                {
                    q: 'Quantos créditos cada geração custa?',
                    a: 'Cada geração é cobrada de acordo com as regras atuais de créditos do modelo.'
                }
            ]
        },
        runway: {
            title: 'Gerador de Vídeos IA Runway',
            desc: 'Runway é um modelo de vídeo IA profissional com controles flexíveis para proporção, duração e seed.',
            demoPromptExample: 'Ao anoitecer, as silhuetas de guindastes em um canteiro de obras em Singapura destacam-se contra um pôr do sol brilhante. Vários operários de construção usando capacetes estão guardando suas ferramentas, preparando-se para ir embora...',
            professional: 'Profissional',
            multiOption: 'Múltiplas Opções',
            highQuality: 'Alta Qualidade',
            multiFormat: 'Múltiplas Proporções',
            reproducibleSeed: 'Seed Reproduzível',
            features: [
                {
                    icon: '🎬',
                    title: 'Imagem para Vídeo',
                    desc: 'Envie uma imagem de referência e um prompt para gerar vídeos de alta qualidade rapidamente.'
                },
                {icon: '📐', title: 'Múltiplas Proporções', desc: 'Suporta 16:9, 9:16, 1:1, 4:3, 3:4 e 21:9.'},
                {icon: '🎲', title: 'Controle de Seed', desc: 'Use seed para reproduzir resultados de geração semelhantes.'},
                {
                    icon: '⚡',
                    title: 'Saída Profissional',
                    desc: 'Saída consistente adequada para fluxos de trabalho profissionais e comerciais.'
                },
                {icon: '🖼️', title: 'Animação de Imagem', desc: 'Transforme imagens estáticas em planos de vídeo dinâmicos.'},
                {icon: '💼', title: 'Licença Comercial', desc: 'O conteúdo gerado pode ser usado comercialmente.'}
            ],
            faq: [
                {
                    q: 'Como o Runway funciona?',
                    a: 'Envie uma imagem de referência e insira um prompt; o modelo gera o vídeo correspondente.'
                },
                {q: 'Quais proporções de tela são suportadas?', a: '16:9, 9:16, 1:1, 4:3, 3:4 e 21:9 são suportadas.'},
                {q: 'Os vídeos gerados podem ser usados comercialmente?', a: 'Sim, as saídas do Runway podem ser usadas comercialmente.'}
            ]
        }
    },
    privacy: {
        title: 'Política de Privacidade',
        lastUpdated: 'Última atualização: 15 de Janeiro de 2025',
        navTerms: 'Termos de Serviço →',
        navTrust: 'Confiança e Segurança →',
        sections: [
            {
                title: '1. Coleta de Informações',
                paragraphs: ['Coletamos informações que você fornece ao se registrar e usar nossos serviços, incluindo endereço de e-mail, nome de usuário e informações de pagamento.', 'Também coletamos automaticamente dados de uso como endereço IP, tipo de navegador, horário de acesso e recursos utilizados.']
            },
            {
                title: '2. Uso de Informações',
                paragraphs: ['Usamos as informações coletadas para fornecer, manter e melhorar nossos serviços, processar transações, enviar notificações relacionadas ao serviço e prevenir fraudes e abusos.', 'Não vendemos suas informações pessoais a terceiros.']
            },
            {
                title: '3. Conteúdo Gerado por IA',
                paragraphs: ['Imagens que você envia e prompts que você insere são usados exclusivamente para gerar o conteúdo solicitado e não são usados para treinar modelos de IA.', 'O conteúdo gerado é armazenado temporariamente em nossos servidores para download e excluído conforme nossa política de retenção de dados.']
            },
            {
                title: '4. Segurança de Dados',
                paragraphs: ['Empregamos medidas de segurança padrão da indústria para proteger suas informações pessoais, incluindo criptografia SSL, controles de acesso e auditorias de segurança regulares.', 'Embora façamos o nosso melhor para proteger seus dados, nenhum método de transmissão pela internet é 100% seguro.']
            },
            {
                title: '5. Uso de Cookies',
                paragraphs: ['Usamos cookies e tecnologias similares para melhorar a experiência do usuário, analisar o uso e fornecer conteúdo personalizado.', 'Você pode gerenciar as preferências de cookies nas configurações do seu navegador. Desativar cookies pode afectar alguns recursos.']
            },
            {
                title: '6. Serviços de Terceiros',
                paragraphs: ['Podemos usar provedores de serviços de terceiros para nos auxiliar na prestação de serviços, como processamento de pagamentos, análise de dados e suporte ao cliente.', 'Esses provedores de serviços de terceiros só acessam suas informações pessoais na medida necessária para realizar serviços para nós.']
            },
            {
                title: '7. Seus Direitos',
                paragraphs: ['Você tem o direito de acessar, corrigir ou excluir suas informações pessoais. Você também tem o direito de solicitar que restrinjamos o processamento de seus dados ou transfiramos seus dados para outro serviço.', 'Para exercer esses direitos, entre em contato conosco em miral_support@miralvis.com. Responderemos à sua solicitação em até 30 dias.']
            },
            {
                title: '8. Conformidade com GDPR',
                paragraphs: ['Para usuários no Espaço Econômico Europeu, cumprimos os requisitos do Regulamento Geral de Proteção de Dados (GDPR). Nossa base legal para processar seus dados inclui execução de contrato, interesses legítimos e seu consentimento.']
            },
            {
                title: '9. Entre em Contato',
                paragraphs: ['Se você tiver alguma dúvida ou preocupação sobre nossa política de privacidade, entre em contato com nossa equipe de proteção de dados em miral_support@miralvis.com.']
            }
        ]
    },
    terms: {
        title: 'Termos de Serviço',
        lastUpdated: 'Última atualização: 15 de Janeiro de 2025',
        navPrivacy: 'Política de Privacidade →',
        navTrust: 'Confiança e Segurança →',
        sections: [
            {
                title: '1. Visão Geral do Serviço',
                paragraphs: ['Miral (doravante referida como "a Plataforma") é uma plataforma de IA que integra criação de imagens, vídeos e músicas. Estes Termos de Serviço (doravante referidos como "Termos") regem as condições e regras para o uso da Plataforma.', 'Ao usar a Plataforma, você concorda em estar vinculado a estes Termos. Se não concordar, por favor, não use a Plataforma.']
            },
            {
                title: '2. Registro de Conta',
                paragraphs: ['Você deve ter pelo menos 18 anos para registrar uma conta. Você precisa fornecer informações de registro precisas e completas e é responsável por manter a segurança da conta.', 'Você é responsável por todas as atividades realizadas através de sua conta. Se descobrir qualquer uso não autorizado, notifique-nos imediatamente.']
            },
            {
                title: '3. Uso do Serviço',
                paragraphs: ['A Plataforma fornece serviços de geração de conteúdo por IA baseados em créditos. Créditos podem ser obtidos através de assinatura ou compra única. Diferentes modelos de IA e recursos consomem diferentes quantidades de créditos.', 'Você concorda em não usar a Plataforma para fins ilegais, prejudiciais ou infratores. A geração de conteúdo ilegal, pornográfico, violento ou infrator de direitos é proibida.']
            },
            {
                title: '4. Propriedade Intelectual',
                paragraphs: ['Os direitos de propriedade intelectual do conteúdo que você gera através da Plataforma pertencem a você, sujeitos aos termos de uso de cada provedor de modelo de IA.', 'As marcas comerciais, logotipos, designs de interface e código de software da Plataforma são protegidos por leis de propriedade intelectual e não podem ser usados sem autorização.']
            },
            {
                title: '5. Pagamento e Reembolso',
                paragraphs: ['Todos os pagamentos são em dólares americanos. As taxas de assinatura são cobradas mensal ou anualmente, dependendo do plano escolhido.', 'Para primeiras compras de pacotes únicos ou primeiras assinaturas, reembolsos podem ser solicitados em até 7 dias corridos se o uso de créditos for inferior a 3%.']
            },
            {
                title: '6. Isenção de Responsabilidade',
                paragraphs: ['A Plataforma fornece serviços "como estão" e não oferece garantias expressas ou implícitas sobre a disponibilidade, precisão ou adequação dos serviços.', 'O conteúdo gerado por IA pode ser impreciso ou imperfeito. Os usuários devem julgar a aplicabilidade do conteúdo gerado por si mesmos.']
            },
            {
                title: '7. Limitação de Responsabilidade',
                paragraphs: ['Na máxima extensão permitida por lei, a Plataforma não é responsável por quaisquer danos diretos, indiretos, incidentais ou consequentes resultantes do uso ou incapacidade de usar os serviços.', 'A responsabilidade total da Plataforma não excede o total de taxas que você pagou nos últimos 12 meses.']
            },
            {
                title: '8. Modificação dos Termos',
                paragraphs: ['Reservamo-nos o direito de modificar estes Termos a qualquer momento. Os Termos modificados entram em vigor quando publicados nesta página.', 'O uso continuado da Plataforma indica aceitação dos Termos modificados. Alterações significativas serão notificadas por e-mail ou notificação da Plataforma.']
            },
            {
                title: '9. Entre em Contato',
                paragraphs: ['Se você tiver alguma dúvida sobre estes Termos, entre em contato conosco em miral_support@miralvis.com.']
            }
        ]
    },
    trustSafety: {
        tag: '🛡️ Confiança e Segurança',
        title: 'A Segurança dos Seus Dados é Nossa Prioridade',
        subtitle: 'Saiba como protegemos sua privacidade e segurança de dados.',
        badges: [
            {
                icon: '🛡️',
                title: 'Sem Treinamento de IA',
                desc: 'Seu conteúdo enviado e obras geradas nunca são usados para treinar modelos de IA.'
            },
            {
                icon: '🔒',
                title: 'Criptografia Ponta a Ponta',
                desc: 'Todas as transferências de dados usam criptografia TLS 1.3, dados armazenados usam criptografia AES-256.'
            },
            {
                icon: '✓',
                title: 'Conformidade com GDPR',
                desc: 'Totalmente em conformidade com os requisitos do Regulamento Geral de Proteção de Dados da UE.'
            },
            {
                icon: '🗑️',
                title: 'Controle dos Seus Dados',
                desc: 'Você pode exportar ou excluir todos os seus dados a qualquer momento, incluindo exclusão de conta.'
            }
        ],
        sections: [
            {
                title: 'Transparência no Processamento de Dados',
                paragraphs: ['Somos completamente transparentes sobre como lidamos com dados. Imagens e vídeos enviados são usados apenas para gerar o conteúdo solicitado e excluídos dos servidores em 24 horas após o processamento.', 'O conteúdo gerado é armazenado em sua conta e você pode baixar ou excluir a qualquer momento. Não compartilhamos seu conteúdo sem seu consentimento.']
            },
            {
                title: 'Infraestrutura Segura',
                paragraphs: ['Nossos serviços são implantados em infraestrutura cloud líder mundial com proteção de segurança em múltiplas camadas. Todos os servidores estão em data centers certificados SOC 2 e ISO 27001.', 'Realizamos auditorias de segurança regulares e testes de penetração para garantir a segurança do sistema. Todos os funcionários recebem treinamento rigoroso de segurança.']
            },
            {
                title: 'Segurança de Conteúdo',
                paragraphs: ['Implantamos sistemas avançados de segurança de conteúdo que detectam e bloqueiam automaticamente a geração de conteúdo prejudicial. Isso inclui, mas não se limita a, conteúdo violento, pornográfico e infrator.', 'Se descobrir qualquer conteúdo violador, denuncie em abuse@miral.org.']
            },
            {
                title: 'Conformidade e Certificação',
                paragraphs: ['Cumprimos as principais regulamentações globais de proteção de dados, incluindo GDPR (UE), CCPA (Califórnia) e LGPD (Brasil).', 'Nosso processamento de pagamentos está em conformidade com os padrões PCI DSS, garantindo a segurança das suas informações de pagamento.']
            }
        ],
        ctaTitle: 'Preocupações de Segurança?',
        ctaDesc: 'Nossa equipe de segurança está pronta para responder suas perguntas',
        ctaButton: 'Contatar Equipe de Segurança',
        navTerms: 'Termos de Serviço →',
        navPrivacy: 'Política de Privacidade →'
    },
    gallery: {
        tag: 'Histórico de Criações',
        title: 'Minhas Criações',
        subtitle: 'Veja todo o seu histórico de criações com IA.',
        loginRequired: 'Por favor, faça login para ver seu histórico de criações',
        empty: 'Nenhuma criação ainda',
        loadMore: 'Carregar Mais',
        filters: {
            all: 'Todos',
            pending: 'Processando',
            finish: 'Concluído',
            failed: 'Falhou'
        },
        usePrompt: 'Gerar com este prompt',
        download: 'Baixar',
        status: {
            pending: 'Processando',
            finish: 'Concluído',
            failed: 'Falhou'
        }
    },
    inspiration: {
        title: 'Inspiração',
        subtitle: 'Veja o que criadores estão construindo com o Miral — de imagens hiper-realistas a vídeos cinematográficos, inspiração ao seu alcance.',
        filters: {
            all: 'Todos',
            image: 'Imagem',
            video: 'Vídeo',
            portrait: 'Retrato',
            landscape: 'Paisagem',
            fantasy: 'Fantasia',
            anime: 'Anime'
        }
    },
    profile: {
        joinTime: 'Membro desde',
        tabs: {
            account: 'Conta',
            billing: 'Faturamento',
            privacy: 'Dados e Privacidade'
        },
        balance: {
            title: 'Visão Geral do Saldo',
            available: 'Créditos Disponíveis'
        },
        subscription: {
            currentPlan: 'Plano Atual',
            status: 'Status',
            activated: 'Ativado',
            cancelled: 'Cancela no final do período atual',
            pending: 'Processando',
            failed: 'Pagamento Falhou',
            expiryDate: 'Válido Até',
            permanent: 'Permanente',
            upgradePlan: 'Atualizar ou Trocar Plano',
            cancelPlan: 'Cancelar Assinatura',
            cancelNote: 'Sua assinatura permanece ativa até o final do período de cobrança atual',
            cancelWarning: 'Sua assinatura será cancelada. Você pode continuar usando todos os recursos até',
            restorePlan: 'Restaurar Assinatura'
        },
        upgrade: {
            title: 'Atualizar',
            desc: 'Obtenha acesso ilimitado e benefícios exclusivos',
            btn: 'Ver Planos'
        },
        billing: {
            title: 'Histórico de Pagamentos',
            subtitle: 'Veja seus registros de pagamento e baixe faturas',
            empty: 'Sem registros de faturamento ainda',
            creditsPack: 'Pacote de Créditos',
            oneTime: 'Único',
            monthly: 'Mensal',
            yearly: 'Anual',
            refresh: 'Atualizar',
            plan: 'Plano',
            date: 'Data',
            amount: 'Valor',
            invoice: 'Fatura',
            download: 'Baixar',
            invoiceModal: {
                title: 'Detalhes da Fatura',
                orderInfo: 'Informações do Pedido',
                invoiceInfo: 'Informações da Fatura',
                plan: 'Plano',
                date: 'Data do Pagamento',
                amount: 'Valor',
                paymentId: 'ID do Pedido',
                close: 'Fechar',
                download: 'Baixar Fatura',
                fullName: 'Nome Completo',
                fullNamePlaceholder: 'Digite seu nome completo',
                email: 'E-mail',
                emailPlaceholder: 'Digite seu e-mail',
                company: 'Empresa',
                companyPlaceholder: 'Razão social da empresa',
                taxId: 'CNPJ/CPF',
                taxIdPlaceholder: 'Digite o CNPJ/CPF',
                addressLine1: 'Endereço Linha 1',
                addressLine1Placeholder: 'Endereço da rua',
                addressLine2: 'Endereço Linha 2',
                addressLine2Placeholder: 'Apto, suíte, etc. (opcional)',
                city: 'Cidade',
                cityPlaceholder: 'Cidade',
                province: 'Estado',
                provincePlaceholder: 'Estado',
                postalCode: 'CEP',
                postalCodePlaceholder: 'CEP',
                country: 'País',
                countryPlaceholder: 'País',
                invoiceRemarks: 'Observações',
                invoiceRemarksPlaceholder: 'Observações da fatura',
                optional: 'opcional',
                required: 'Este campo é obrigatório'
            }
        },
        privacy: {
            title: 'Configurações de Privacidade',
            cardTitle: 'Seus Dados Estão Protegidos',
            cardSubtitle: 'Nosso compromisso com sua privacidade e segurança de dados',
            item1: 'Seus dados nunca são usados para treinamento de modelos de IA',
            item2: 'Transmissão e armazenamento de dados totalmente criptografados',
            item3: 'Obras geradas são excluídas automaticamente após o período de armazenamento',
            item4: 'Sem loops de feedback, sem uso secundário de dados derivados',
            item5: 'Conformidade rigorosa com regulamentações de proteção de dados'
        },
        support: {
            title: 'Precisa de Ajuda?',
            desc: 'Nossa equipe de suporte está aqui para ajudar',
            btn: 'Contatar Suporte',
            note: 'miral_support@miralvis.com · Resposta em até 24 horas'
        }
    },
    payment: {
        success: {
            title: 'Pagamento Bem-Sucedido',
            message: 'Obrigado pela sua compra! Seu pedido foi processado com sucesso e os créditos foram adicionados à sua conta.',
            goHome: 'Ir para Início',
            viewProfile: 'Ver Perfil'
        },
        cancel: {
            title: 'Pagamento Cancelado',
            message: 'Seu pagamento foi cancelado. Se tiver alguma dúvida, sinta-se à vontade para contatar nossa equipe de suporte.',
            tryAgain: 'Tentar Novamente',
            goHome: 'Ir para Início'
        }
    },
    seo: {
        default: {
            title: 'Miral - Gerador de Imagens, Vídeos e Músicas com IA',
            description: 'Miral é uma plataforma completa de criação com IA, suportando modelos como Seedream 4, Midjourney, GPT Image, Veo 3 e Sora 2. Crie imagens, vídeos e músicas incríveis sem esforço.',
            keywords: 'gerador de imagens IA, gerador de vídeos IA, gerador de músicas IA, texto para imagem, texto para vídeo, Seedream, Midjourney, Veo, Sora, Miral'
        },
        home: {
            title: 'Miral: gerador de imagens, vídeos e músicas com IA',
            description: 'Crie imagens, vídeos e músicas excelentes no Miral com modelos líderes como Seedream 5, Midjourney, Veo 3.1, Sora 2 e outros, tudo em uma única plataforma.'
        },
        pricing: {
            title: 'Preços - Plataforma de Criação IA Miral',
            description: 'Miral oferece planos de preços flexíveis para todas as suas necessidades criativas. Compre créditos, pague pelo uso, sem assinatura obrigatória.'
        },
        profile: {
            title: 'Perfil - Miral',
            description: 'Gerencie sua conta Miral, veja histórico de pedidos e registros de criação.'
        },
        models: {
            title: 'Modelos de IA - Miral',
            description: 'Explore os melhores modelos de IA na plataforma Miral, incluindo modelos de geração de imagens, vídeos e músicas.',
            wan25: {
                title: 'Wan 2.5 - Modelo de Vídeo IA Poderoso',
                description: 'Wan 2.5 oferece geração de vídeo IA de nível superior. Crie vídeos realistas e suaves com movimento e detalhes avançados, perfeito para criadores e empresas.'
            },
            wan26: {
                title: 'Wan 2.6 - Gerador de Vídeo IA Aprimorado',
                description: 'Aprimore sua criação de vídeos com Wan 2.6. Este modelo de IA avançado gera vídeos ultrarrealistas com movimento, detalhes e velocidade melhorados para conteúdo profissional.'
            },
            wan22: {
                title: 'Wan 2.2 - Gerador de Vídeo IA Rápido',
                description: 'Wan 2.2 é um modelo de vídeo IA rápido e confiável. Gere vídeos de alta qualidade rapidamente, ideal para criadores que precisam de produção de conteúdo rápida e profissional.'
            },
            wanAnimate: {
                title: 'Wan Animate - Animação de Personagem - Miral',
                description: 'Anime personagens com imagem de referência e vídeo de movimento via Alibaba Wan 2.2 Animate.'
            },
            veo30: {
                title: 'Veo 3.0 - Modelo de Vídeo IA Líder',
                description: 'Veo 3.0 é um gerador de vídeo IA de primeira linha. Crie vídeos cinematográficos e realistas com IA avançada, perfeito para criação de conteúdo profissional e marketing.'
            },
            veo31: {
                title: 'Veo 3.1 - Geração de Vídeo IA de Ponta',
                description: 'Veo 3.1 é um modelo de vídeo IA líder para vídeos impressionantes e realistas. Crie clipes cinematográficos, animações e conteúdo com qualidade e velocidade incomparáveis.'
            },
            kling26: {
                title: 'Kling 2.6 - Modelo de Vídeo IA Premium',
                description: 'Kling 2.6 traz geração de vídeo IA profissional à vida. Gere vídeos suaves e de alta qualidade com IA avançada para criadores, profissionais de marketing e empresas.'
            },
            kling3: {
                title: 'Kling 3 - Gerador de Vídeo IA - Miral',
                description: 'Gere vídeos IA de alta qualidade com o modelo Kling 3.'
            },
            kling25: {
                title: 'Kling 2.5 - Modelo de Vídeo IA Confiável',
                description: 'Kling 2.5 oferece poderosa geração de vídeo IA para criadores. Faça vídeos de alta qualidade com movimento e detalhes suaves, perfeito para conteúdo e marketing.'
            },
            seedance: {
                title: 'Seedance AI - Gerador de Vídeo IA Avançado',
                description: 'Gere vídeos IA de alta qualidade com Seedance AI. Crie clipes impressionantes, animações e conteúdo cinematográfico com modelos de IA de ponta para resultados rápidos e profissionais.'
            },
            sora2: {
                title: 'Gerador de Vídeo IA Sora 2 – Texto e Imagem para Vídeo | Miral',
                description: 'Crie vídeos Sora 2 de texto ou imagens no Miral. Teste com créditos grátis e escolha 4–12 s, 720p/1080p e formato 16:9/9:16.'
            },
            hailuo23: {
                title: 'Hailuo 2.3 - Gerador de Vídeo IA Inteligente',
                description: 'Hailuo 2.3 oferece geração de vídeo IA inteligente. Crie vídeos criativos e de alta qualidade com IA avançada para criadores de conteúdo e empresas.'
            },
            viduq3pro: {
                title: 'Vidu Q3 Pro - Gerador de Vídeo IA - Miral',
                description: 'Crie texto-para-vídeo e imagem-para-vídeo com Vidu Q3 Pro, múltiplas resoluções e durações.'
            },
            runway: {
                title: 'Runway - Plataforma de Criação de Vídeo IA',
                description: 'Runway é uma plataforma de vídeo IA líder para criadores. Edite, gere e aprimore vídeos com ferramentas IA poderosas, perfeita para produção de conteúdo profissional.'
            },
            nanobanana: {
                title: 'Nano Banana - Gerador de Imagens IA - Miral',
                description: 'Gere rapidamente imagens criativas com o modelo Nano Banana.'
            },
            seedream4: {
                title: 'Seedream 4 - Gerador de Imagens IA',
                description: 'Crie imagens IA impressionantes e de alta resolução com Seedream 4. Gere arte fotorrealista, ilustrações e designs com IA avançada para trabalho criativo profissional.'
            },
            seedream5: {
                title: 'Seedream 5 - Gerador de Imagens IA ByteDance - Miral',
                description: 'Gere imagens IA de alta qualidade com o modelo ByteDance Seedream 5.'
            },
            midjourney: {
                title: 'Midjourney - Gerador de Arte IA',
                description: 'Midjourney é um gerador de arte IA líder. Crie imagens, arte e designs impressionantes a partir de prompts de texto, perfeito para artistas, designers e criadores de conteúdo.'
            },
            gptimage1: {
                title: 'GPT-Image-1 - Modelo de Imagem IA da OpenAI',
                description: 'GPT-Image-1 da OpenAI gera imagens IA de alta qualidade a partir de texto. Crie visuais realistas e criativos para design, marketing e criação de conteúdo.'
            },
            gptimage15: {
                title: 'GPT Image 1.5 - Gerador de Imagens IA da OpenAI - Miral',
                description: 'Gere imagens IA de alta qualidade com o modelo OpenAI GPT Image 1.5.'
            },
            fluxpro11ultra: {
                title: 'Flux Pro 1.1 Ultra - Gerador de Imagens IA Premium',
                description: 'Flux Pro 1.1 Ultra oferece geração de imagens IA de qualidade ultra-alta. Crie imagens fotorrealistas e detalhadas com IA avançada para design e arte profissional.'
            },
            fluxschnell: {
                title: 'Flux Schnell - Gerador de Imagens IA Rápido',
                description: 'Flux Schnell é um gerador de imagens IA ultrarrápido. Crie imagens de alta qualidade rapidamente, ideal para criadores que precisam de conteúdo visual rápido e profissional.'
            },
            flux2: {
                title: 'FLUX.2 - Gerador de Imagens IA - Miral',
                description: 'Gere imagens IA de qualidade profissional com o modelo FLUX.2 — 5 variantes para velocidade, qualidade e controle.'
            },
            zimageturbo: {
                title: 'Z Image Turbo - Gerador de Imagens IA - Miral',
                description: 'Gere imagens de alta resolução com o modelo Z Image Turbo.'
            }
        },
        tools: {
            title: 'Ferramentas de Imagem IA - Miral',
            description: 'Miral oferece várias ferramentas de processamento de imagens com IA, incluindo remoção de marca d\'água, remoção de fundo, aprimoramento de imagens e mais.',
            watermarkRemover: {
                title: 'Removedor de marca d\'água online com IA | Miral',
                description: 'Remova online marcas d\'água, logotipos, datas, textos e rascunhos de fotos com IA. Preserve os detalhes e exporte resultados limpos em JPG, PNG ou WebP.'
            },
            backgroundRemover: {
                title: 'Removedor de fundo com IA grátis online | Miral',
                description: 'Remova fundos de imagens grátis com IA. Recorte retratos e produtos, preserve cabelo e bordas e crie PNG transparente a partir de JPG, PNG ou WebP.'
            },
            imageEraser: {
                title: 'Apagador de Imagem IA - Remover Objetos de Fotos',
                description: 'Apague objetos, pessoas, marcas d\'água e texto indesejados de fotos com IA. Passe o pincel sobre a área e a IA a remove perfeitamente, preenchendo o espaço com conteúdo natural. Perfeito para limpar imagens.'
            },
            objectRemover: {
                title: 'Remover Objetos IA - Remover Objetos de Fotos',
                description: 'Remova objetos indesejados de fotos com IA. Passe o pincel sobre o objeto e a IA o remove perfeitamente, preenchendo a área com conteúdo natural. Perfeito para limpar suas fotos.'
            },
            aiPersonRemover: {
                title: 'Remover Pessoas IA - Remover Pessoas de Fotos',
                description: 'Remova pessoas de fotos com IA. Passe o pincel sobre qualquer pessoa e a IA a remove perfeitamente, preenchendo a área com conteúdo natural. Perfeito para remover transeuntes e estranhos das suas fotos.'
            },
            'whiteBackground': {
                title: 'Fundo Branco IA - Substituir Fundo da Imagem por Branco',
                description: 'Substitua fundos de imagens por branco puro automaticamente usando IA. Ideal para fotos de produtos de e-commerce, fotos de documento e imagens de catálogo.'
            },
            'blueBackground': {
                title: 'Fundo Azul IA - Substituir Fundo da Imagem por Azul',
                description: 'Substitua fundos de imagens por azul puro automaticamente usando IA. Ideal para fotos de passaporte, fotos de documento e documentos oficiais.'
            },
            faceSwap: {
                title: 'Troca de Rosto IA - Trocar Rostos em Fotos',
                description: 'Troque rostos em fotos com IA. Envie uma foto alvo e um rosto de origem para mesclar rostos perfeitamente com resultados realistas e naturais.'
            },
            imageEnhancer: {
                title: 'Aprimorador de Imagem IA - Aumentar Resolução e Aprimorar Fotos',
                description: 'Aprimore e aumente a resolução de imagens com IA. Nitidez de detalhes, correção de desfoque, aumento de resolução e restauração de fotos antigas para resultados profissionais de alta qualidade.'
            },
            docCropEnhance: {
                title: 'Recorte e correção de documentos com IA | Miral',
                description: 'Recorte e corrija documentos, provas, tarefas e livros online. Ajuste inclinação, perspectiva, páginas curvas e sombras para obter digitalizações nítidas.'
            },
            handwrittenErase: {
                title: 'Removedor de escrita em provas e tarefas com IA | Miral',
                description: 'Apague respostas manuscritas de provas, tarefas e cadernos com IA sem remover o texto impresso. Inclui rotação, recorte e correção de páginas.'
            }
        },
        music: {
            title: 'Gerador de Música IA - Miral',
            description: 'Crie músicas únicas a partir de descrições de texto usando a geração de música IA do Miral.'
        },
        inspiration: {
            title: 'Inspiração - Miral',
            description: 'Navegue pelas obras em destaque da comunidade Miral e obtenha inspiração para criação com IA.'
        },
        gallery: {
            title: 'Minha Galeria - Miral',
            description: 'Visualize e gerencie todas as suas criações na plataforma Miral.'
        },
        faq: {
            title: 'FAQ - Miral',
            description: 'Perguntas frequentes sobre a plataforma Miral para ajudá-lo a começar com a criação com IA.'
        },
        about: {
            title: 'About Us - Miral',
            description: 'Learn about the Miral AI platform for image, video, and music creation.'
        },
        contact: {
            title: 'Contact Us - Miral',
            description: 'Contact Miral support for help and feedback.'
        },
        terms: {
            title: 'Termos de Serviço - Miral',
            description: 'Termos de serviço e acordo do usuário da plataforma Miral.'
        },
        privacy: {
            title: 'Política de Privacidade - Miral',
            description: 'Política de privacidade e declaração de proteção de dados da plataforma Miral.'
        },
        trustSafety: {
            title: 'Confiança e Segurança - Miral',
            description: 'Políticas de confiança e segurança da plataforma Miral.'
        },
    imageModels: {
            title: "Modelos de imagem com IA - Miral",
            description: "Explore os melhores modelos de imagem com IA no Miral e gere imagens impressionantes a partir de descrições de texto.",
            relatedModelsTitle: "Explore Mais Modelos de Imagem com IA",
            demoPrompt: "Texto de Instrução",
            demoOutput: "Imagem gerada",
            demoPlaceholder: "Imagem de exemplo — em breve",
            promptLabel: "Criar com",
            usePrompt: "Use este prompt →",
            imagePlaceholder: "Exemplo de Imagem de IA",
            replaceImageHint: "Gerado a partir do prompt exibido ao lado desta imagem",
            flux1: {
                title: "Gerador de Imagens FLUX.1 AI Gratuito Online | Miral",
                description: "Crie imagens de IA de alta qualidade online com o FLUX.1 usando o Flux Pro 1.1 Ultra ou o Flux Schnell. Explore nove proporções de tela, estilos visuais e créditos gratuitos.",
                heroHeadline: "Gerador de Imagens de IA FLUX.1",
                heroIntro: "Use o gerador de imagens FLUX.1 AI da Black Forest Labs gratuitamente no Miral AI. Cadastre-se para receber créditos gratuitos e escolha entre a saída de alta qualidade do Flux Pro 1.1 Ultra e a criação rápida e com vários estilos do Flux Schnell.",
                eyebrow: "Black Forest Labs · FLUX.1",
                sectionKicker: "FLUX.1",
                ctaTag: "FLUX.1 · Miral",
                badges: ["Texto para imagem", "9 Proporções de Aspecto", "Pro e Schnell", "Fotografia / Arte Digital / Anime"],
                previewLabel: "Flux Pro 1.1 Ultra",
                previewMeta: ["1:1", "16:9", "9:16", "9 proporções"],
                previewTitle: "Escolha entre qualidade refinada e exploração criativa rápida",
                previewDesc: "Use o Pro 1.1 Ultra para visuais detalhados ou o Schnell para explorar rapidamente direções fotográficas, de arte digital e de anime.",
                keyFeaturesTitle: "Crie visuais de alta qualidade com o gerador de texto para imagem FLUX.1",
                keyFeaturesIntro: "Explore os recursos do Flux Pro 1.1 Ultra e do Flux Schnell para uma compreensão rápida, velocidade de saída, estilos visuais e proporções flexíveis.",
                exploreTitle: "Explore Mais Modelos de Imagem com IA",
                mainFeaturesTitle: "FLUX.1 Recursos",
                generatedImageLabel: "Imagem gerada",
                versionLabel: "Versão",
                featureLabel: "Principais Recursos",
                useCaseLabel: "Ideal para",
                controlsTitle: "Escolha o Modelo, a Proporção e o Estilo Visual Adequados",
                controlsIntro: "Use o Flux Pro 1.1 Ultra para imagens finais refinadas ou o Flux Schnell para uma exploração mais rápida e, em seguida, ajuste a proporção e o estilo ao canal desejado.",
                galleryTitle: "Mais exemplos de imagens FLUX.1",
                discussionTitle: "Perguntas comuns de seleção do FLUX.1",
                communityTitle: "Formas populares de criar com o FLUX.1",
                tutorialPrompt: "Uma livraria tranquila em uma estufa à beira-mar ao nascer do sol, luminárias de leitura aconchegantes, prateleiras de carvalho claro, reflexos suaves no chão, fotografia de interiores realista.",
                qualityBenefits: [
                    "Renderize materiais, iluminação e profundidade espacial com um acabamento mais refinado.",
                    "Siga instruções detalhadas que combinam assunto, composição, câmera e estilo.",
                    "Explore direções fotográficas, de arte digital e de anime a partir de instruções de texto claras."
                ],
                features: [
                    { name: "Texto para Imagem de Alta Qualidade FLUX.1", short: "Transforme instruções escritas em visuais detalhados e profissionais.", desc: "O Flux Pro 1.1 Ultra é adequado para trabalhos em que detalhes da imagem, materiais, iluminação e acabamento geral são importantes. Descrever claramente o assunto, a composição, a câmera e o estilo ajuda a direcionar a imagem para o seu projeto.", demo: { type: 'table', rows: [
                        { prompt: "Exterior de um hotel boutique no deserto durante a hora azul, paredes de taipa, luz quente da janela, gramíneas nativas, sombras longas, fotografia arquitetônica realista.", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "Fotografia editorial de ravióli artesanal em um prato preto fosco, azeite de manjericão, guardanapo de linho, luz direcional da janela, pouca profundidade de campo.", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "Geração rápida com Flux Schnell", short: "Crie rascunhos rápidos, teste prompts e explore ideias rapidamente.", desc: "Flux Schnell é ideal para fluxos de trabalho que precisam de testes rápidos de composição, estilo ou conceito. Gere um rascunho, revise a direção e refine o prompt para uma nova iteração.", prompt: "Um conceito de estande modular de papelão para uma startup ecológica, pedestais de produtos simples, texturas de papel reciclado, iluminação brilhante para exposições, layout limpo.", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "Nove proporções de imagem", short: "Abrange formatos ultra-amplos, paisagem, quadrado, retrato e vertical.", desc: "O Flux Pro 1.1 Ultra e o Flux Schnell suportam as proporções 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 e 9:21 para banners, imagens de produtos, conteúdo para redes sociais, pôsteres e visuais para dispositivos móveis.", prompt: "Um observatório alpino panorâmico 21:9 acima de um mar de nuvens, plataforma de observação de vidro, luz da manhã, pequenos caminhantes para dar escala, pintura matte cinematográfica.", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "Múltiplos Estilos Visuais em Schnell", short: "Escolha Automático, Fotográfico, Arte Digital ou Anime.", desc: "O Flux Schnell oferece direções de estilo Automático, Fotográfico, Arte Digital e Anime, facilitando a alternância entre visuais fotorrealistas, ilustrados e de anime sem precisar trocar de modelo.", demo: { type: 'table', rows: [
                        { prompt: "Estilo fotográfico: um mecânico de bicicletas ajustando uma bicicleta de corrida vintage em uma garagem ensolarada, mãos manchadas de graxa, reflexos cromados realistas.", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "Estilo anime: um aconchegante café de gatos dentro de um trem suspenso, nuvens em tons pastel de pôr do sol do lado de fora das janelas, personagens expressivos e arte com linhas limpas.", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "Casos de Uso Criativos Flexíveis", short: "Crie visuais de produtos, marketing, retratos, conceitos e redes sociais.", desc: "A família FLUX.1 oferece suporte a imagens de produtos e marcas refinadas, bem como conceitos de campanha rápidos, retratos, designs de ambientes e proporções específicas da plataforma.", prompt: "Visual de lançamento de tênis sustentável com textura de tecido reciclado, detalhes de cadarço flutuantes, fundo gradiente verde musgo, espaço vazio ousado para texto de anúncio em redes sociais.", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "Instrução Exemplos",
                showcaseTitle: "Exemplos de prompts do FLUX.1 para melhores imagens de IA",
                showcaseIntro: "Use estes prompts do FLUX.1 como ponto de partida. Descreva claramente o assunto, a composição, a iluminação, a câmera, os materiais, a paleta de cores e o estilo visual.",
                variantsKicker: "Guia de modelos",
                variantsTitle: "Flux Pro 1.1 Ultra vs Flux Schnell",
                variantsIntro: "Escolha um modelo FLUX.1 com base na qualidade, velocidade e controle de estilo que seu projeto precisa.",
                variants: [
                    { name: "Flux Pro 1.1 Ultra", tag: "Alta qualidade", desc: "Projetado para trabalhos detalhados, realistas e refinados de texto para imagem, com nove proporções de aspecto suportadas.", bestFor: "Ideal para fotografia de produtos, imagens principais de campanhas e visuais finais refinados." },
                    { name: "Flux Schnell", tag: "Rápido", desc: "Projetado para iteração rápida com nove proporções e estilos Automático, Fotográfico, Arte Digital e Anime.", bestFor: "Ideal para rascunhos, testes de prompts, conteúdo para redes sociais e exploração rápida." }
                ],
                useCasesKicker: "Feito para trabalho de verdade",
                useCasesTitle: "Casos de Uso Populares do FLUX.1",
                useCases: [
                    { name: "FLUX.1 para fotografia de produto", desc: "Crie imagens principais de produtos, cenas de estilo de vida e conceitos visuais para e-commerce." },
                    { name: "FLUX.1 para Marketing e Publicidade", desc: "Gere anúncios para redes sociais, banners de campanhas e visuais de marketing com a sua marca." },
                    { name: "FLUX.1 para retratos fotorrealistas", desc: "Crie retratos com aparência fotográfica, com iluminação, fundos e composição controlados." },
                    { name: "FLUX.1 para arte digital", desc: "Use o Schnell para explorar rapidamente as direções de ilustração, fantasia e arte digital." },
                    { name: "FLUX.1 para Imagens de Anime", desc: "Use o estilo Schnell Anime para personagens e cenas de anime." },
                    { name: "FLUX.1 para arte conceitual", desc: "Explore ambientes cinematográficos, cenas de jogos, personagens e mundos visuais." },
                    { name: "FLUX.1 para Imagens de Mídias Sociais", desc: "Use nove proporções para conteúdo de plataforma em paisagem, quadrado e retrato." },
                    { name: "FLUX.1 para pôsteres e banners", desc: "Escolha uma proporção adequada para eventos, promoções e conceitos de layout de página para dispositivos móveis." }
                ],
                howToKicker: "Três simples Etapas",
                howToTitle: "Como usar o gerador de imagens FLUX.1 AI online gratuitamente",
                howToIntro: "Cadastre-se para receber créditos gratuitos e usar o Flux Pro 1.1 Ultra ou o Flux Schnell online no Miral.",
                howToSteps: [
                    { title: "Insira uma solicitação detalhada", desc: "Descreva o assunto, o cenário, a composição, a iluminação, a câmera, os materiais, as cores e o estilo desejado." },
                    { title: "Escolha o modelo e a proporção", desc: "Escolha Pro 1.1 Ultra para qualidade refinada ou Schnell para exploração rápida e, em seguida, defina uma proporção e um estilo Schnell." },
                    { title: "Gere e refine", desc: "Gere a imagem, revise e baixe-a ou ajuste a descrição, a proporção ou o estilo para outra versão." }
                ],
                howToCta: "Use o gerador de imagens de IA FLUX.1 gratuitamente",
                faqTitle: "Perguntas frequentes sobre o FLUX.1",
                faqs: [
                    { q: "O que é o gerador de imagens FLUX.1 AI?", a: "FLUX.1 é uma família de modelos de geração de imagens da Black Forest Labs. No Miral, use o Flux Pro 1.1 Ultra e o Flux Schnell para transformar prompts de texto em imagens de produtos, marketing, retratos, animes e artes conceituais." },
                    { q: "Posso usar o gerador de imagens FLUX.1 AI gratuitamente?", a: "Sim. Cadastre-se para receber créditos gratuitos e comece a criar imagens de alta qualidade com o gerador de imagens FLUX.1 AI imediatamente. A geração de imagens utiliza os créditos correspondentes." },
                    { q: "Qual a diferença entre Flux Pro 1.1 Ultra e Flux Schnell?", a: "O Flux Pro 1.1 Ultra é adequado para imagens finais refinadas, onde detalhes e acabamento são importantes. O Flux Schnell é adequado para rascunhos rápidos, testes de prompts e exploração de vários estilos, com os estilos Automático, Fotográfico, Arte Digital e Anime." },
                    { q: "Quais proporções de imagem o FLUX.1 suporta?", a: "O Flux Pro 1.1 Ultra e o Flux Schnell no Miral suportam 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 e 9:21, totalizando nove proporções." },
                    { q: "Quais estilos o Flux Schnell suporta?", a: "O Flux Schnell oferece suporte aos modos Automático, Fotográfico, Arte Digital e Anime para correspondência automática, imagens fotorrealistas, ilustração digital e visuais de anime." },
                    { q: "Como uso o gerador de imagens FLUX.1 AI online?", a: "Insira um texto, escolha Flux Pro 1.1 Ultra ou Flux Schnell e defina uma proporção. Com o Schnell, você também pode selecionar um estilo visual antes de clicar em Gerar." },
                    { q: "Quais são os melhores exemplos de prompts do FLUX.1?", a: "Os prompts eficazes do FLUX.1 descrevem claramente o assunto, o cenário, a composição, a iluminação, a câmera, os materiais, a paleta de cores e o estilo desejado. Use os exemplos desta página como ponto de partida e adapte-os ao seu projeto." },
                    { q: "FLUX.1 vs FLUX.2: qual devo usar?", a: "Escolha FLUX.1 para obter resultados refinados com o Flux Pro 1.1 Ultra ou criação rápida de vários estilos com o Flux Schnell. Escolha a página FLUX.2 no Miral quando precisar das variantes Klein, Max, Pro e Flex." },
                    { q: "FLUX.1 vs Midjourney: qual devo usar?", a: "FLUX.1 é ideal para proporções de aspecto explícitas, o fluxo de trabalho rápido do Schnell ou a saída refinada do Pro 1.1 Ultra. O Midjourney pode ser mais adequado para usuários que preferem seus estilos artísticos, fluxo de trabalho com imagens de referência e processo criativo." }
                ],
                ctaTitle: "Use o FLUX.1 gratuitamente no Miral!",
                ctaDesc: "Cadastre-se para receber créditos gratuitos. Escolha Flux Pro 1.1 Ultra ou Flux Schnell e crie imagens com a proporção e o estilo que seu projeto precisa."
            },
            flux2: {
                title: "Gerador de imagens com IA FLUX.2 gratuito online | Miral",
                description: "Crie imagens de IA fotorrealistas online com o FLUX.2. Escolha entre cinco variantes de modelo para fotos de produtos, pôsteres, obras de arte e visuais de marketing refinados.",
                heroHeadline: "Gerador de Imagens de IA FLUX.2",
                heroIntro: "Use o gerador de imagens FLUX.2 AI da Black Forest Labs gratuitamente no Miral AI. Cadastre-se para receber créditos gratuitos e crie instantaneamente imagens fotorrealistas de alta qualidade, fotografia de produtos, pôsteres e recursos visuais de marketing.",
                eyebrow: "Black Forest Labs · FLUX.2",
                sectionKicker: "FLUX.2",
                ctaTag: "FLUX.2 · Miral",
                badges: ["Texto para imagem", "Fotorrealista", "Tipografia Precisa", "Múltiplas proporções de aspecto"],
                previewLabel: "FLUX.2",
                previewMeta: ["1:1", "1024 × 1024", "PNG"],
                previewTitle: "De um estímulo preciso para um visual pronto para produção",
                previewDesc: "Crie fotos detalhadas de produtos, conceitos de campanha, retratos e designs ricos em texto em um fluxo de trabalho simplificado.",
                keyFeaturesTitle: "Crie visuais profissionais com o gerador de texto para imagem FLUX.2",
                keyFeaturesIntro: "Explore os principais recursos do gerador de imagens FLUX.2 AI para obter instruções precisas, detalhes refinados, resultados realistas e controle visual confiável.",
                exploreTitle: "Explore Mais Modelos de Imagem com IA",
                mainFeaturesTitle: "Principais recursos do FLUX.2",
                generatedImageLabel: "Imagem gerada",
                versionLabel: "Versão",
                featureLabel: "Principais Recursos",
                useCaseLabel: "Ideal para",
                controlsTitle: "Escolha a versão e as configurações de saída corretas do FLUX.2",
                controlsIntro: "Use Klein para iteração rápida, Max para a melhor qualidade final, Pro para fluxos de trabalho de produção ou Flex para tipografia e controle de detalhes finos.",
                galleryTitle: "Mais exemplos de imagens FLUX.2",
                discussionTitle: "Modelo FLUX.2 comum Perguntas",
                communityTitle: "Formas populares de criar com o FLUX.2",
                tutorialPrompt: "Fotografia de campanha premium de um frasco de perfume esmeralda translúcido sobre calcário claro, luz suave da manhã, refração realista do vidro, tipografia refinada e amplo espaço negativo.",
                qualityBenefits: [
                    "Siga instruções detalhadas com maior controle sobre o assunto, a composição, a iluminação e o estilo.",
                    "Crie texturas realistas, profundidade e detalhes refinados para trabalhos visuais profissionais.",
                    "Gerencie pôsteres, rótulos de produtos e gráficos de campanhas com muito texto, utilizando uma tipografia mais clara."
                ],
                features: [
                    { name: "Síntese de Imagem de Alta Qualidade", short: "Oferece maior agilidade e qualidade de imagem sem latência adicional.", desc: "O FLUX.2 aprimora significativamente o alinhamento de prompts e suporta até mesmo entradas de formato longo, como roteiros detalhados e descrições de cenas. Ele garante que as imagens geradas ofereçam maior fidelidade sem comprometer a velocidade, o que reduz a necessidade de ajustes iterativos e permite que os criadores cheguem a um resultado final mais rapidamente.", demo: { type: 'table', rows: [
                        { prompt: "Uma paisagem deslumbrante com cores vibrantes e detalhes intrincados, mostrando um pôr do sol sobre uma cordilheira.",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "Arte abstrata para tradução entre linguagens funcionais e linguagens de baixo nível." ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "Um retrato de personagem de anime/desenho animado, detalhado e bem feito, mas com aparência humana." ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "Detalhes e Realismo Superiores", short: "Produz texturas, iluminação e profundidade realistas para visuais com qualidade de estúdio.", desc: "O FLUX.2 captura texturas finas, iluminação realista e profundidade natural que fazem com que as imagens geradas pareçam genuinamente fotográficas. Isso o torna ideal para fotos de produtos, retratos e visuais cinematográficos onde a credibilidade é fundamental.", prompt: "Fotografia de estúdio de um relógio mecânico prateado sobre ardósia escura, iluminação lateral suave, textura realista de metal escovado, pouca profundidade de campo, reflexos sutis, composição editorial premium." ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "Forte Precisão", short: "Segue instruções complexas de perto, incluindo assuntos, estilos e composição específicos.", desc: "O FLUX.2 interpreta instruções em camadas e com várias partes com uma precisão impressionante — lidando com assuntos específicos, estilos de arte, paletas de cores e instruções de composição em uma única geração. Isso dá aos criadores mais controle e menos retrabalho ao descrever exatamente o que desejam.", prompt: "Um bonde vermelho atravessando uma praça europeia chuvosa ao entardecer, três ciclistas em primeiro plano, janelas de um café aconchegante à esquerda, céu azul na hora azul, composição simétrica, fotografia cinematográfica.",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "Manipulação Avançada de Tipografia", short: "Renderiza texto em imagens com ortografia mais limpa e consistência de estilo.", desc: "O FLUX.2 oferece geração e controle de texto aprimorados em imagens, com maior consistência no estilo da fonte. Isso possibilita a produção de materiais e sinalização baseados em texto para pôsteres, anúncios, quadrinhos e identidade visual de marcas com muito menos artefatos.", demo: { type: 'table', rows: [
                        { prompt: "Uma bela foto de paisagem mística com o texto \"FLUX 2\", beleza sutil, incorporando mirtilos." ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "Um bolo Floresta Negra com a inscrição \"FLUX 2 Pro\", saboroso, fotografia gastronômica." ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "Geração Rápida e Escalável", short: "Escolha entre iteração em menos de um segundo e saída de qualidade máxima.", desc: "O FLUX.2 abrange modelos Klein rápidos e variantes Pro, Max e Flex focadas em produção. Essa variedade o torna prático para rascunhos rápidos, produção de conteúdo em lote e ativos criativos ou de marketing com qualidade final.", prompt: "Uma foto editorial limpa de um frasco de perfume verde translúcido sobre calcário, com luz suave da manhã, sombras sutis e estética de campanha premium." ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "Instrução Exemplos",
                showcaseTitle: "Exemplos de prompts do FLUX.2 para imagens de IA aprimoradas",
                showcaseIntro: "Use estes exemplos de prompts do FLUX.2 como ponto de partida, personalize o assunto, a composição, a iluminação e o estilo e, em seguida, envie seu prompt diretamente para o gerador.",
                variantsKicker: "Guia de modelos",
                variantsTitle: "Comparação de modelos FLUX.2: Klein vs Max vs Pro vs Flex",
                variantsIntro: "Compare o FLUX.2 Klein, Max, Pro e Flex para escolher o modelo de imagem de IA certo para iteração rápida, ativos de qualidade final, escala de produção ou controle preciso de tipografia.",
                variants: [
                    { name: "FLUX.2 Klein 4B / 9B", tag: "Mais rápido", desc: "Escolha FLUX.2 Klein para geração rápida de imagens em grande volume, rascunhos e prototipagem rápida.", bestFor: "Ideal para rascunhos, lotes e iteração rápida" },
                    { name: "FLUX.2 Max", tag: "Qualidade máxima", desc: "Escolha FLUX.2 Max para os arquivos finais, o acompanhamento mais preciso das instruções e geração consistente.", bestFor: "Ideal para campanhas premium e imagens de destaque" },
                    { name: "FLUX.2 Pro", tag: "Produção", desc: "Escolha o FLUX.2 Pro para um equilíbrio de nível profissional entre qualidade de imagem, tempo de resposta e saída escalável.", bestFor: "Ideal para marketing e produção de conteúdo" },
                    { name: "FLUX.2 Flex", tag: "Controle", desc: "Escolha FLUX.2 Flex para guia ajustável, tipografia, renderização de texto e preservação de pequenos detalhes.", bestFor: "Ideal para pôsteres, rótulos e recursos de design" }
                ],
                useCasesKicker: "Feito para trabalho de verdade",
                useCasesTitle: "Casos de uso populares do FLUX.2",
                useCases: [
                    { name: "FLUX.2 para Fotografia de Produto", desc: "Crie fotos de produtos refinadas, cenas de estilo de vida e variações de imagens para e-commerce." },
                    { name: "FLUX.2 para marketing e publicidade", desc: "Transforme conceitos de campanha em anúncios para redes sociais, banners e visuais de marca consistentes." },
                    { name: "FLUX.2 para pôsteres e tipografia", desc: "Use a renderização de texto FLUX.2 para produzir títulos, rótulos, pôsteres e gráficos baseados em texto mais claros." },
                    { name: "FLUX.2 para retratos fotorrealistas", desc: "Gere retratos detalhados com IA, com iluminação, estilo e composição controlados." },
                    { name: "FLUX.2 para Arte Conceitual", desc: "Explore ambientes cinematográficos, personagens e direções visuais rapidamente." },
                    { name: "FLUX.2 para design editorial", desc: "Crie ilustrações e capas diferenciadas para artigos e apresentações." }
                ],
                howToKicker: "Três simples Etapas",
                howToTitle: "Como usar o gerador de imagens de IA FLUX.2 online",
                howToIntro: "Use o gerador de imagens FLUX.2 AI online no Miral para passar de um texto detalhado para uma imagem gerada.",
                howToSteps: [
                    { title: "Digite sua mensagem", desc: "Descreva o assunto, a composição, a iluminação, as cores, o estilo e qualquer texto que você queira que apareça na imagem." },
                    { title: "Escolha as configurações do FLUX.2", desc: "Abra o gerador, selecione Klein, Max, Pro ou Flex e, em seguida, escolha o tamanho de saída que melhor se adapta ao seu projeto." },
                    { title: "Gere sua imagem", desc: "Inicie a geração, revise o resultado e baixe a imagem ou refine seu texto para obter outra versão." }
                ],
                howToCta: "Experimente o gerador de imagens FLUX.2 AI",
                faqTitle: "Perguntas frequentes sobre o FLUX.2",
                faqs: [
                    { q: "O que é FLUX.2?", a: "FLUX.2 é o modelo de IA de texto para imagem de última geração da Black Forest Labs. Ele transforma instruções escritas em imagens detalhadas de alta qualidade e está disponível no Miral para criação visual de arte, design, marketing e produtos diretamente no seu navegador." },
                    { q: "Que ferramenta posso usar para criar fotografias de produtos e imagens de marketing ricas em texto?", a: "O FLUX.2 combina coerência imediata, detalhes, fotorrealismo e tratamento tipográfico para fotografia profissional de produtos e recursos visuais de marketing ricos em texto que exigem fidelidade e precisão." },
                    { q: "Posso usar o gerador de imagens FLUX.2 AI gratuitamente?", a: "Sim. Cadastre-se para receber créditos gratuitos e comece a criar imagens de alta qualidade com o gerador de imagens FLUX.2 AI imediatamente. A geração de imagens utiliza os créditos correspondentes." },
                    { q: "Como uso o gerador de imagens FLUX.2 AI online?", a: "Insira um texto detalhado, escolha FLUX.2 Klein, Max, Pro ou Flex, selecione um tamanho de imagem e clique em Gerar. O FLUX.2 funciona bem para materiais de marketing, fotografia de produtos, conceitos cinematográficos, conteúdo para redes sociais e designs de pôsteres." },
                    { q: "Quanto tempo leva para gerar o FLUX.2?", a: "O tempo de geração depende da variante FLUX.2 selecionada, do tamanho da imagem e da carga atual do serviço. O Klein foi projetado para iterações muito rápidas, enquanto o Max, o Pro e o Flex priorizam diferentes equilíbrios entre qualidade e controle." },
                    { q: "Como corrigir uma imagem do FLUX.2 que não segue minhas instruções?", a: "Descreva o assunto, o cenário, a composição, a iluminação, a câmera ou o estilo artístico, as cores e qualquer texto necessário de forma mais explícita. Use os exemplos de prompts do FLUX.2 nesta página como ponto de partida e personalize-os para o seu projeto." },
                    { q: "Qual modelo FLUX.2 devo escolher?", a: "Escolha FLUX.2 Klein para rascunhos e lotes rápidos, Max para ativos finais da mais alta qualidade, Pro para geração de imagens em escala de produção ou Flex quando a tipografia e o controle preciso forem mais importantes." },
                    { q: "FLUX.2 Max vs Pro: qual a diferença?", a: "O FLUX.2 Max prioriza a máxima qualidade, o acompanhamento preciso das instruções e a geração consistente. O FLUX.2 Pro equilibra a qualidade de nível profissional, prazos de entrega mais rápidos e a escalabilidade da produção para fluxos de trabalho criativos do dia a dia." },
                    { q: "FLUX.2 vs Midjourney: qual devo usar?", a: "Escolha com base no fluxo de trabalho, em vez de um vencedor universal. O FLUX.2 é uma ótima opção para seguir instruções com precisão, tipografia, visuais de produtos e produção baseada em API. O Midjourney pode ser mais adequado para criadores que preferem seu fluxo de trabalho artístico diferenciado e ferramentas da comunidade." }
                ],
                ctaTitle: "Experimente o FLUX.2 gratuitamente no Miral!",
                ctaDesc: "Insira sua ideia acima e use o gerador de imagens FLUX.2 AI para criar imagens detalhadas com a variante do modelo que se adapta ao seu fluxo de trabalho."
            },
            seedream: {
                title: "Gerador de Imagens Seedream AI Gratuito Online | Miral",
                description: "Gere imagens de IA de alta qualidade online com o Seedream. Obtenha compreensão precisa e imediata, renderização de texto nítida e saída detalhada de 2K a 4K para projetos criativos.",
                heroHeadline: "Gerador de imagens Seedream AI",
                heroIntro: "Use o gerador de imagens de IA da Seedream gratuitamente. Cadastre-se para receber créditos gratuitos e crie instantaneamente recursos visuais de produtos, pôsteres, retratos e imagens de marketing de alta qualidade.",
                eyebrow: "ByteDance Seed · Seedream AI",
                sectionKicker: "Seedream AI",
                ctaTag: "Seedream · Miral",
                badges: ["Texto para imagem", "Compreensão da intenção", "Saída 2K / 3K / 4K", "Renderização de texto nítida"],
                previewLabel: "Seedream AI",
                previewMeta: ["1:1", "2K / 3K / 4K", "Tamanho personalizado"],
                previewTitle: "Da intenção criativa a um visual preciso e de alta resolução",
                previewDesc: "Crie composições complexas, fotos de produtos, retratos e designs ricos em texto com detalhes refinados e controle preciso das linhas de comando.",
                keyFeaturesTitle: "Crie visuais precisos com o Gerador de Texto para Imagem Seedream AI",
                keyFeaturesIntro: "Explore os recursos de IA do Seedream para uma compreensão mais profunda da intenção, composição complexa, saída em alta resolução, detalhes realistas e renderização precisa de texto por meio da geração de texto para imagem.",
                exploreTitle: "Explore os modelos de IA da Seedream",
                mainFeaturesTitle: "Principais recursos de texto para imagem do Seedream AI",
                seedream5Desc: "Utilize o modelo mais recente do Seedream para obter instruções precisas, realismo refinado, renderização de texto e saída em alta resolução.",
                seedream4Desc: "Abra o fluxo de trabalho estabelecido do Seedream 4 para criação confiável de texto para imagem e configurações de saída flexíveis.",
                features: [
                    { name: "Compreensão mais aprofundada do texto", short: "Interpreta a intenção criativa, as relações espaciais e as instruções detalhadas.", desc: "A IA da Seedream vai além da simples correspondência de termos isolados em um prompt. Ela raciocina sobre as relações entre assuntos, layout, atributos e contexto visual para produzir resultados mais coerentes a partir de instruções de texto complexas.", demo: { type: 'table', rows: [
                        { prompt: "Uma prateleira de exibição 3x3, vista frontal, com nove objetos diferentes organizados por material e cor, iluminação de estúdio consistente e alinhamento espacial preciso.", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "Foto editorial de um relógio ao lado de um linho dobrado e uma xícara de cerâmica, composição triangular equilibrada, luz suave da manhã.", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "Uma cena cinematográfica de mercado com compradores em primeiro plano, um sujeito central claro, profundidade em camadas e luz quente refletida no pavimento molhado.", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "Controle de composição complexa", short: "Lida com múltiplos assuntos, atributos e layouts estruturados com maior coerência.", desc: "O gerador de imagens Seedream AI segue instruções de várias partes em cenas complexas, ajudando a preservar os atributos, posições, cores e relações dos objetos solicitados em uma única composição.", prompt: "Uma cena editorial frontal com três vasos de cerâmica de formatos diferentes sobre plataformas de pedra escalonadas, uma esfera vermelha atrás do vaso mais alto, iluminação lateral suave, espaçamento equilibrado e fundo neutro de estúdio.", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "Saída em 2K, 3K e 4K", short: "Selecione uma resolução de saída com base nos detalhes e dimensões que seu projeto precisa.", desc: "O Seedream AI oferece suporte a saídas selecionáveis ​​em 2K, 3K e 4K no Miral, além de tamanhos de imagem personalizados. Escolha com base nas dimensões e no nível de detalhes necessários para o seu uso final.", prompt: "Uma ampla paisagem cinematográfica de uma cidade costeira futurista ao nascer do sol, arquitetura em camadas, água reflexiva, profundidade atmosférica, detalhes intrincados de edifícios, composição panorâmica.", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "Renderização de texto aprimorada", short: "Cria textos mais nítidos para pôsteres, layouts, etiquetas e gráficos de apresentação.", desc: "O Seedream AI combina raciocínio visual com criação de texto aprimorada, tornando-o útil para pôsteres, gráficos de apresentação, anúncios, conceitos de embalagem e outros layouts onde o texto legível faz parte da imagem.", demo: { type: 'table', rows: [
                        { prompt: "Pôster minimalista de evento com o título \"DESIGN FOR TOMORROW\", tipografia geométrica em negrito, fundo branco e grade de destaque verde.", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "Pacote de café premium com a etiqueta \"MIRAL ROAST\", notas de degustação concisas, textura de papel quente, fotografia de produto em estúdio.", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "Detalhes e Realismo Refinados", short: "Produz iluminação, materiais, profundidade e apresentação do produto convincentes.", desc: "A IA da Seedream renderiza texturas refinadas e iluminação coerente para fotografia de produtos, retratos, visuais editoriais e conceitos cinematográficos onde clareza e estrutura crível são importantes.", prompt: "Uma foto editorial limpa de um frasco de perfume verde translúcido sobre calcário, com luz suave da manhã, sombras sutis e estética de campanha premium.", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "Instrução Exemplos",
                showcaseTitle: "Exemplos de prompts do Seedream AI para melhores imagens de IA",
                showcaseIntro: "Use estes exemplos de prompts do Seedream AI como ponto de partida. Descreva claramente os assuntos, as relações espaciais, o texto, a iluminação e o layout e, em seguida, envie o prompt diretamente para o gerador.",
                variantsKicker: "Guia de resolução",
                variantsTitle: "Guia de Resolução do Seedream AI: 2K vs 3K vs 4K",
                variantsIntro: "Escolha uma resolução de saída do Seedream AI com base na rapidez com que deseja iterar e na quantidade de detalhes que o recurso final exige.",
                variants: [
                    { name: "2K", tag: "Saída padrão", desc: "Uma solução prática para conteúdo de redes sociais, trabalhos criativos do dia a dia e layouts digitais padrão.", bestFor: "Ideal para conteúdo digital regular" },
                    { name: "3K", tag: "Mais detalhes", desc: "Adiciona mais detalhes à imagem e suporta layouts maiores para trabalhos de marketing e apresentação.", bestFor: "Ideal para materiais de marketing e apresentações" },
                    { name: "4K", tag: "Detalhes máximos", desc: "Use a predefinição mais alta quando texturas finas, layouts com muito texto ou qualidade de entrega premium forem importantes.", bestFor: "Ideal para campanhas finais e saída em alta resolução" }
                ],
                useCasesKicker: "Feito para trabalho de verdade",
                useCasesTitle: "Casos de uso populares do Seedream AI",
                useCases: [
                    { name: "IA da Seedream para fotografia de produtos", desc: "Crie fotos de produtos profissionais, cenas de estilo de vida e conceitos de imagens para e-commerce." },
                    { name: "Seedream AI para Marketing", desc: "Transforme ideias de campanhas estruturadas em anúncios para redes sociais, banners e elementos visuais da marca." },
                    { name: "Seedream AI para pôsteres e textos", desc: "Crie conceitos de pôsteres, gráficos de apresentação, rótulos e layouts baseados em texto." },
                    { name: "Seedream AI para composições complexas", desc: "Organize vários assuntos e atributos solicitados em uma estrutura visual coerente." },
                    { name: "IA da Seedream para arte conceitual", desc: "Explore ambientes cinematográficos, personagens e instruções visuais detalhadas." },
                    { name: "Seedream AI para visuais editoriais", desc: "Crie capas, ilustrações, infográficos e imagens prontas para apresentações." }
                ],
                howToKicker: "Três simples Etapas",
                howToTitle: "Como usar o gerador de imagens Seedream AI online gratuitamente",
                howToIntro: "Cadastre-se para receber créditos gratuitos e usar o gerador de imagens Seedream AI online com instruções claras e a resolução exigida pelo seu projeto.",
                howToSteps: [
                    { title: "Insira sua Ideia Criativa", desc: "Descreva os assuntos, as relações espaciais, a composição, a iluminação, o estilo e o texto necessário da forma mais clara possível." },
                    { title: "Escolha a resolução e o tamanho", desc: "Abra o gerador e selecione 2K, 3K, 4K ou um tamanho personalizado compatível com base no seu uso final." },
                    { title: "Gerar e revisar", desc: "Inicie a geração, revise a composição e os detalhes e, em seguida, baixe o resultado ou ajuste suas instruções." }
                ],
                howToCta: "Use o gerador de imagens Seedream AI gratuitamente",
                faqTitle: "Perguntas frequentes sobre o Seedream AI",
                faqs: [
                    { q: "O que é o gerador de imagens Seedream AI?", a: "O Seedream AI é um modelo inteligente de criação de imagens da equipe Seed da ByteDance. No Miral, ele transforma instruções de texto detalhadas em imagens de alta resolução para design, marketing, conceitos de produtos, pôsteres e recursos visuais editoriais." },
                    { q: "Que ferramenta posso usar para criar pôsteres de alta resolução com texto nítido?", a: "A IA do Seedream combina uma compreensão mais profunda da intenção, composição precisa, criação de texto aprimorada e saída selecionável em alta resolução para pôsteres e outros layouts ricos em texto." },
                    { q: "Posso usar o gerador de imagens Seedream AI gratuitamente?", a: "Sim. Cadastre-se para receber créditos gratuitos e comece a criar imagens de alta qualidade com o gerador de imagens Seedream AI imediatamente. A geração de imagens usa os créditos correspondentes." },
                    { q: "Como uso o gerador de imagens Seedream AI online?", a: "Insira um texto detalhado, escolha a saída em 2K, 3K ou 4K, selecione opcionalmente um tamanho personalizado e clique em Gerar. Para melhores resultados, descreva claramente os assuntos, as relações espaciais, os atributos, a iluminação, o texto e o layout." },
                    { q: "O Seedream AI suporta imagens em 2K, 3K e 4K?", a: "Sim. O Miral disponibiliza predefinições de resolução 2K, 3K e 4K para o Seedream AI, além de dimensões personalizadas compatíveis para diferentes proporções e necessidades de distribuição." },
                    { q: "Como corrigir imagens do Seedream com texto ou composição incorretos?", a: "Descreva o assunto, as relações entre os objetos, a composição, a iluminação, as cores, o estilo e o texto necessário de forma mais explícita. Use os exemplos do Seedream nesta página como ponto de partida e declare cada requisito visual claramente." },
                    { q: "Qual resolução de IA devo escolher no Seedream?", a: "Escolha 2K para conteúdo digital padrão, 3K quando layouts de marketing ou apresentação precisarem de mais detalhes e 4K quando o máximo de detalhes for importante para grandes campanhas finais, pôsteres ou recursos de design premium." },
                    { q: "Seedream AI vs Midjourney: qual devo usar?", a: "O Seedream AI é uma ótima opção para instruções estruturadas, composições complexas, layouts ricos em texto e saída de alta resolução selecionável no Miral. O Midjourney pode ser mais adequado para criadores que preferem seu fluxo de trabalho artístico diferenciado e ferramentas da comunidade." }
                ],
                ctaTitle: "Use o Seedream AI gratuitamente no Miral!",
                ctaDesc: "Cadastre-se para receber créditos gratuitos. Descreva sua ideia, escolha a resolução adequada e use o gerador de imagens Seedream AI para criar visuais precisos e de alta resolução."
            },
            gptImage: {
                title: "Gerador de Imagens com IA GPT Image Gratuito Online | Miral",
                description: "Gere imagens de IA de alta qualidade online com GPT Image e GPT-Image-1.5 no Miral AI. Escolha tamanhos e níveis de qualidade práticos para pôsteres, produtos e retratos.",
                heroHeadline: "Gerador de imagens GPT Image AI",
                heroIntro: "Use o gerador de imagens GPT Image AI gratuitamente no Miral AI. Cadastre-se para receber créditos grátis e crie instantaneamente imagens de produtos, pôsteres, retratos e recursos visuais de marketing de alta qualidade com o GPT-Image-1.5.",
                eyebrow: "OpenAI · GPT-Image-1.5",
                sectionKicker: "Imagem GPT",
                ctaTag: "GPT Image · Miral",
                badges: ["Texto para imagem", "Qualidade Selecionável", "Paisagem / Retrato / Quadrado", "Entendimento Preciso de Precisão"],
                previewLabel: "GPT-Image-1.5",
                previewMeta: ["1024 × 1024", "1536 × 1024", "1024 × 1536"],
                previewTitle: "De uma ideia escrita a uma imagem de IA refinada e prática",
                previewDesc: "Use instruções claras e qualidade selecionável para criar visuais de produtos, pôsteres, retratos e conteúdo de marca.",
                keyFeaturesTitle: "Crie visuais de alta qualidade com o Gerador de Imagens com IA GPT Image",
                keyFeaturesIntro: "Explore os recursos do GPT-Image-1.5 para compreensão rápida, controle de qualidade, tamanhos de imagem práticos e criação visual profissional.",
                features: [
                    { name: "Prompts de linguagem natural e com vários assuntos", short: "Descreva assuntos, composição, iluminação, estilo e relações visuais em linguagem natural.", desc: "O gerador de imagens GPT Image AI suporta instruções em linguagem natural com múltiplos assuntos, atributos e requisitos de composição. Comece com uma instrução simples ou especifique a posição, a cor e o relacionamento de cada assunto para criar imagens com múltiplos assuntos mais coerentes.", demo: { type: 'table', rows: [
                        { prompt: "Fotografia editorial de um frasco de perfume transparente sobre um pedestal de pedra clara, luz suave da manhã vinda da esquerda, fundo limpo, pouca profundidade de campo, estética de marca premium.", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "Uma rua chuvosa da cidade à noite, três pedestres em primeiro plano segurando guarda-chuvas de cores diferentes, um bonde passando ao longe, neon refletido no pavimento molhado, composição cinematográfica ampla.", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "Controle de Qualidade GPT-Image-1.5", short: "Escolha Automático, Baixo, Médio ou Alto com base na velocidade e nas necessidades de detalhes.", desc: "O GPT-Image-1.5 oferece configurações de qualidade automática, baixa, média e alta. Use a qualidade mais baixa para exploração rápida e a qualidade mais alta para imagens de produtos finais, pôsteres ou materiais de marketing.", prompt: "Anúncio de alta qualidade de um bolo de morango contra um fundo preto, textura cremosa e nítida, luz de contorno suave, fotografia de alimentos detalhada, composição comercial.", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "Três Tamanhos de Imagem Práticos", short: "Crie saídas quadradas, horizontais e verticais.", desc: "Escolha 1024×1024, 1536×1024 ou 1024×1536 para publicações em redes sociais, banners e recursos visuais de apresentação, ou pôsteres na vertical e conteúdo para dispositivos móveis.", prompt: "Um pôster de viagem vertical de 1024×1536 com um penhasco à beira-mar e um farol na névoa da manhã, espaço para um título na parte superior, layout editorial moderno.", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "Criação Clara de Texto e Layout", short: "Crie pôsteres, rótulos e conceitos de marca que incluam texto.", desc: "Ao especificar claramente o texto, o posicionamento, o estilo tipográfico e as relações de layout necessários, o GPT Image pode ajudar a explorar pôsteres, embalagens, gráficos para eventos e imagens de marketing com títulos.", demo: { type: 'table', rows: [
                        { prompt: "Pôster minimalista para evento de tecnologia com o título \"CRIE O FUTURO\", tipo de letra sans-serif em negrito, fundo azul escuro, grade geométrica verde e título centralizado e nítido.", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "Conceito de embalagem de café premium com o texto \"MIRAL ROAST\" na frente, textura de papel marrom quente, rótulo limpo, fotografia de produto em estúdio.", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "Detalhes e realismo", short: "Renderize materiais, iluminação, pessoas e detalhes do produto de forma realista.", desc: "O GPT Image funciona bem para fotografia de produtos, retratos, interiores e visuais editoriais quando o prompt descreve claramente os materiais, as opções de câmera, a iluminação e a profundidade de campo.", prompt: "Retrato editorial em close de um(a) artista de cerâmica sob luz natural da janela, textura de pele realista, pó de argila nas mãos, fundo de oficina, pouca profundidade de campo, fotografia editorial com tons quentes.", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "Instrução Exemplos",
                showcaseTitle: "Exemplos de prompts do GPT Image para imagens de IA melhores",
                showcaseIntro: "Use esses prompts de imagem do GPT como ponto de partida. Descreva claramente o assunto, a composição, a iluminação, o estilo, os materiais e qualquer texto necessário.",
                variantsKicker: "Guia de versões",
                variantsTitle: "GPT-Image-1.5 vs GPT-Image-1",
                variantsIntro: "Escolha uma versão de imagem GPT com base na necessidade de controle de qualidade. Ambas suportam tamanhos práticos de quadrado, paisagem e retrato.",
                variants: [
                    { name: "GPT-Image-1.5", tag: "Recomendado", desc: "Suporta 1024×1024, 1536×1024 e 1024×1536 com opções de qualidade automática, baixa, média e alta.", bestFor: "Ideal para trabalhos diários e profissionais que exigem controle de qualidade" },
                    { name: "GPT-Image-1", tag: "Clássico", desc: "Suporta os mesmos três tamanhos de imagem práticos com um conjunto de controles mais simples.", bestFor: "Ideal para criação de imagens de texto para uso geral e de forma simples" }
                ],
                useCasesKicker: "Feito para trabalho de verdade",
                useCasesTitle: "Casos de uso populares do GPT Image",
                useCases: [
                    { name: "GPT Image para fotografia e mockups de produtos", desc: "Crie imagens de destaque de produtos, cenas de estilo de vida, mockups de produtos e conceitos visuais para e-commerce." },
                    { name: "GPT Image para imagens de listagens de e-commerce", desc: "Explore imagens de listagem de produtos, gráficos de recursos, displays de embalagens e conceitos de publicidade." },
                    { name: "GPT Image para marketing e anúncios em mídias sociais", desc: "Crie anúncios para mídias sociais, banners de campanhas, banners de e-mail e visuais de marketing de marca." },
                    { name: "Imagem GPT para layouts de UI/UX e sites", desc: "Gere conceitos visuais para interfaces de aplicativos, layouts de sites, páginas de destino e páginas de apresentação de produtos." },
                    { name: "GPT Image para infográficos e relatórios visuais", desc: "Explore conceitos de layout para infográficos, relatórios visuais e gráficos de apresentação; verifique todo o texto e dados antes do uso final." },
                    { name: "GPT Image para pôsteres e embalagens de produtos", desc: "Explore pôsteres, rótulos de produtos e designs de embalagens com requisitos de título e layout." },
                    { name: "GPT Image para capas de livros e blogs Imagens", desc: "Crie capas de livros, ilustrações editoriais, cabeçalhos de blog e conceitos visuais para publicações." },
                    { name: "Imagem GPT para Retratos", desc: "Crie retratos editoriais com iluminação, fundos e estilo controlados." },
                    { name: "Gerador de imagens GPT para conceitos de personagens de jogos", desc: "Explore rapidamente personagens de jogos, figurinos, adereços e diferentes direções artísticas." },
                    { name: "GPT Image para ambientes de jogos", desc: "Gere ambientes de jogos, cenas cinematográficas e conceitos de construção de mundo para exploração criativa inicial." },
                    { name: "Imagem GPT para Conteúdo Social", desc: "Gere imagens quadradas, horizontais e verticais para diferentes plataformas." }
                ],
                howToKicker: "Três simples Etapas",
                howToTitle: "Como usar o gerador de imagens GPT Image AI online gratuitamente?",
                howToIntro: "Cadastre-se para receber créditos gratuitos e usar o gerador de imagens GPT Image AI online no Miral.",
                howToSteps: [
                    { title: "Insira uma solicitação detalhada", desc: "Descreva o assunto, cenário, composição, iluminação, estilo, materiais e qualquer texto necessário." },
                    { title: "Escolha o tamanho e a qualidade", desc: "Escolha um formato quadrado, paisagem ou retrato e defina a qualidade GPT-Image-1.5 de acordo com suas necessidades." },
                    { title: "Gerar e revisar", desc: "Inicie a geração, revise e baixe a imagem ou ajuste as instruções e crie outra versão." }
                ],
                howToCta: "Use o gerador de imagens GPT Image AI gratuitamente",
                faqTitle: "Perguntas frequentes sobre o gerador de imagens GPT",
                faqs: [
                    { q: "O que é o gerador de imagens GPT Image AI?", a: "O GPT Image é a família de modelos de texto para imagem de uso geral da OpenAI. No Miral, o gerador de imagens de IA GPT Image transforma instruções escritas em imagens de alta qualidade para design, marketing, conceitos de produtos, pôsteres e conteúdo para redes sociais." },
                    { q: "Posso usar o gerador de imagens GPT Image AI gratuitamente?", a: "Sim. Cadastre-se para receber créditos gratuitos e comece a criar imagens de alta qualidade com o gerador de imagens GPT Image AI imediatamente. A geração de imagens utiliza os créditos correspondentes." },
                    { q: "Como faço para usar o gerador de imagens GPT Image AI online?", a: "Insira um prompt detalhado e escolha 1024×1024, 1536×1024 ou 1024×1536. Com o GPT-Image-1.5, você também pode selecionar qualidade automática, baixa, média ou alta antes de clicar em Gerar." },
                    { q: "Qual é a diferença entre GPT-Image-1.5 e GPT-Image-1?", a: "Ambas as versões suportam os mesmos três tamanhos de imagem práticos. O GPT-Image-1.5 no Miral também oferece controle de qualidade automático, baixo, médio e alto, enquanto o GPT-Image-1 possui um conjunto de parâmetros mais simples." },
                    { q: "Quais tamanhos de imagem o GPT Image suporta?", a: "No Miral, o GPT-Image-1 e o GPT-Image-1.5 suportam imagens quadradas de 1024×1024, paisagens de 1536×1024 e retratos de 1024×1536." },
                    { q: "Qual qualidade de imagem GPT devo escolher?", a: "Escolha baixa ou média ao testar textos rapidamente, alta para imagens de produtos finais, pôsteres ou materiais de marketing e automática quando não tiver certeza. As opções de qualidade se aplicam ao GPT-Image-1.5." },
                    { q: "Como corrigir resultados do GPT Image que não correspondem à minha solicitação?", a: "Descreva o assunto, o cenário, a composição, a iluminação, a câmera, os materiais, o estilo e qualquer texto necessário com mais detalhes. Use os exemplos de imagem GPT nesta página como ponto de partida e adapte-os ao seu projeto." },
                    { q: "Preciso de experiência em engenharia de prompts para usar o GPT Image?", a: "Não. Comece com uma instrução simples em linguagem natural e, em seguida, adicione as posições do sujeito, a composição, a iluminação, as cores, os materiais e os requisitos de texto conforme necessário. Descrições mais claras geralmente ajudam o resultado a corresponder melhor à sua intenção criativa." },
                    { q: "Que ferramenta posso usar para criar imagens de produtos, pôsteres e conceitos de interface de usuário para e-commerce?", a: "O GPT Image pode criar imagens para anúncios de e-commerce, mockups de produtos, pôsteres, conceitos de UI/UX, layouts de sites, layouts de infográficos, capas de livros, imagens para blogs, banners de e-mail e conceitos de jogos. Verifique o texto, os dados, os elementos da marca e os detalhes estruturais antes do uso final." },
                    { q: "GPT Image vs Midjourney: qual devo usar?", a: "O GPT Image é uma ótima opção para controle claro de instruções, tamanhos de imagem práticos e geração direta pelo navegador. O Midjourney pode ser mais adequado para usuários que preferem seus estilos artísticos, fluxo de trabalho com imagens de referência e processo criativo." }
                ],
                ctaTitle: "Use o GPT Image gratuitamente no Miral!",
                ctaDesc: "Cadastre-se para receber créditos gratuitos. Descreva sua ideia, escolha um tamanho e uma qualidade e use o gerador de imagens GPT Image AI para criar visuais de alta qualidade."
            },
            qwenImage2Pro: {
                title: "Gerador de Imagens com IA Qwen Image 2.0 Pro Gratuito Online | Miral",
                description: "Crie imagens de IA online com o Qwen Image 2.0 Pro. Use prompts negativos, aprimoramento de prompts, proporções flexíveis e gere até quatro imagens por execução.",
                heroHeadline: "Gerador de Imagens com IA Qwen Image 2.0 Pro",
                heroIntro: "Use o gerador de imagens Qwen Image 2.0 Pro AI gratuitamente no Miral AI. Cadastre-se para receber créditos grátis e crie rapidamente imagens de alta qualidade com prompts negativos, aprimoramento de prompts e proporções flexíveis.",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "Qwen Image 2.0 Pro",
                ctaTag: "Qwen Image 2.0 Pro · Miral",
                badges: ["Texto para imagem", "Prompt negativo", "Aprimoramento do prompt", "1-4 Imagens por Impressão", "Proporções Flexíveis"],
                previewLabel: "Qwen Image 2.0 Pro",
                previewMeta: ["1:1", "2048 × 2048", "Até 1-4 Imagens"],
                previewTitle: "De um prompt preciso com exclusões a visuais refinados.",
                previewDesc: "Combine prompts positivos com prompts negativos e aprimoramento de prompts para gerar várias imagens relevantes em uma única execução.",
                keyFeaturesTitle: "Crie visuais precisos com o Gerador de Texto para Imagem Qwen Image 2.0 Pro",
                keyFeaturesIntro: "Explore os principais recursos do gerador de imagens Qwen Image 2.0 Pro AI para controle preciso, sugestões negativas, aprimoramento de sugestões, saída em lote e proporções flexíveis.",
                mainFeaturesTitle: "Principais Recursos do Qwen Image 2.0 Pro",
                promptLabel: "Prompt positivo",
                negativePromptLabel: "Prompt negativo",
                shortPromptLabel: "Prompt curto",
                negativePromptFallback: "Baixa nitidez, detalhes distorcidos, composição confusa",
                features: [
                    { name: "Controle de Prompt Negativo", short: "Descreva o que excluir para obter resultados mais precisos e relevantes.", desc: "O gerador de imagens de IA Qwen Image 2.0 Pro oferece suporte a uma instrução negativa dedicada, para que você possa dizer ao modelo o que evitar — como baixa nitidez, mãos deformadas ou composição confusa. Isso oferece um controle mais preciso sobre a imagem final e reduz a necessidade de gerar novas imagens repetidamente.", demo: { type: 'table', rows: [
                        { prompt: "Uma foto de produto premium de um frasco de vidro para cuidados com a pele sobre pedra molhada, luz suave da manhã, fundo limpo. (Negativo: fundo confuso, baixa resolução, reflexos deformados.)", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "Retrato de uma jovem mulher sob a luz do outono, textura natural da pele, pouca profundidade de campo. (Negativo: pele excessivamente suavizada, aparência cerosa, cores supersaturadas.)", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "Aprimoramento do prompt", short: "Opcionalmente, expanda uma breve descrição para detalhes mais ricos.", desc: "Ative o aprimoramento de prompt e o Qwen Image 2.0 Pro enriquecerá automaticamente um breve prompt com detalhes extras antes da geração. Isso ajuda prompts não especializados a produzir imagens mais completas e vívidas sem reescrita manual.", demo: { type: 'table', rows: [
                        { prompt: "Um cantinho aconchegante para leitura perto de uma janela chuvosa.", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "Uma escrivaninha de madeira ao lado de uma janela coberta de chuva à noite, uma luminária de mesa aconchegante iluminando um livro aberto e chá fumegante, um interior tranquilo e acolhedor.", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "Gere de 1 a 4 imagens em Uma vez", short: "Produza múltiplas variações em uma única execução.", desc: "O Qwen Image 2.0 Pro pode gerar até quatro imagens por solicitação, permitindo comparar variações de um conceito, ângulo ou estilo lado a lado e escolher a melhor. Isso acelera a exploração criativa para recursos visuais de marketing e produtos.", prompt: "Um abajur de mesa minimalista de cerâmica sobre uma mesa lateral de nogueira, interior aconchegante à noite, parede creme, sombras suaves, fotografia de produto escandinava.", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "Proporções Flexíveis", short: "Escolha os formatos paisagem, retrato, quadrado ou personalizado.", desc: "Escolha entre proporções predefinidas, como 2688×1536 paisagem, 1536×2688 retrato, 2048×2048 quadrado e 2368×1728 / 1728×2368, ou insira um tamanho personalizado de 512×512 a 2048×2048. Isso torna o gerador de texto para imagem Qwen Image 2.0 Pro adequado para banners, pôsteres, postagens em redes sociais e miniaturas quadradas.", prompt: "Uma foto panorâmica cinematográfica de uma falésia costeira na hora dourada, com nuvens dramáticas e detalhes finos da rocha, 2688×1536.", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "Detalhes e Realismo Refinados", short: "Renderize texturas, iluminação e profundidade realistas.", desc: "O Qwen Image 2.0 Pro produz texturas finas, iluminação realista e profundidade natural, tornando-o ideal para fotografia de produtos, retratos e visuais editoriais onde a verossimilhança é importante.", prompt: "Retrato editorial em close-up de uma ceramista idosa em uma oficina ensolarada, textura natural da pele, pó de argila nas mãos, luz quente da janela, profundidade de campo rasa.", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "Instrução Exemplos",
                showcaseTitle: "Exemplos de prompts do Qwen Image 2.0 Pro para imagens de IA melhores",
                showcaseIntro: "Use estes exemplos de prompts do Qwen Image 2.0 Pro como ponto de partida. Combine cada prompt positivo com um prompt negativo para remover elementos indesejados e, em seguida, envie-o diretamente para o gerador.",
                useCasesKicker: "Feito para trabalho de verdade",
                useCasesTitle: "Casos de uso populares do Qwen Image 2.0 Pro",
                useCases: [
                    { name: "Qwen Image 2.0 Pro para Fotografia de Produtos", desc: "Crie fotos de produtos nítidas com fundos controlados usando instruções negativas para remover elementos indesejados." },
                    { name: "Qwen Image 2.0 Pro para Marketing", desc: "Gere conceitos de campanha, anúncios para redes sociais e banners em várias proporções." },
                    { name: "Qwen Image 2.0 Pro para pôsteres e tipografia", desc: "Crie layouts de pôsteres e designs ricos em texto com títulos e rótulos claros." },
                    { name: "Qwen Image 2.0 Pro para Retratos", desc: "Gere retratos detalhados com textura de pele natural usando solicitações negativas para evitar artefatos." },
                    { name: "Qwen Image 2.0 Pro para Arte Conceitual", desc: "Explore personagens, ambientes e direções visuais com 1 a 4 variações por execução." },
                    { name: "Qwen Image 2.0 Pro para comércio eletrônico", desc: "Produza múltiplas variações de imagens para anúncios e listagens em uma única geração." }
                ],
                howToKicker: "Três simples Etapas",
                howToTitle: "Como usar o gerador de imagens com IA Qwen Image 2.0 Pro online",
                howToIntro: "Use o gerador de imagens Qwen Image 2.0 Pro AI online no Miral com sugestões positivas, sugestões negativas e controles de saída flexíveis.",
                howToSteps: [
                    { title: "Insira seu texto principal", desc: "Descreva o assunto, a cena, a composição, a iluminação, o estilo e os detalhes visuais desejados." },
                    { title: "Configurar controles de geração", desc: "Adicione um prompt negativo, se necessário, ative o aprimoramento do prompt, escolha o tamanho e selecione de uma a quatro imagens." },
                    { title: "Gerar e Comparar", desc: "Inicie a geração, compare as variações retornadas e baixe a imagem que melhor corresponde à sua intenção." }
                ],
                howToCta: "Experimente o Qwen Image 2.0 Pro, um gerador de imagens com IA",
                faqTitle: "Perguntas frequentes sobre o Qwen Image 2.0 Pro",
                faqs: [
                    { q: "O que é o gerador de imagens com IA Qwen Image 2.0 Pro?", a: "O Qwen Image 2.0 Pro é o modelo de texto para imagem Tongyi Qwen da Alibaba. O gerador de imagens de IA Qwen Image 2.0 Pro transforma instruções escritas em imagens detalhadas de alta qualidade e está disponível no Miral para criação visual de arte, design, marketing e produtos diretamente no seu navegador." },
                    { q: "Qual ferramenta posso usar para criar várias variações de imagens de produtos com prompts negativos?", a: "O Qwen Image 2.0 Pro oferece um prompt negativo dedicado, aprimoramento de prompt opcional, de 1 a 4 imagens por execução e proporções flexíveis para fotografia de produtos, marketing e variações visuais de comércio eletrônico." },
                    { q: "Posso usar o gerador de imagens Qwen Image 2.0 Pro AI gratuitamente?", a: "Sim. Cadastre-se para receber créditos gratuitos e comece a criar imagens de alta qualidade com o gerador de imagens de IA Qwen Image 2.0 Pro imediatamente. A geração de imagens utiliza os créditos correspondentes." },
                    { q: "Como uso o gerador de imagens Qwen Image 2.0 Pro AI online?", a: "Digite uma instrução de texto detalhada, adicione opcionalmente uma instrução negativa descrevendo o que evitar, ative o aprimoramento da instrução, se necessário, escolha uma proporção ou tamanho personalizado, defina quantas imagens gerar (1 a 4) e clique em Gerar. O Qwen Image 2.0 Pro funciona bem para materiais de marketing, fotografia de produtos, retratos e designs de pôsteres." },
                    { q: "Como corrigir elementos indesejados nos resultados do Qwen Image 2.0 Pro?", a: "Adicione uma instrução negativa descrevendo os elementos que você não deseja, como baixa nitidez, mãos deformadas ou um fundo confuso. O Qwen Image 2.0 Pro usa isso para direcionar a geração para longe desses resultados." },
                    { q: "Quantas imagens o Qwen Image 2.0 Pro pode gerar de uma só vez?", a: "O Qwen Image 2.0 Pro pode gerar até 4 imagens em uma única solicitação (n = 1 a 4), para que você possa comparar variações de um conceito, ângulo ou estilo e escolher a melhor." },
                    { q: "Quais tamanhos e proporções o Qwen Image 2.0 Pro suporta?", a: "No Miral, o Qwen Image 2.0 Pro oferece proporções predefinidas como 2688×1536, 1536×2688, 2048×2048, 2368×1728 e 1728×2368, além de um tamanho personalizado de 512×512 até 2048×2048. Isso abrange formatos paisagem, retrato e quadrado para banners, pôsteres, posts em redes sociais e miniaturas." },
                    { q: "Quais são os melhores exemplos de prompts do Qwen Image 2.0 Pro?", a: "Instruções eficazes do Qwen Image 2.0 Pro descrevem claramente o assunto, o cenário, a composição, a iluminação e o estilo. Em seguida, combine uma instrução positiva com uma negativa para remover detalhes indesejados. Use os exemplos de instruções do Qwen Image 2.0 Pro nesta página como ponto de partida e personalize-os para o seu projeto." },
                    { q: "Qwen Image 2.0 Pro vs Midjourney: qual devo usar?", a: "Escolha com base no fluxo de trabalho, em vez de um vencedor universal. O Qwen Image 2.0 Pro é uma ótima opção quando você precisa de instruções negativas explícitas, aprimoramento de instruções, de 1 a 4 imagens por execução e proporções flexíveis em um gerador baseado em navegador no Miral. O Midjourney pode ser mais adequado para criadores que preferem seu fluxo de trabalho artístico diferenciado e ferramentas da comunidade." }
                ],
                ctaTitle: "Experimente o Qwen Image 2.0 Pro gratuitamente no Miral!",
                ctaDesc: "Digite sua ideia acima e use o gerador de imagens de IA Qwen Image 2.0 Pro com controles opcionais para criar variações de imagem precisas."
            },
            stableDiffusion: {
                title: "Gerador de Imagens com IA Stable Diffusion 3.5 Gratuito Online | Miral",
                description: "Gere imagens de IA online com o Stable Diffusion 3.5. Use prompts negativos, proporções predefinidas e tamanhos personalizados de 512 a 2048 pixels no Miral.",
                heroHeadline: "Gerador de imagens de IA Stable Diffusion 3.5",
                heroIntro: "Use o gerador de imagens Stable Diffusion 3.5 AI gratuitamente no Miral AI. Cadastre-se para receber créditos grátis e crie rapidamente imagens de alta qualidade com prompts detalhados, prompts negativos e tamanhos flexíveis.",
                eyebrow: "Stability AI · Stable Diffusion 3.5",
                sectionKicker: "Difusão Estável 3.5",
                ctaTag: "Stable Diffusion 3.5 · Miral",
                badges: ["Texto para imagem", "Prompt negativo", "Proporções Flexíveis", "Tamanho personalizado"],
                previewLabel: "Difusão Estável 3.5",
                previewMeta: ["1:1", "512 – 2048", "Múltiplos de 64"],
                previewTitle: "De um prompt detalhado a uma imagem controlada e refinada",
                previewDesc: "Combine dicas positivas com dicas negativas e escolha a proporção correta para direcionar o Stable Diffusion 3.5 em direção a visuais nítidos e precisos.",
                keyFeaturesTitle: "Crie visuais controlados com o gerador de texto para imagem Stable Diffusion 3.5",
                keyFeaturesIntro: "Explore os principais recursos do gerador de imagens com IA Stable Diffusion 3.5 para prompts negativos, proporções flexíveis, tamanhos personalizados e compreensão detalhada do prompt.",
                exploreTitle: "Explore Mais Modelos de Imagem com IA",
                mainFeaturesTitle: "Principais Recursos do Stable Diffusion 3.5",
                generatedImageLabel: "Imagem gerada",
                versionLabel: "Controle",
                featureLabel: "O que isso altera",
                useCaseLabel: "Ideal para",
                variantsTitle: "Controles de Saída do Stable Diffusion 3.5",
                variantsIntro: "Combine o modelo Stable Diffusion 3.5 com proporções predefinidas ou dimensões personalizadas exatas com base no layout final que você precisa.",
                variants: [
                    { name: "Difusão Estável 3.5", desc: "Geração detalhada de texto para imagem com controle de prompts positivos e negativos.", bestFor: "Visuais de produtos, retratos, arte conceitual e imagens de marketing." },
                    { name: "Proporções predefinidas", desc: "Dimensões de saída prontas para paisagem, retrato e quadrado.", bestFor: "Publicações em redes sociais, banners, pôsteres e miniaturas." },
                    { name: "Tamanho de Imagem Personalizado", desc: "Largura e altura exatas de 512 a 2048 em múltiplos de 64.", bestFor: "Crie layouts e projetos que exigem dimensões de pixel precisas." }
                ],
                controlsTitle: "Escolha os controles de prompt e o tamanho de imagem corretos",
                controlsIntro: "Use um prompt negativo para reduzir detalhes indesejados e, em seguida, selecione uma proporção predefinida ou insira dimensões personalizadas para o canal desejado.",
                galleryTitle: "Mais exemplos de imagens do Stable Diffusion 3.5",
                discussionTitle: "Perguntas Frequentes sobre o Stable Diffusion 3.5",
                communityTitle: "Formas populares de criar com o Stable Diffusion 3.5",
                tutorialPrompt: "Fotografia editorial de um alto-falante escultural de cerâmica sobre pedra clara, sob a suave luz da manhã vinda de uma janela, textura realista, composição equilibrada, sombras sutis e fundo limpo.",
                qualityBenefits: [
                    "Use prompts negativos para reduzir a desordem, detalhes malformados e estilos visuais indesejados.",
                    "Siga as descrições em camadas do assunto, composição, iluminação, materiais e atmosfera.",
                    "Crie imagens em formato paisagem, retrato e quadradas com predefinições ou dimensões personalizadas precisas."
                ],
                features: [
                    { name: "Controle de Prompt Negativo", short: "Descreva o que excluir para obter resultados mais precisos e relevantes.", desc: "O gerador de imagens de IA Stable Diffusion 3.5 suporta um prompt negativo dedicado, para que você possa dizer ao modelo o que evitar — como baixa nitidez, mãos deformadas ou um fundo confuso. Isso oferece um controle mais preciso sobre a imagem final e reduz a necessidade de rolar novamente repetidamente.", demo: { type: 'table', rows: [
                        { prompt: "Uma foto de produto premium de um vaso de cerâmica preto fosco sobre um pedestal de mármore, luz suave de estúdio e fundo limpo. (Negativo: fundo confuso, baixa resolução, reflexos deformados.)", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "Retrato de um jovem sob a suave luz da janela, com textura natural da pele e pouca profundidade de campo. (Negativo: pele excessivamente alisada, aspecto ceroso, cores saturadas em excesso.)", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "Proporções Flexíveis", short: "Escolha o formato paisagem, retrato, quadrado ou um tamanho personalizado.", desc: "Escolha entre proporções predefinidas, como 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 e 1536×1536, ou insira um tamanho personalizado de 512×512 a 2048×2048. Isso torna o gerador de texto para imagem Stable Diffusion 3.5 adequado para banners, pôsteres, postagens em redes sociais e miniaturas quadradas.", prompt: "Uma panorâmica cinematográfica de uma falésia costeira na hora dourada, com nuvens dramáticas e detalhes nítidos das rochas, 1536×896.", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "Imagem personalizada Tamanhos", short: "Defina as dimensões exatas dos pixels para obter resultados precisos.", desc: "Quando uma predefinição não se ajustar, alterne para um tamanho personalizado e insira qualquer largura e altura de 512 a 2048 em múltiplos de 64. Isso permite que você ajuste um layout específico, espaço para banner ou proporção de impressão sem recorte manual.", prompt: "Um fundo de pôster minimalista com composição geométrica centralizada, gradiente azul profundo, granulação sutil, 1280×1280.", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "Entendimento Detalhado do Prompt", short: "Segue descrições em camadas de assunto, luz e estilo.", desc: "O Stable Diffusion 3.5 lê instruções de texto em camadas e renderiza o assunto, o cenário, a iluminação e o clima que você descreve. Combine um prompt positivo claro com um prompt negativo para aproximar o resultado da sua intenção em menos tentativas.", demo: { type: 'table', rows: [
                        { prompt: "Foto editorial de um relógio de pulso ao lado de um linho dobrado e uma xícara de cerâmica, composição triangular equilibrada, luz suave da manhã.", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "Um cantinho de leitura aconchegante perto de uma janela chuvosa, luz quente de abajur, livros empilhados, cobertor texturizado, atmosfera cinematográfica.", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "Detalhes e Realismo Refinados", short: "Renderize iluminação, materiais e profundidade realistas.", desc: "O Stable Diffusion 3.5 produz texturas finas, iluminação realista e profundidade natural, tornando o gerador de imagens com IA Stable Diffusion 3.5 uma ótima opção para fotografia de produtos, retratos, arte conceitual e visuais editoriais onde a verossimilhança é importante.", prompt: "Retrato editorial em close-up de uma ceramista idosa em uma oficina ensolarada, textura natural da pele, pó de argila nas mãos, luz quente da janela, profundidade de campo rasa.", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "Instrução Exemplos",
                showcaseTitle: "Exemplos de prompts do Stable Diffusion 3.5 para melhores imagens de IA",
                showcaseIntro: "Use estes exemplos de prompts do Stable Diffusion 3.5 como ponto de partida. Descreva o assunto, a composição, a iluminação e o estilo com clareza, combine cada prompt com um prompt negativo e envie-o diretamente para o gerador.",
                useCasesKicker: "Feito para trabalho de verdade",
                useCasesTitle: "Casos de uso populares do Stable Diffusion 3.5",
                useCases: [
                    { name: "Stable Diffusion 3.5 para fotografia de produtos", desc: "Crie fotos de produtos nítidas com fundos controlados usando instruções negativas para remover elementos indesejados." },
                    { name: "Stable Diffusion 3.5 para Marketing", desc: "Gere conceitos de campanha, anúncios para redes sociais e banners em várias proporções." },
                    { name: "Stable Diffusion 3.5 para pôsteres e layouts", desc: "Produza fundos de pôsteres e visuais prontos para layout em dimensões de pixel personalizadas." },
                    { name: "Stable Diffusion 3.5 para retratos", desc: "Gere retratos detalhados com textura de pele natural, usando prompts negativos para evitar artefatos." },
                    { name: "Stable Diffusion 3.5 para arte conceitual", desc: "Explore personagens, ambientes e direções visuais com prompts em camadas." },
                    { name: "Stable Diffusion 3.5 para conteúdo de redes sociais", desc: "Crie imagens quadradas, em formato retrato e paisagem, dimensionadas para diferentes plataformas de mídia social." }
                ],
                howToKicker: "Três simples Etapas",
                howToTitle: "Como usar o gerador de imagens com IA Stable Diffusion 3.5 online",
                howToIntro: "Use o gerador de imagens Stable Diffusion 3.5 AI online no Miral com um prompt claro, um prompt negativo e a proporção que seu projeto precisa.",
                howToSteps: [
                    { title: "Insira seu texto principal", desc: "Descreva o assunto, a cena, a composição, a iluminação, o estilo e os detalhes visuais desejados." },
                    { title: "Configurar controles de geração", desc: "Adicione uma descrição negativa, se necessário, e escolha uma proporção predefinida ou insira um tamanho personalizado." },
                    { title: "Gerar e revisar", desc: "Inicie a geração, revise o resultado e baixe a imagem ou ajuste seu prompt para outra tentativa." }
                ],
                howToCta: "Experimente o Gerador de Imagens com IA do Stable Diffusion 3.5",
                faqTitle: "Perguntas frequentes sobre o Stable Diffusion 3.5",
                faqs: [
                    { q: "O que é o gerador de imagens com IA Stable Diffusion 3.5?", a: "O Stable Diffusion 3.5 é um modelo de texto para imagem da Stability AI. O gerador de imagens Stable Diffusion 3.5 AI transforma instruções escritas em imagens detalhadas e está disponível no Miral para criação de arte, design, marketing e recursos visuais de produtos diretamente no seu navegador." },
                    { q: "Que ferramenta posso usar para criar imagens de tamanho personalizado com prompts negativos?", a: "O Stable Diffusion 3.5 oferece um prompt negativo dedicado, proporções de aspecto prontas e tamanhos personalizados de 512 a 2048 para fotografia de produtos, visuais de marketing, retratos e arte conceitual." },
                    { q: "Posso usar o gerador de imagens Stable Diffusion 3.5 AI gratuitamente?", a: "Sim. Cadastre-se para receber créditos gratuitos e comece a criar imagens de alta qualidade com o gerador de imagens de IA Stable Diffusion 3.5 imediatamente. A geração de imagens utiliza os créditos correspondentes." },
                    { q: "Como uso o gerador de imagens Stable Diffusion 3.5 AI online?", a: "Insira um texto detalhado, opcionalmente adicione uma mensagem negativa descrevendo o que evitar, escolha uma proporção predefinida ou insira um tamanho personalizado e clique em Gerar. O Stable Diffusion 3.5 funciona bem para materiais de marketing, fotografia de produtos, retratos e layouts de pôsteres." },
                    { q: "Como corrigir detalhes indesejados ou deformados em imagens do Stable Diffusion 3.5?", a: "Adicione um prompt negativo descrevendo os elementos que você não deseja, como baixa nitidez, mãos deformadas ou um fundo confuso. O Stable Diffusion 3.5 o utiliza para direcionar a geração de imagens e evitar esses resultados." },
                    { q: "Quais tamanhos e proporções o Stable Diffusion 3.5 suporta?", a: "No Miral, o Stable Diffusion 3.5 oferece proporções predefinidas como 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 e 1536×1536, além de um tamanho personalizado de 512×512 até 2048×2048 em múltiplos de 64. Isso abrange saídas em formato paisagem, retrato e quadrado para banners, pôsteres, posts em redes sociais e miniaturas." },
                    { q: "Quais são os melhores exemplos de prompts do Stable Diffusion 3.5?", a: "As instruções do Stable Diffusion 3.5 descrevem claramente o assunto, o cenário, a composição, a iluminação e o estilo, e combinam uma instrução positiva com uma negativa para remover detalhes indesejados. Use os exemplos de instruções do Stable Diffusion 3.5 nesta página como ponto de partida e personalize-os para o seu projeto." },
                    { q: "Stable Diffusion 3.5 vs Midjourney: qual devo usar?", a: "Escolha com base no fluxo de trabalho, em vez de um vencedor universal. O Stable Diffusion 3.5 é uma ótima opção quando você precisa de instruções negativas explícitas, proporções de aspecto prontas e tamanhos de pixel personalizados em um gerador baseado em navegador no Miral. O Midjourney pode ser mais adequado para criadores que preferem seu fluxo de trabalho artístico diferenciado e ferramentas da comunidade." }
                ],
                ctaTitle: "Experimente o Stable Diffusion 3.5 gratuitamente no Miral!",
                ctaDesc: "Insira sua ideia acima e use o gerador de imagens de IA Stable Diffusion 3.5 com dicas negativas e tamanhos flexíveis para criar visuais controlados."
            },
            zImageTurbo: {
                title: "Gerador de Imagens Z Image Turbo AI Gratuito Online | Miral",
                description: "Crie imagens de IA de alta qualidade online com o Z Image Turbo. Expanda os prompts, escolha proporções flexíveis, defina dimensões personalizadas e controle as sementes no Miral.",
                heroHeadline: "Gerador de imagens de IA Z Image Turbo",
                heroIntro: "Use o gerador de imagens Z Image Turbo AI gratuitamente no Miral AI. Cadastre-se para receber créditos gratuitos e crie rapidamente imagens de alta qualidade com extensão de prompt, proporções flexíveis e controle de sementes.",
                eyebrow: "Z Image Turbo",
                sectionKicker: "Z Image Turbo",
                ctaTag: "Z Image Turbo · Miral",
                badges: ["Texto para imagem", "Extensão do prompt", "Proporções Flexíveis", "Tamanho personalizado", "Controle de sementes"],
                previewLabel: "Z Image Turbo",
                previewMeta: ["1:1", "512 – 2048", "Controle de sementes"],
                previewTitle: "De um prompt curto a uma imagem refinada e de alta resolução",
                previewDesc: "Deixe que a extensão do prompt enriqueça uma ideia breve, escolha a proporção correta e reutilize um modelo para manter um estilo consistente em todas as imagens.",
                keyFeaturesTitle: "Crie visuais refinados com o gerador de texto para imagem Z Image Turbo",
                keyFeaturesIntro: "Explore os principais recursos do gerador de imagens com IA Z Image Turbo para extensão de prompts, proporções flexíveis, tamanhos personalizados e consistência baseada em sementes.",
                exploreTitle: "Explore Mais Modelos de Imagem com IA",
                mainFeaturesTitle: "Principais Recursos do Z Image Turbo",
                generatedImageLabel: "Imagem gerada",
                versionLabel: "Controle",
                featureLabel: "O que isso altera",
                useCaseLabel: "Ideal para",
                variantsTitle: "Controles de criação do Z Image Turbo",
                variantsIntro: "Combine extensão de prompts, dimensões flexíveis e controle de sementes de acordo com o nível de detalhe e consistência visual que seu projeto exige.",
                variants: [
                    { name: "Z Image Turbo", desc: "Geração rápida de texto para imagem com saída detalhada em alta resolução.", bestFor: "Visuais de produtos, retratos, arte conceitual e imagens de marketing." },
                    { name: "Extensão do prompt", desc: "Enriquece automaticamente prompts curtos com detalhes visuais adicionais.", bestFor: "Transformando ideias rápidas em instruções de geração mais completas." },
                    { name: "Controle de sementes", desc: "Reutiliza a mesma semente inicial enquanto você refina outras configurações.", bestFor: "Mantém um estilo coordenado em diferentes variações de imagem ou campanhas." }
                ],
                controlsTitle: "Escolha as configurações corretas de prompt, tamanho e seed",
                controlsIntro: "Habilite a extensão de prompts quando uma ideia precisar de mais detalhes, escolha as dimensões de saída desejadas e reutilize uma semente quando a consistência visual for importante.",
                galleryTitle: "Mais exemplos de imagens do Z Image Turbo",
                discussionTitle: "Perguntas Frequentes sobre o Z Image Turbo",
                communityTitle: "Formas populares de criar com o Z Image Turbo",
                tutorialPrompt: "Uma scooter elétrica compacta exibida em um estúdio de arquitetura iluminado, piso de concreto claro, claraboia suave, fotografia de produto refinada, composição equilibrada, materiais realistas.",
                qualityBenefits: [
                    "Expanda ideias curtas em prompts mais ricos sem precisar reescrever manualmente cada detalhe visual.",
                    "Escolha paisagem, retrato, quadrado ou dimensões personalizadas precisas para o canal final.",
                    "Reutilize um modelo inicial para manter a iluminação, a paleta de cores e a composição mais consistentes entre as iterações."
                ],
                features: [
                    { name: "Extensão do prompt", short: "Opcionalmente, expanda uma breve descrição para detalhes mais ricos.", desc: "Ative a extensão de prompt e o Z Image Turbo enriquecerá automaticamente um prompt breve com detalhes extras antes da geração. Isso ajuda prompts curtos ou simples a produzirem imagens mais completas e vívidas sem reescrita manual.", demo: { type: 'table', rows: [
                        { prompt: "Uma estufa de vidro repleta de plantas tropicais na superfície de Marte.", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "Uma pequena padaria artesanal construída dentro de um vagão de trem antigo.", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "Proporções Flexíveis", short: "Escolha o formato paisagem, retrato, quadrado ou um tamanho personalizado.", desc: "Escolha entre proporções predefinidas, como 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 e 1536×1536, ou insira um tamanho personalizado de 512×512 a 2048×2048. Isso torna o gerador de texto para imagem Z Image Turbo adequado para banners, pôsteres, publicações em redes sociais e miniaturas quadradas.", prompt: "Uma vista aérea ultra-ampla de um mercado noturno de Tóquio na chuva, lanternas de papel brilhantes, barracas de comida lotadas, ruas reflexivas, atmosfera cinematográfica, 1536×864.", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "Imagem personalizada Tamanhos", short: "Defina as dimensões exatas dos pixels para obter resultados precisos.", desc: "Quando uma predefinição não se ajustar, mude para um tamanho personalizado e insira qualquer largura e altura de 512 a 2048. Isso permite que você corresponda a um layout específico, espaço para banner ou proporção de impressão sem recorte manual.", prompt: "Um pôster vertical de exposição botânica, tipografia laranja em tamanho grande, folhas tropicais raras, textura de papel em tom quente de branco, grade editorial precisa, 1152×1728.", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "Controle de Semente para Consistência", short: "Reutilize uma semente para manter um estilo estável entre as imagens.", desc: "Defina uma semente fixa (de 0 a 2147483647) e o gerador de imagens Z Image Turbo AI usará o mesmo ponto de partida em todas as execuções, facilitando a manutenção de uma aparência consistente enquanto você refina o prompt. Deixe a semente em 0 para obter um resultado novo e aleatório a cada vez.", prompt: "Uma campanha coordenada de cuidados com a pele apresentando três frascos de vidro fosco sobre pedra verde-clara, luz suave e difusa, detalhes em eucalipto — reutilizando a mesma semente para preservar a iluminação, a paleta de cores e a composição em toda a linha de produtos.", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "Detalhes e Realismo Refinados", short: "Renderize iluminação, materiais e profundidade realistas.", desc: "O Z Image Turbo produz texturas finas, iluminação realista e profundidade natural, tornando-o uma ótima opção para fotografia de produtos, retratos, arte conceitual e visuais editoriais onde a verossimilhança é importante.", prompt: "Close-up documental de um luthier esculpindo uma ponte de bordo em uma oficina silenciosa, lascas finas de madeira, ferramentas manuais desgastadas, textura natural da pele, luz suave da janela voltada para o norte, pouca profundidade de campo.", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "Instrução Exemplos",
                showcaseTitle: "Exemplos de prompts do Z Image Turbo para imagens de IA melhores",
                showcaseIntro: "Use estes exemplos de prompts do Z Image Turbo como ponto de partida. Descreva o assunto, a composição, a iluminação e o estilo com clareza, habilite opcionalmente a extensão do prompt e envie-o diretamente para o gerador.",
                useCasesKicker: "Feito para trabalho de verdade",
                useCasesTitle: "Casos de uso populares do Z Image Turbo",
                useCases: [
                    { name: "Z Image Turbo para fotografia de produtos", desc: "Crie fotos de produtos nítidas com fundos controlados e uma semente fixa para uma aparência consistente." },
                    { name: "Z Image Turbo para Marketing", desc: "Gere conceitos de campanha, anúncios para redes sociais e banners em várias proporções." },
                    { name: "Z Image Turbo para pôsteres e layouts", desc: "Produza fundos de pôsteres e visuais prontos para layout em dimensões de pixel personalizadas." },
                    { name: "Z Image Turbo para retratos", desc: "Gere retratos detalhados com textura de pele natural e iluminação realista." },
                    { name: "Z Image Turbo para arte conceitual", desc: "Explore personagens, ambientes e direções visuais com prompts em camadas." },
                    { name: "Z Image Turbo para Conteúdo Social", desc: "Crie imagens quadradas, em formato retrato e paisagem, dimensionadas para diferentes plataformas de mídia social." }
                ],
                howToKicker: "Três simples Etapas",
                howToTitle: "Como usar o gerador de imagens com IA Z Image Turbo online",
                howToIntro: "Use o gerador de imagens Z Image Turbo AI online no Miral com um prompt claro, extensão de prompt opcional e a proporção que seu projeto precisa.",
                howToSteps: [
                    { title: "Insira seu texto principal", desc: "Descreva o assunto, a cena, a composição, a iluminação, o estilo e os detalhes visuais desejados." },
                    { title: "Configurar controles de geração", desc: "Opcionalmente, habilite a extensão de prompt, escolha uma proporção predefinida ou insira um tamanho personalizado e defina uma semente se desejar consistência." },
                    { title: "Gerar e revisar", desc: "Inicie a geração, revise o resultado e baixe a imagem ou ajuste seu prompt para outra tentativa." }
                ],
                howToCta: "Experimente o gerador de imagens com IA Z Image Turbo",
                faqTitle: "Perguntas frequentes sobre o Z Image Turbo",
                faqs: [
                    { q: "O que é o gerador de imagens Z Image Turbo AI?", a: "O Z Image Turbo é um modelo de texto para imagem para geração de imagens de alta resolução. O gerador de imagens de IA Z Image Turbo transforma prompts escritos em imagens detalhadas e está disponível no Miral para criação visual de arte, design, marketing e produtos diretamente no seu navegador." },
                    { q: "Qual ferramenta posso usar para criar uma série consistente de imagens de produtos?", a: "O Z Image Turbo combina extensão de prompts, tamanhos de imagem flexíveis e controle de sementes para ajudar a criar uma série consistente de fotografias de produtos ou visuais de marketing." },
                    { q: "Posso usar o gerador de imagens Z Image Turbo AI gratuitamente?", a: "Sim. Cadastre-se para receber créditos gratuitos e comece a criar imagens de alta qualidade com o gerador de imagens Z Image Turbo AI imediatamente. A geração de imagens utiliza os créditos correspondentes." },
                    { q: "Como uso o gerador de imagens Z Image Turbo AI online?", a: "Digite um prompt de texto detalhado, ative opcionalmente a extensão do prompt, escolha uma proporção predefinida ou insira um tamanho personalizado, defina uma semente se desejar uma aparência consistente e clique em Gerar. O Z Image Turbo funciona bem para materiais de marketing, fotografia de produtos, retratos e layouts de pôsteres." },
                    { q: "O que é extensão de prompt no Z Image Turbo?", a: "A extensão de prompt é uma opção que permite ao Z Image Turbo enriquecer automaticamente um prompt curto ou simples com detalhes extras antes da geração. Isso ajuda prompts não especializados a produzir imagens mais completas e vívidas sem reescrita manual." },
                    { q: "Como corrigir resultados inconsistentes no Z Image Turbo?", a: "Reutilize a mesma semente enquanto refina outros parâmetros para ajudar a manter um estilo consistente em todas as imagens. Deixe a semente em 0 somente quando quiser um resultado novo e aleatório a cada vez." },
                    { q: "Quais tamanhos e proporções o Z Image Turbo suporta?", a: "Na Miral, o Z Image Turbo oferece proporções predefinidas como 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 e 1536×1536, além de um tamanho personalizado de 512×512 até 2048×2048. Isso abrange formatos paisagem, retrato e quadrado para banners, pôsteres, publicações em redes sociais e miniaturas." },
                    { q: "Quais são os melhores exemplos de prompts do Z Image Turbo?", a: "Os prompts eficazes do Z Image Turbo descrevem claramente o assunto, o cenário, a composição, a iluminação e o estilo. Para ideias curtas, habilite a extensão do prompt para que o modelo possa enriquecê-lo automaticamente. Use os exemplos de prompts do Z Image Turbo nesta página como ponto de partida e personalize-os para o seu projeto." }
                ],
                ctaTitle: "Experimente o Z Image Turbo gratuitamente no Miral!",
                ctaDesc: "Digite sua ideia acima e use o gerador de imagens de IA Z Image Turbo com extensão de prompt, tamanhos flexíveis e controle de semente para criar visuais refinados."
            },
            midjourney: {
                title: "Gerador de Imagens Midjourney AI Gratuito Online | Miral",
                description: "Crie arte com IA online com o Midjourney no Miral AI. Escolha estilos realistas ou de anime, oriente os resultados com imagens de referência e transforme instruções de texto em visuais vibrantes.",
                heroHeadline: "Gerador de imagens de IA Midjourney",
                heroIntro: "Use o gerador de imagens Midjourney AI gratuitamente no Miral AI. Cadastre-se para receber créditos gratuitos e crie instantaneamente imagens de alta qualidade com estilos Realista ou Anime e orientação opcional de imagem de referência.",
                eyebrow: "Midjourney",
                sectionKicker: "Midjourney",
                ctaTag: "Midjourney · Miral",
                badges: ["Texto para imagem", "Estilos Realistas e Anime", "Guia de Imagem de Referência", "Direção Artística"],
                previewLabel: "Midjourney",
                previewMeta: ["Realista", "Anime", "Até 5 referências"],
                previewTitle: "De um estímulo vívido a uma imagem cinematográfica com direção de arte",
                previewDesc: "Escolha um estilo, descreva o clima e a iluminação e deixe o Midjourney moldar o visual artístico do seu conceito, pôster ou personagem.",
                keyFeaturesTitle: "Crie visuais com direção de arte usando o Gerador de Texto para Imagem Midjourney.",
                keyFeaturesIntro: "Explore os principais recursos do gerador de imagens com IA da Midjourney para troca de estilo, orientação por imagem de referência e direção artística rica.",
                features: [
                    { name: "Estilos Realistas e Anime", short: "Alterne o estilo visual com um toque.", desc: "O gerador de imagens com IA Midjourney no Miral oferece dois estilos prontos para uso: Realista e Anime. Escolha Realista para detalhes fotográficos, luz natural e texturas realistas, ou Anime para linhas estilizadas, cores vibrantes e uma aparência de desenho à mão. O estilo é escolhido no painel, para que sua instrução possa se concentrar na cena em si.", demo: { type: 'table', rows: [
                        { prompt: "Um viajante solitário em pé na beira de uma crista de montanha enevoada ao nascer do sol, luz volumétrica, plano geral cinematográfico, detalhes finos de tecido e rocha.", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "Uma jovem espadachim determinada em um telhado ao entardecer, cabelos esvoaçantes, lanternas brilhantes, traços expressivos de anime, sombreamento cel vibrante.", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "Guia de Imagem de Referência", short: "Faça o upload de até cinco imagens para definir o visual.", desc: "Guie o gerador de imagens de IA do Midjourney com até cinco imagens de referência (PNG, JPG, JPEG ou WebP). Use-as para definir uma paleta de cores, aparência de personagem, formato do produto ou estética geral, para que o resultado fique mais próximo da direção da referência do que apenas do texto.", prompt: "Uma foto de produto premium de um vaso de cerâmica preto fosco sobre um pedestal de mármore, luz suave de estúdio, fundo limpo, combinando com o clima e a paleta das referências enviadas.", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "Iluminação e Ambiente Cinematográficos", short: "Renderize luz, atmosfera e profundidade dramáticas.", desc: "O Midjourney é conhecido por sua iluminação e atmosfera com direção de arte. Descreva a hora dourada, o brilho neon, a névoa, a luz de contorno ou a luz de velas, e o modelo se inclina para um visual cinematográfico que se adapta a pôsteres, artes principais e visuais conceituais.", demo: { type: 'table', rows: [
                        { prompt: "Um beco de neon encharcado pela chuva à noite, poças refletoras, bokeh suave de placas distantes, atmosfera cinematográfica melancólica, uma única figura com um guarda-chuva.", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "Um retrato de um músico em um terraço durante a hora dourada, contraluz quente, reflexo da lente, pouca profundidade de campo, granulação do filme.", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "Arte conceitual e de personagens", short: "Crie personagens e mundos expressivos.", desc: "O gerador de texto para imagem Midjourney é ideal para design de personagens, cenas de fantasia e arte conceitual. Descreva a pose, a roupa, a expressão e o cenário de um personagem, escolha um estilo e itere até obter o resultado desejado.", prompt: "Um alquimista errante com uma capa de viagem em camadas, carregando uma lanterna de latão e frascos brilhantes, trilha na floresta antiga, luz filtrada, detalhes intrincados da vestimenta.", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "Pôsteres e Arte Editorial", short: "Crie layouts e visuais impactantes.", desc: "Desde a arte principal da campanha até ilustrações editoriais, a Midjourney cria composições ousadas e uma estética refinada. Combine um foco claro com um clima descrito e deixe o modelo fornecer visuais com direção de arte para uso em marketing e editoriais.", prompt: "Uma imagem-chave ousada para a campanha, mostrando um beija-flor pairando sobre uma flor tropical brilhante, tons de joias saturados, espaço negativo limpo, iluminação de estúdio de alto contraste.", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "Instrução Exemplos",
                showcaseTitle: "Exemplos de prompts do Midjourney para imagens de IA melhores",
                showcaseIntro: "Use estes exemplos de prompts do Midjourney como ponto de partida. Descreva o assunto, o clima, a iluminação e o estilo da cena e, em seguida, escolha Realista ou Anime no painel e envie para o gerador.",
                useCasesKicker: "Feito para trabalho de verdade",
                useCasesTitle: "Casos de uso populares no meio do processo",
                useCases: [
                    { name: "Midjourney para Arte Conceitual", desc: "Construa personagens, mundos de fantasia e direções visuais com iluminação e atmosfera direcionadas pela arte." },
                    { name: "Midjourney para Arte Principal e Pôsteres", desc: "Crie visuais impactantes para campanhas, pôsteres e ilustrações editoriais com um visual refinado." },
                    { name: "Midjourney para Visuais de Produto e Marca", desc: "Crie conceitos de produtos premium e imagens de marca, guiado por imagens de referência para garantir consistência." },
                    { name: "Midjourney para Retratos", desc: "Gere retratos cinematográficos com luz natural, granulação de filme ou sombreamento estilizado de anime." },
                    { name: "Midjourney para anime e ilustração", desc: "Mude para o estilo Anime para linhas expressivas, cores vibrantes e personagens desenhados à mão." },
                    { name: "Midjourney para Conteúdo Social", desc: "Crie imagens impactantes e fáceis de compartilhar para feeds, miniaturas e posts criativos em redes sociais." }
                ],
                howToKicker: "Três simples Etapas",
                howToTitle: "Como usar o gerador de imagens online Midjourney AI",
                howToIntro: "Use o gerador de imagens Midjourney AI online no Miral com um prompt vívido, um estilo escolhido e imagens de referência opcionais.",
                howToSteps: [
                    { title: "Descreva sua Cena", desc: "Escreva uma descrição vívida que abranja o assunto, o cenário, o clima, a iluminação e o visual artístico desejado." },
                    { title: "Escolha o estilo e as referências", desc: "Escolha Realista ou Anime no painel e, opcionalmente, carregue até cinco imagens de referência para orientar a aparência." },
                    { title: "Gere e refine", desc: "Inicie a geração, revise o resultado e baixe a imagem ou ajuste sua descrição e referências para outra versão." }
                ],
                howToCta: "Experimente o Midjourney AI Image Generator",
                faqTitle: "Perguntas frequentes sobre o Midjourney",
                faqs: [
                    { q: "O que é o gerador de imagens Midjourney AI?", a: "Midjourney é um modelo de texto para imagem amplamente utilizado, conhecido por seus visuais cinematográficos e com direção de arte. No Miral, o gerador de imagens com IA Midjourney transforma instruções escritas em imagens impressionantes para arte conceitual, imagens-chave, pôsteres e trabalhos editoriais diretamente no seu navegador." },
                    { q: "Qual ferramenta posso usar para criar arte conceitual cinematográfica com imagens de referência?", a: "Midjourney combina direção artística rica, iluminação dramática, estilos realista e anime, além de orientação com imagens de referência para arte conceitual cinematográfica, visuais principais e imagens de marca." },
                    { q: "Posso usar o gerador de imagens Midjourney AI gratuitamente?", a: "Sim. Cadastre-se para receber créditos gratuitos e comece a criar imagens de alta qualidade com o gerador de imagens Midjourney AI imediatamente. A geração de imagens utiliza os créditos correspondentes." },
                    { q: "Como uso o gerador de imagens Midjourney AI online?", a: "Insira um texto vívido descrevendo o assunto, o clima, a iluminação e o estilo, escolha Realista ou Anime no painel, opcionalmente carregue até cinco imagens de referência e clique em Gerar. O Midjourney funciona bem para arte conceitual, imagens-chave, pôsteres, retratos e ilustrações editoriais." },
                    { q: "Qual é a diferença entre os estilos Realista e Anime?", a: "O estilo Realista prioriza detalhes fotográficos, luz natural e texturas realistas, enquanto o estilo Anime favorece linhas estilizadas, cores vibrantes e um visual desenhado à mão. Você escolhe o estilo no painel, para que seu prompt possa se concentrar na cena em si." },
                    { q: "Como corrigir imagens do Midjourney que não correspondem à minha referência?", a: "Faça o upload de até cinco imagens de referência nítidas (PNG, JPG, JPEG ou WebP) e descreva qual paleta de cores, aparência do personagem, formato do produto ou estética geral o resultado deve seguir." },
                    { q: "Quais são os melhores exemplos de prompts para o Midjourney?", a: "As sugestões de meio de processo eficazes descrevem detalhadamente o tema, o cenário, o clima, a iluminação e o estilo artístico, e depois combinam essa sugestão com o estilo adequado no painel. Use os exemplos de sugestões de meio de processo nesta página como ponto de partida e adapte-os ao seu projeto." },
                    { q: "Midjourney vs Stable Diffusion 3.5: qual devo usar?", a: "Escolha com base no fluxo de trabalho, em vez de um vencedor universal. O Midjourney é uma ótima opção para conceitos com direção de arte, iluminação cinematográfica e visuais guiados por referências, com estilos Realista e Anime prontos para uso no Miral. O Stable Diffusion 3.5 pode ser adequado para criadores que precisam de instruções negativas explícitas e proporções flexíveis com tamanhos personalizados." }
                ],
                ctaTitle: "Experimente o Midjourney gratuitamente no Miral!",
                ctaDesc: "Insira sua ideia acima e use o gerador de imagens Midjourney AI com estilos Realista ou Anime e imagens de referência para criar visuais com direção de arte."
            }
        }
    }
}
